import { A as e } from "./validation-C1j4XYsm.js";
import { B as t, F as n, G as r, H as i, I as a, J as o, K as s, M as c, Q as l, R as u, S as d, U as f, V as p, ct as m, et as h, g, it as _, j as v, nt as y, q as b, s as x, t as S, tt as C, u as ee, w as te, z as ne } from "./dates-CZDXVurS.js";
import { P as re, Pattern as ie, match as w } from "ts-pattern";
import { isSequenceApiErrorResponse as ae, toCountryLabel as T, toStateLabel as oe } from "@sequencehq/api";
import { inflect as E } from "inflection";
import * as D from "react";
import se, { cloneElement as ce, createContext as le, forwardRef as ue, useCallback as O, useContext as k, useEffect as A, useId as de, useLayoutEffect as fe, useMemo as pe, useRef as j, useState as M } from "react";
import { Fragment as me, jsx as N, jsxs as he } from "react/jsx-runtime";
import ge from "tiny-invariant";
import P from "big.js";
import _e from "lodash/fp/omit";
import { dequal as F } from "dequal";
import ve from "lodash/fp/get";
import ye from "lodash/fp/set";
import be from "deepmerge";
import { Font as xe } from "@react-pdf/renderer";
import { omit as Se, pick as Ce, sortBy as we } from "lodash/fp";
//#region \0rolldown/runtime.js
var Te = Object.create, Ee = Object.defineProperty, De = Object.getOwnPropertyDescriptor, Oe = Object.getOwnPropertyNames, ke = Object.getPrototypeOf, Ae = Object.prototype.hasOwnProperty, je = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, Me = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Ne = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Oe(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Ae.call(e, s) && s !== n && Ee(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = De(t, s)) || r.enumerable
	});
	return e;
}, Pe = (e, t, n) => (n = e == null ? {} : Te(ke(e)), Ne(t || !e || !e.__esModule ? Ee(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Fe = (e) => e?.filter((e) => e?.id).reduce((e, t) => ({
	...e,
	[t.id]: t
}), {}) ?? {}, Ie = {
	ONE_TIME: {
		label: "One time",
		name: "one time",
		pluralName: "one time"
	},
	ON_DEMAND: {
		label: "On demand",
		name: "on demand",
		pluralName: "on demand"
	},
	PER_EVENT: {
		label: "Per event",
		name: "event",
		pluralName: "events"
	},
	MONTHLY: {
		label: "Monthly",
		name: "month",
		pluralName: "months"
	},
	QUARTERLY: {
		label: "Quarterly",
		name: "quarter",
		pluralName: "quarters"
	},
	HALF_YEARLY: {
		label: "Semi-annually",
		name: "semi-annual",
		pluralName: "semi-annual"
	},
	YEARLY: {
		label: "Annually",
		name: "year",
		pluralName: "years"
	},
	NONE: {
		label: "",
		name: "",
		pluralName: ""
	},
	NEVER: {
		label: "",
		name: "",
		pluralName: ""
	}
}, Le = (e, t = " - ") => e ? Ie[e]?.label : t, Re = (e, t) => Ie[e]?.name ?? t, ze = (e, t) => Ie[e]?.pluralName ?? t, Be = { ONE_TIME: "Once" }, Ve = [
	"MONTHLY",
	"QUARTERLY",
	"HALF_YEARLY",
	"YEARLY",
	"ON_DEMAND",
	"PER_EVENT",
	"ONE_TIME"
].map((e) => ({
	value: e,
	label: Be[e] ?? Ie[e].label
})), He = {
	IN_ARREARS: { label: "In arrears" },
	IN_ADVANCE: { label: "In advance" }
}, Ue = (e) => He[e].label, We = ["IN_ARREARS", "IN_ADVANCE"].map((e) => ({
	value: e,
	label: He[e].label
})), Ge = (e) => (t) => {
	let n = URL.createObjectURL(t), r = Object.assign(document.createElement("a"), {
		download: e,
		href: n
	});
	document.body.appendChild(r), r.click(), r.remove();
}, Ke = (e, t) => qe(e.headers.get("content-disposition")) ?? t, qe = (e) => {
	if (!e) return;
	let t = /filename\*=[^']*'[^']*'([^;]+)/i.exec(e)?.[1], n = /filename="([^"]*)"/i.exec(e)?.[1], r = /filename=([^;"]+)/i.exec(e)?.[1], i = t ? Je(t) : n ?? r;
	return i ? Ye(i.trim()) : void 0;
}, Je = (e) => {
	try {
		return decodeURIComponent(e);
	} catch {
		return;
	}
}, Ye = (e) => e.split(/[/\\]/).pop() || void 0, Xe = (e) => new Promise((t, n) => {
	let r = new FileReader();
	r.onload = (e) => {
		if (!e.target) return n("event.target is null");
		let r = e.target.result;
		return typeof r == "string" ? t(r) : n("dataUrl is not string");
	}, r.readAsDataURL(e);
}), Ze = (e, t) => {
	let n = Object.entries(t).reduce(({ config: t, missingEnvVars: n }, r) => {
		let i = r[0], a = r[1], o = e[a];
		return o ? {
			config: {
				...t,
				[i]: o
			},
			missingEnvVars: n
		} : {
			config: t,
			missingEnvVars: [...n, a]
		};
	}, {
		config: {},
		missingEnvVars: []
	});
	if (n.missingEnvVars.length) throw Error(`Missing environment variables: ${n.missingEnvVars.join(", ")}`);
	return n.config;
}, Qe = {
	dsn: "VITE_SENTRY_DSN",
	environment: "VITE_SENTRY_ENVIRONMENT"
}, $e = {
	dsn: "SENTRY_DSN",
	environment: "SENTRY_ENVIRONMENT"
}, et = (e) => Ze(e, Qe), tt = (e) => Ze(e, $e), nt = {
	client_id: "VITE_CLIENT_ID",
	redirect_uri: "VITE_REDIRECT_URI",
	authorization_endpoint: "VITE_AUTHORIZATION_ENDPOINT",
	token_endpoint: "VITE_TOKEN_ENDPOINT",
	requested_scopes: "VITE_REQUESTED_SCOPES",
	token_revoke_endpoint: "VITE_TOKEN_REVOKE_ENDPOINT",
	auth_url: "VITE_AUTH_URL"
}, rt = (e) => Ze(e, nt), it = { userInfoUrl: "USER_INFO_URL" }, at = (e) => Ze(e, it), ot = { sdkBasePath: "BASE_PATH" }, st = (e) => Ze(e, ot), ct = { dashboardUrl: "DASHBOARD_URL" }, lt = (e) => Ze(e, ct), ut = (e) => w(e).with("local", () => "https://local.seqhq.io:3002").with("dev", () => "https://portal.seqhq.io").with("demo", () => "https://portal.sequencehq.com").with("sandbox", () => "https://portal.sandbox.sequencehq.com").with("production", "stable", "test", () => "https://portal.sequencehq.com").exhaustive(), dt = (e) => w(e).with("local", "dev", "test", () => "no-reply@mail.seqhq.io").with("sandbox", "production", "demo", "stable", () => "notifications@mail.sequencehq.com").exhaustive(), ft = (e) => e.length > 0 ? e.join(",") : void 0, pt = (e) => e ? e.split(",").filter(Boolean) : [], mt = (e) => {
	let t = document.querySelector(`#menu-list-${e}`);
	if (!t) return;
	let n = t.parentElement;
	if (n) return n;
}, ht = (e, t) => {
	t?.classList.remove(`menu-list-fix-${e}`), document.querySelector(`#menu-list-fix-style-${e}`)?.remove();
}, gt = 8, _t = (e) => {
	let t = mt(e);
	if (!t) return;
	ht(e, t);
	let n = window.getComputedStyle(t).getPropertyValue("transform"), r = t.getBoundingClientRect(), i = document.documentElement.clientWidth, a = r.right - (i - gt), o = vt(n), s = o.translateX, { translateY: c } = o;
	if (a > 0) {
		s -= a;
		let e = r.left - a;
		e < gt && (s += gt - e);
	}
	let l = document.createElement("style");
	l.id = `menu-list-fix-style-${e}`;
	let u = `.menu-list-fix-${e} { transform: translate(${s}px, ${c}px) !important }`;
	l.appendChild(document.createTextNode(u)), document.head.appendChild(l), t.classList.add(`menu-list-fix-${e}`);
}, vt = (e) => {
	if (!e || e === "none") return {
		translateX: 0,
		translateY: 0
	};
	let t = e.match(/matrix.*\((.+)\)/)?.[1].split(",").map((e) => Number.parseFloat(e.trim()));
	return !t || t.length < 6 ? {
		translateX: 0,
		translateY: 0
	} : {
		translateX: t[4],
		translateY: t[5]
	};
}, yt = (e) => {
	setTimeout(() => {
		let t = mt(e);
		t && ht(e, t);
	}, 150);
};
//#endregion
//#region src/dom/positioning.ts
function bt(e) {
	if (!e) return null;
	let t = e.parentElement;
	for (; t && window.getComputedStyle(t).position === "static";) t = t.parentElement;
	let n = e.getBoundingClientRect(), r = t ? t.getBoundingClientRect() : {
		top: 0,
		left: 0
	};
	return {
		top: n.top - r.top,
		left: n.left - r.left
	};
}
//#endregion
//#region src/formatters/formatAddress.ts
var xt = (e, t = !0) => e ? [
	e.line1,
	e.line2,
	e.town,
	...e.state ? [oe(e.state)] : [],
	e.postcode,
	...t ? [T(e.country)] : []
].filter((e) => !!e) : [], St = new Intl.PluralRules("en-US", { type: "ordinal" }), Ct = /* @__PURE__ */ new Map([
	["one", "st"],
	["two", "nd"],
	["few", "rd"],
	["other", "th"]
]), wt = (e) => {
	let t = St.select(e);
	return `${e}${Ct.get(t)}`;
}, Tt = {
	IBAN: "IBAN",
	UK_BANK_ACCOUNT: "UK Account Details",
	US_ACH: "US ACH Details",
	US_WIRE: "US Wire Details",
	CA_BANK_ACCOUNT: "Canadian Account Details",
	CA_INTERNATIONAL: "Canadian International Details",
	AUSTRALIAN: "Australian Account Details",
	SWEDISH_BANKGIRO: "Swedish Bankgiro"
}, Et = (e) => Tt[e], Dt = ({ sortCode: e }) => [
	e.slice(0, 2),
	e.slice(2, 4),
	e.slice(4)
].join("-"), Ot = (e, t) => {
	if (!e) return "";
	let r = new Date(e);
	return r.toString() === "Invalid Date" ? "" : n(r, t);
}, kt = (e, t) => {
	if (!e) return "";
	let r = e.includes("T") ? e : `${e}T00:00:00.000Z`, i = new Date(Date.parse(r));
	return i.toString() === "Invalid Date" ? "" : n(i, t);
}, At = (e) => u(e, { representation: "date" }), jt = (e, t) => u(_(m(e, t))), Mt = (e, t) => u(v(d(e, t))), Nt = (t, r = "") => e(t) ? n(t, "yyyy-MM-dd") : r, Pt = ({ dateTarget: e, dateNow: t }) => {
	let n = t ? new Date(Date.parse(t)) : /* @__PURE__ */ new Date(), r = new Date(Date.parse(e));
	if (n.toString() === "Invalid Date" || r.toString() === "Invalid Date") return "";
	if (o(_(r), d(_(n), { days: 1 }))) return "tomorrow";
	if (o(_(r), _(n))) return "today";
	if (o(_(r), d(_(n), { days: -1 }))) return "yesterday";
	let i = n.getTime() > r.getTime(), s = i ? "" : "in ", c = i ? " ago" : "";
	return `${s}${a(v(r), v(n))}${c}`;
}, Ft = (e = "") => (t) => {
	if (typeof t != "string" && typeof t != "number") return "";
	let n = typeof t == "string" ? parseInt(t) : t;
	return isNaN(n) ? "" : `${e}${n.toLocaleString("en-US")}`;
}, It = ({ prefix: e = "", defaultNumber: t = "" } = {}) => (n) => {
	let r = `${e}${t}`;
	if (typeof n != "string") return r;
	let [i, a] = n.split("."), o = parseFloat(i);
	if (isNaN(o)) return r;
	let s = `${e}${o.toLocaleString("en-US")}`;
	return a === void 0 ? s : `${s}.${a}`;
}, Lt = (e, t = 0) => {
	if (e <= 0) return "0 Bytes";
	let n = 1e3, r = t < 0 ? 0 : t, i = [
		"Bytes",
		"KB",
		"MB",
		"GB"
	], a = Math.floor(Math.log(e) / Math.log(n));
	return `${parseFloat((e / n ** a).toFixed(r))} ${i[a]}`;
}, Rt = (e, t = 2) => {
	let n = parseFloat(e.toString()).toFixed(t);
	return parseFloat(n).toString();
}, zt = (e, t = "currency") => {
	if (!e || e.trim() === "" || isNaN(Number(e))) return e;
	let n = parseFloat(e);
	return isNaN(n) ? e : t === "percentage" ? e.startsWith(".") ? `0${e}` : e : e.startsWith(".") ? (e.split(".")[1]?.length || 0) < 2 ? n.toFixed(2) : `0${e}` : Number.isInteger(n) || (e.split(".")[1]?.length || 0) < 2 ? n.toFixed(2) : e;
};
//#endregion
//#region ../../node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
function Bt(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function Vt(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Ht = /*#__PURE__*/ function() {
	function e(e) {
		var t = this;
		this._insertTag = function(e) {
			var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
			t.container.insertBefore(e, n), t.tags.push(e);
		}, this.isSpeedy = e.speedy === void 0 ? process.env.NODE_ENV === "production" : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
	}
	var t = e.prototype;
	return t.hydrate = function(e) {
		e.forEach(this._insertTag);
	}, t.insert = function(e) {
		this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(Vt(this));
		var t = this.tags[this.tags.length - 1];
		if (process.env.NODE_ENV !== "production") {
			var n = e.charCodeAt(0) === 64 && e.charCodeAt(1) === 105;
			n && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n;
		}
		if (this.isSpeedy) {
			var r = Bt(t);
			try {
				r.insertRule(e, r.cssRules.length);
			} catch (t) {
				process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(e) && console.error("There was a problem inserting the following rule: \"" + e + "\"", t);
			}
		} else t.appendChild(document.createTextNode(e));
		this.ctr++;
	}, t.flush = function() {
		this.tags.forEach(function(e) {
			return e.parentNode && e.parentNode.removeChild(e);
		}), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
	}, e;
}(), I = "-ms-", Ut = "-moz-", L = "-webkit-", Wt = "comm", Gt = "rule", Kt = "decl", qt = "@import", Jt = "@keyframes", Yt = "@layer", Xt = Math.abs, Zt = String.fromCharCode, Qt = Object.assign;
function $t(e, t) {
	return z(e, 0) ^ 45 ? (((t << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3) : 0;
}
function en(e) {
	return e.trim();
}
function tn(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function R(e, t, n) {
	return e.replace(t, n);
}
function nn(e, t) {
	return e.indexOf(t);
}
function z(e, t) {
	return e.charCodeAt(t) | 0;
}
function rn(e, t, n) {
	return e.slice(t, n);
}
function an(e) {
	return e.length;
}
function on(e) {
	return e.length;
}
function sn(e, t) {
	return t.push(e), e;
}
function cn(e, t) {
	return e.map(t).join("");
}
//#endregion
//#region ../../node_modules/stylis/src/Tokenizer.js
var ln = 1, un = 1, dn = 0, B = 0, V = 0, fn = "";
function pn(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: ln,
		column: un,
		length: o,
		return: ""
	};
}
function mn(e, t) {
	return Qt(pn("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function hn() {
	return V;
}
function gn() {
	return V = B > 0 ? z(fn, --B) : 0, un--, V === 10 && (un = 1, ln--), V;
}
function H() {
	return V = B < dn ? z(fn, B++) : 0, un++, V === 10 && (un = 1, ln++), V;
}
function _n() {
	return z(fn, B);
}
function vn() {
	return B;
}
function yn(e, t) {
	return rn(fn, e, t);
}
function bn(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function xn(e) {
	return ln = un = 1, dn = an(fn = e), B = 0, [];
}
function Sn(e) {
	return fn = "", e;
}
function Cn(e) {
	return en(yn(B - 1, En(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function wn(e) {
	for (; (V = _n()) && V < 33;) H();
	return bn(e) > 2 || bn(V) > 3 ? "" : " ";
}
function Tn(e, t) {
	for (; --t && H() && !(V < 48 || V > 102 || V > 57 && V < 65 || V > 70 && V < 97););
	return yn(e, vn() + (t < 6 && _n() == 32 && H() == 32));
}
function En(e) {
	for (; H();) switch (V) {
		case e: return B;
		case 34:
		case 39:
			e !== 34 && e !== 39 && En(V);
			break;
		case 40:
			e === 41 && En(e);
			break;
		case 92:
			H();
			break;
	}
	return B;
}
function Dn(e, t) {
	for (; H() && e + V !== 57 && !(e + V === 84 && _n() === 47););
	return "/*" + yn(t, B - 1) + "*" + Zt(e === 47 ? e : H());
}
function On(e) {
	for (; !bn(_n());) H();
	return yn(e, B);
}
//#endregion
//#region ../../node_modules/stylis/src/Parser.js
function kn(e) {
	return Sn(An("", null, null, null, [""], e = xn(e), 0, [0], e));
}
function An(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, x = a, S = r, C = y; g;) switch (m = v, v = H()) {
		case 40: if (m != 108 && z(C, d - 1) == 58) {
			nn(C += R(Cn(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			C += Cn(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			C += wn(m);
			break;
		case 92:
			C += Tn(vn() - 1, 7);
			continue;
		case 47:
			switch (_n()) {
				case 42:
				case 47:
					sn(Mn(Dn(H(), vn()), t, n), c);
					break;
				default: C += "/";
			}
			break;
		case 123 * h: s[l++] = an(C) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (C = R(C, /\f/g, "")), p > 0 && an(C) - d && sn(p > 32 ? Nn(C + ";", r, n, d - 1) : Nn(R(C, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: C += ";";
				default: if (sn(S = jn(C, t, n, l, u, i, s, y, b = [], x = [], d), a), v === 123) if (u === 0) An(C, t, S, S, b, a, d, s, x);
				else switch (f === 99 && z(C, 3) === 110 ? 100 : f) {
					case 100:
					case 108:
					case 109:
					case 115:
						An(e, S, S, r && sn(jn(e, S, S, 0, 0, i, s, y, i, b = [], d), x), i, x, d, s, r ? b : x);
						break;
					default: An(C, S, S, S, [""], x, 0, s, x);
				}
			}
			l = u = p = 0, h = _ = 1, y = C = "", d = o;
			break;
		case 58: d = 1 + an(C), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && gn() == 125) continue;
			}
			switch (C += Zt(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (C += "\f", -1);
					break;
				case 44:
					s[l++] = (an(C) - 1) * _, _ = 1;
					break;
				case 64:
					_n() === 45 && (C += Cn(H())), f = _n(), u = d = an(y = C += On(vn())), v++;
					break;
				case 45: m === 45 && an(C) == 2 && (h = 0);
			}
	}
	return a;
}
function jn(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = on(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = rn(e, d + 1, d = Xt(h = o[m])), y = e; _ < p; ++_) (y = en(h > 0 ? f[_] + " " + v : R(v, /&\f/g, f[_]))) && (c[g++] = y);
	return pn(e, t, n, i === 0 ? Gt : s, c, l, u);
}
function Mn(e, t, n) {
	return pn(e, t, n, Wt, Zt(hn()), rn(e, 2, -2), 0);
}
function Nn(e, t, n, r) {
	return pn(e, t, n, Kt, rn(e, 0, r), rn(e, r + 1, -1), r);
}
//#endregion
//#region ../../node_modules/stylis/src/Serializer.js
function Pn(e, t) {
	for (var n = "", r = on(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function Fn(e, t, n, r) {
	switch (e.type) {
		case Yt: if (e.children.length) break;
		case qt:
		case Kt: return e.return = e.return || e.value;
		case Wt: return "";
		case Jt: return e.return = e.value + "{" + Pn(e.children, r) + "}";
		case Gt: e.value = e.props.join(",");
	}
	return an(n = Pn(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
//#endregion
//#region ../../node_modules/stylis/src/Middleware.js
function In(e) {
	var t = on(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function Ln(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
//#endregion
//#region ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function Rn(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
//#endregion
//#region ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var zn = function(e, t, n) {
	for (var r = 0, i = 0; r = i, i = _n(), r === 38 && i === 12 && (t[n] = 1), !bn(i);) H();
	return yn(e, B);
}, Bn = function(e, t) {
	var n = -1, r = 44;
	do
		switch (bn(r)) {
			case 0:
				r === 38 && _n() === 12 && (t[n] = 1), e[n] += zn(B - 1, t, n);
				break;
			case 2:
				e[n] += Cn(r);
				break;
			case 4: if (r === 44) {
				e[++n] = _n() === 58 ? "&\f" : "", t[n] = e[n].length;
				break;
			}
			default: e[n] += Zt(r);
		}
	while (r = H());
	return e;
}, Vn = function(e, t) {
	return Sn(Bn(xn(e), t));
}, Hn = /* #__PURE__ */ new WeakMap(), Un = function(e) {
	if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
		for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
		if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !Hn.get(n)) && !r) {
			Hn.set(e, !0);
			for (var i = [], a = Vn(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
		}
	}
}, Wn = function(e) {
	if (e.type === "decl") {
		var t = e.value;
		t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
	}
}, Gn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Kn = function(e) {
	return e.type === "comm" && e.children.indexOf(Gn) > -1;
}, qn = function(e) {
	return function(t, n, r) {
		if (!(t.type !== "rule" || e.compat)) {
			var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
			if (i) {
				for (var a = t.parent ? t.parent.children : r, o = a.length - 1; o >= 0; o--) {
					var s = a[o];
					if (s.line < t.line) break;
					if (s.column < t.column) {
						if (Kn(s)) return;
						break;
					}
				}
				i.forEach(function(e) {
					console.error("The pseudo class \"" + e + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + e.split("-child")[0] + "-of-type\".");
				});
			}
		}
	};
}, Jn = function(e) {
	return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, Yn = function(e, t) {
	for (var n = e - 1; n >= 0; n--) if (!Jn(t[n])) return !0;
	return !1;
}, Xn = function(e) {
	e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, Zn = function(e, t, n) {
	Jn(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Xn(e)) : Yn(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Xn(e)));
};
function Qn(e, t) {
	switch ($t(e, t)) {
		case 5103: return L + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return L + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return L + e + Ut + e + I + e + e;
		case 6828:
		case 4268: return L + e + I + e + e;
		case 6165: return L + e + I + "flex-" + e + e;
		case 5187: return L + e + R(e, /(\w+).+(:[^]+)/, L + "box-$1$2" + I + "flex-$1$2") + e;
		case 5443: return L + e + I + "flex-item-" + R(e, /flex-|-self/, "") + e;
		case 4675: return L + e + I + "flex-line-pack" + R(e, /align-content|flex-|-self/, "") + e;
		case 5548: return L + e + I + R(e, "shrink", "negative") + e;
		case 5292: return L + e + I + R(e, "basis", "preferred-size") + e;
		case 6060: return L + "box-" + R(e, "-grow", "") + L + e + I + R(e, "grow", "positive") + e;
		case 4554: return L + R(e, /([^-])(transform)/g, "$1" + L + "$2") + e;
		case 6187: return R(R(R(e, /(zoom-|grab)/, L + "$1"), /(image-set)/, L + "$1"), e, "") + e;
		case 5495:
		case 3959: return R(e, /(image-set\([^]*)/, L + "$1$`$1");
		case 4968: return R(R(e, /(.+:)(flex-)?(.*)/, L + "box-pack:$3" + I + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + L + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return R(e, /(.+)-inline(.+)/, L + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (an(e) - 1 - t > 6) switch (z(e, t + 1)) {
				case 109: if (z(e, t + 4) !== 45) break;
				case 102: return R(e, /(.+:)(.+)-([^]+)/, "$1" + L + "$2-$3$1" + Ut + (z(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~nn(e, "stretch") ? Qn(R(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (z(e, t + 1) !== 115) break;
		case 6444:
			switch (z(e, an(e) - 3 - (~nn(e, "!important") && 10))) {
				case 107: return R(e, ":", ":" + L) + e;
				case 101: return R(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + L + (z(e, 14) === 45 ? "inline-" : "") + "box$3$1" + L + "$2$3$1" + I + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (z(e, t + 11)) {
				case 114: return L + e + I + R(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return L + e + I + R(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return L + e + I + R(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return L + e + I + e + e;
	}
	return e;
}
var $n = [function(e, t, n, r) {
	if (e.length > -1 && !e.return) switch (e.type) {
		case Kt:
			e.return = Qn(e.value, e.length);
			break;
		case Jt: return Pn([mn(e, { value: R(e.value, "@", "@" + L) })], r);
		case Gt: if (e.length) return cn(e.props, function(t) {
			switch (tn(t, /(::plac\w+|:read-\w+)/)) {
				case ":read-only":
				case ":read-write": return Pn([mn(e, { props: [R(t, /:(read-\w+)/, ":" + Ut + "$1")] })], r);
				case "::placeholder": return Pn([
					mn(e, { props: [R(t, /:(plac\w+)/, ":" + L + "input-$1")] }),
					mn(e, { props: [R(t, /:(plac\w+)/, ":" + Ut + "$1")] }),
					mn(e, { props: [R(t, /:(plac\w+)/, I + "input-$1")] })
				], r);
			}
			return "";
		});
	}
}], er = function(e) {
	var t = e.key;
	if (process.env.NODE_ENV !== "production" && !t) throw Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
	if (t === "css") {
		var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
		Array.prototype.forEach.call(n, function(e) {
			e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
		});
	}
	var r = e.stylisPlugins || $n;
	if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t)) throw Error("Emotion key must only contain lower case alphabetical characters and - but \"" + t + "\" was passed");
	var i = {}, a, o = [];
	a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
		for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
		o.push(e);
	});
	var s, c = [Un, Wn];
	process.env.NODE_ENV !== "production" && c.push(qn({ get compat() {
		return p.compat;
	} }), Zn);
	var l, u = [Fn, process.env.NODE_ENV === "production" ? Ln(function(e) {
		l.insert(e);
	}) : function(e) {
		e.root || (e.return ? l.insert(e.return) : e.value && e.type !== "comm" && l.insert(e.value + "{}"));
	}], d = In(c.concat(r, u)), f = function(e) {
		return Pn(kn(e), d);
	};
	s = function(e, t, n, r) {
		l = n, process.env.NODE_ENV !== "production" && t.map !== void 0 && (l = { insert: function(e) {
			n.insert(e + t.map);
		} }), f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
	};
	var p = {
		key: t,
		sheet: new Ht({
			key: t,
			container: a,
			nonce: e.nonce,
			speedy: e.speedy,
			prepend: e.prepend,
			insertionPoint: e.insertionPoint
		}),
		nonce: e.nonce,
		inserted: i,
		registered: {},
		insert: s
	};
	return p.sheet.hydrate(o), p;
};
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/extends.js
function tr() {
	return tr = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, tr.apply(null, arguments);
}
//#endregion
//#region ../../node_modules/react-is/cjs/react-is.production.min.js
var nr = /* @__PURE__ */ Me(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), rr = /* @__PURE__ */ Me(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, ee = c, te = s, ne = n, re = d, ie = i, w = h, ae = m, T = r, oe = o, E = a, D = f, se = !1;
		function ce(e) {
			return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(e) || x(e) === l;
		}
		function le(e) {
			return x(e) === u;
		}
		function ue(e) {
			return x(e) === c;
		}
		function O(e) {
			return x(e) === s;
		}
		function k(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function A(e) {
			return x(e) === d;
		}
		function de(e) {
			return x(e) === i;
		}
		function fe(e) {
			return x(e) === h;
		}
		function pe(e) {
			return x(e) === m;
		}
		function j(e) {
			return x(e) === r;
		}
		function M(e) {
			return x(e) === o;
		}
		function me(e) {
			return x(e) === a;
		}
		function N(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = ee, e.ContextProvider = te, e.Element = ne, e.ForwardRef = re, e.Fragment = ie, e.Lazy = w, e.Memo = ae, e.Portal = T, e.Profiler = oe, e.StrictMode = E, e.Suspense = D, e.isAsyncMode = ce, e.isConcurrentMode = le, e.isContextConsumer = ue, e.isContextProvider = O, e.isElement = k, e.isForwardRef = A, e.isFragment = de, e.isLazy = fe, e.isMemo = pe, e.isPortal = j, e.isProfiler = M, e.isStrictMode = me, e.isSuspense = N, e.isValidElementType = b, e.typeOf = x;
	})();
})), ir = /* @__PURE__ */ Me(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = nr() : t.exports = rr();
})), ar = /* @__PURE__ */ Me(((e, t) => {
	var n = ir(), r = {
		childContextTypes: !0,
		contextType: !0,
		contextTypes: !0,
		defaultProps: !0,
		displayName: !0,
		getDefaultProps: !0,
		getDerivedStateFromError: !0,
		getDerivedStateFromProps: !0,
		mixins: !0,
		propTypes: !0,
		type: !0
	}, i = {
		name: !0,
		length: !0,
		prototype: !0,
		caller: !0,
		callee: !0,
		arguments: !0,
		arity: !0
	}, a = {
		$$typeof: !0,
		render: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0
	}, o = {
		$$typeof: !0,
		compare: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0,
		type: !0
	}, s = {};
	s[n.ForwardRef] = a, s[n.Memo] = o;
	function c(e) {
		return n.isMemo(e) ? o : s[e.$$typeof] || r;
	}
	var l = Object.defineProperty, u = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
	function h(e, t, n) {
		if (typeof t != "string") {
			if (m) {
				var r = p(t);
				r && r !== m && h(e, r, n);
			}
			var a = u(t);
			d && (a = a.concat(d(t)));
			for (var o = c(e), s = c(t), g = 0; g < a.length; ++g) {
				var _ = a[g];
				if (!i[_] && !(n && n[_]) && !(s && s[_]) && !(o && o[_])) {
					var v = f(t, _);
					try {
						l(e, _, v);
					} catch {}
				}
			}
		}
		return e;
	}
	t.exports = h;
}));
//#endregion
//#region ../../node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
function or(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? r += n + " " : t.push(e[n] + ";");
	}), r;
}
var sr = function(e, t, n) {
	var r = e.key + "-" + t.name;
	n === !1 && e.registered[r] === void 0 && (e.registered[r] = t.styles);
}, cr = function(e, t, n) {
	sr(e, t, n);
	var r = e.key + "-" + t.name;
	if (e.inserted[t.name] === void 0) {
		var i = t;
		do
			e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
		while (i !== void 0);
	}
};
//#endregion
//#region ../../node_modules/@emotion/hash/dist/emotion-hash.esm.js
function lr(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
//#endregion
//#region ../../node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var ur = {
	animationIterationCount: 1,
	aspectRatio: 1,
	borderImageOutset: 1,
	borderImageSlice: 1,
	borderImageWidth: 1,
	boxFlex: 1,
	boxFlexGroup: 1,
	boxOrdinalGroup: 1,
	columnCount: 1,
	columns: 1,
	flex: 1,
	flexGrow: 1,
	flexPositive: 1,
	flexShrink: 1,
	flexNegative: 1,
	flexOrder: 1,
	gridRow: 1,
	gridRowEnd: 1,
	gridRowSpan: 1,
	gridRowStart: 1,
	gridColumn: 1,
	gridColumnEnd: 1,
	gridColumnSpan: 1,
	gridColumnStart: 1,
	msGridRow: 1,
	msGridRowSpan: 1,
	msGridColumn: 1,
	msGridColumnSpan: 1,
	fontWeight: 1,
	lineHeight: 1,
	opacity: 1,
	order: 1,
	orphans: 1,
	tabSize: 1,
	widows: 1,
	zIndex: 1,
	zoom: 1,
	WebkitLineClamp: 1,
	fillOpacity: 1,
	floodOpacity: 1,
	stopOpacity: 1,
	strokeDasharray: 1,
	strokeDashoffset: 1,
	strokeMiterlimit: 1,
	strokeOpacity: 1,
	strokeWidth: 1
}, dr = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences", fr = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", pr = /[A-Z]|^ms/g, mr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, hr = function(e) {
	return e.charCodeAt(1) === 45;
}, gr = function(e) {
	return e != null && typeof e != "boolean";
}, _r = /* #__PURE__ */ Rn(function(e) {
	return hr(e) ? e : e.replace(pr, "-$&").toLowerCase();
}), vr = function(e, t) {
	switch (e) {
		case "animation":
		case "animationName": if (typeof t == "string") return t.replace(mr, function(e, t, n) {
			return Ar = {
				name: t,
				styles: n,
				next: Ar
			}, t;
		});
	}
	return ur[e] !== 1 && !hr(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
	var yr = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, br = [
		"normal",
		"none",
		"initial",
		"inherit",
		"unset"
	], xr = vr, Sr = /^-ms-/, Cr = /-(.)/g, wr = {};
	vr = function(e, t) {
		if (e === "content" && (typeof t != "string" || br.indexOf(t) === -1 && !yr.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== "\"" && t.charAt(0) !== "'"))) throw Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
		var n = xr(e, t);
		return n !== "" && !hr(e) && e.indexOf("-") !== -1 && wr[e] === void 0 && (wr[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(Sr, "ms-").replace(Cr, function(e, t) {
			return t.toUpperCase();
		}) + "?")), n;
	};
}
var Tr = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Er(e, t, n) {
	if (n == null) return "";
	if (n.__emotion_styles !== void 0) {
		if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR") throw Error(Tr);
		return n;
	}
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			if (n.anim === 1) return Ar = {
				name: n.name,
				styles: n.styles,
				next: Ar
			}, n.name;
			if (n.styles !== void 0) {
				var r = n.next;
				if (r !== void 0) for (; r !== void 0;) Ar = {
					name: r.name,
					styles: r.styles,
					next: Ar
				}, r = r.next;
				var i = n.styles + ";";
				return process.env.NODE_ENV !== "production" && n.map !== void 0 && (i += n.map), i;
			}
			return Dr(e, t, n);
		case "function":
			if (e !== void 0) {
				var a = Ar, o = n(e);
				return Ar = a, Er(e, t, o);
			} else process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
			break;
		case "string":
			if (process.env.NODE_ENV !== "production") {
				var s = [], c = n.replace(mr, function(e, t, n) {
					var r = "animation" + s.length;
					return s.push("const " + r + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
				});
				s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + c + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + c + "`"));
			}
			break;
	}
	if (t == null) return n;
	var l = t[n];
	return l === void 0 ? n : l;
}
function Dr(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += Er(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") t != null && t[o] !== void 0 ? r += a + "{" + t[o] + "}" : gr(o) && (r += _r(a) + ":" + vr(a, o) + ";");
		else {
			if (a === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production") throw Error(Tr);
			if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var s = 0; s < o.length; s++) gr(o[s]) && (r += _r(a) + ":" + vr(a, o[s]) + ";");
			else {
				var c = Er(e, t, o);
				switch (a) {
					case "animation":
					case "animationName":
						r += _r(a) + ":" + c + ";";
						break;
					default: process.env.NODE_ENV !== "production" && a === "undefined" && console.error(fr), r += a + "{" + c + "}";
				}
			}
		}
	}
	return r;
}
var Or = /label:\s*([^\s;\n{]+)\s*(;|$)/g, kr;
process.env.NODE_ENV !== "production" && (kr = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Ar, jr = function(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	Ar = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += Er(n, t, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(dr), i += a[0]);
	for (var o = 1; o < e.length; o++) i += Er(n, t, e[o]), r && (process.env.NODE_ENV !== "production" && a[o] === void 0 && console.error(dr), i += a[o]);
	var s;
	process.env.NODE_ENV !== "production" && (i = i.replace(kr, function(e) {
		return s = e, "";
	})), Or.lastIndex = 0;
	for (var c = "", l; (l = Or.exec(i)) !== null;) c += "-" + l[1];
	var u = lr(i) + c;
	return process.env.NODE_ENV === "production" ? {
		name: u,
		styles: i,
		next: Ar
	} : {
		name: u,
		styles: i,
		map: s,
		next: Ar,
		toString: function() {
			return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
		}
	};
}, Mr = function(e) {
	return e();
}, Nr = D.useInsertionEffect ? D.useInsertionEffect : !1, Pr = Nr || Mr, Fr = Nr || D.useLayoutEffect, Ir = {}.hasOwnProperty, Lr = /* #__PURE__ */ D.createContext(typeof HTMLElement < "u" ? /* #__PURE__ */ er({ key: "css" }) : null);
process.env.NODE_ENV !== "production" && (Lr.displayName = "EmotionCacheContext"), Lr.Provider;
var Rr = function(e) {
	return /*#__PURE__*/ ue(function(t, n) {
		return e(t, k(Lr), n);
	});
}, zr = /* #__PURE__ */ D.createContext({});
process.env.NODE_ENV !== "production" && (zr.displayName = "EmotionThemeContext");
var Br = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Vr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Hr = function(e) {
	var t = e.cache, n = e.serialized, r = e.isStringTag;
	return sr(t, n, r), Pr(function() {
		return cr(t, n, r);
	}), null;
}, Ur = /* #__PURE__ */ Rr(function(e, t, n) {
	var r = e.css;
	typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
	var i = e[Br], a = [r], o = "";
	typeof e.className == "string" ? o = or(t.registered, a, e.className) : e.className != null && (o = e.className + " ");
	var s = jr(a, void 0, D.useContext(zr));
	if (process.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
		var c = e[Vr];
		c && (s = jr([s, "label:" + c + ";"]));
	}
	o += t.key + "-" + s.name;
	var l = {};
	for (var u in e) Ir.call(e, u) && u !== "css" && u !== Br && (process.env.NODE_ENV === "production" || u !== Vr) && (l[u] = e[u]);
	return l.ref = n, l.className = o, /*#__PURE__*/ D.createElement(D.Fragment, null, /*#__PURE__*/ D.createElement(Hr, {
		cache: t,
		serialized: s,
		isStringTag: typeof i == "string"
	}), /*#__PURE__*/ D.createElement(i, l));
});
process.env.NODE_ENV !== "production" && (Ur.displayName = "EmotionCssPropInternal"), ar();
var Wr = {
	name: "@emotion/react",
	version: "11.11.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: { "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js" },
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				default: "./dist/emotion-react.esm.js"
			},
			import: "./dist/emotion-react.cjs.mjs",
			default: "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				import: "./macro.d.mts",
				default: "./macro.d.ts"
			},
			default: "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: !1,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: { "test:typescript": "dtslint types" },
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.2",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: { react: ">=16.8.0" },
	peerDependenciesMeta: { "@types/react": { optional: !0 } },
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.0",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: { access: "public" },
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: ["browser", "worker"],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						import: "./macro.d.mts",
						default: "./macro.d.ts"
					},
					default: "./macro.js"
				}
			}
		}
	}
}, Gr = !1, Kr = /* #__PURE__ */ Rr(function(e, t) {
	process.env.NODE_ENV !== "production" && !Gr && (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), Gr = !0);
	var n = e.styles, r = jr([n], void 0, D.useContext(zr)), i = D.useRef();
	return Fr(function() {
		var e = t.key + "-global", n = new t.sheet.constructor({
			key: e,
			nonce: t.sheet.nonce,
			container: t.sheet.container,
			speedy: t.sheet.isSpeedy
		}), a = !1, o = document.querySelector("style[data-emotion=\"" + e + " " + r.name + "\"]");
		return t.sheet.tags.length && (n.before = t.sheet.tags[0]), o !== null && (a = !0, o.setAttribute("data-emotion", e), n.hydrate([o])), i.current = [n, a], function() {
			n.flush();
		};
	}, [t]), Fr(function() {
		var e = i.current, n = e[0];
		if (e[1]) {
			e[1] = !1;
			return;
		}
		r.next !== void 0 && cr(t, r.next, !0), n.tags.length && (n.before = n.tags[n.tags.length - 1].nextElementSibling, n.flush()), t.insert("", r, n, !1);
	}, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (Kr.displayName = "EmotionGlobal");
function qr() {
	return jr([...arguments]);
}
var Jr = function() {
	var e = qr.apply(void 0, arguments), t = "animation-" + e.name;
	return {
		name: t,
		styles: "@keyframes " + t + "{" + e.styles + "}",
		anim: 1,
		toString: function() {
			return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
		}
	};
}, Yr = function e(t) {
	for (var n = t.length, r = 0, i = ""; r < n; r++) {
		var a = t[r];
		if (a != null) {
			var o = void 0;
			switch (typeof a) {
				case "boolean": break;
				case "object":
					if (Array.isArray(a)) o = e(a);
					else for (var s in process.env.NODE_ENV !== "production" && a.styles !== void 0 && a.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), o = "", a) a[s] && s && (o && (o += " "), o += s);
					break;
				default: o = a;
			}
			o && (i && (i += " "), i += o);
		}
	}
	return i;
};
function Xr(e, t, n) {
	var r = [], i = or(e, r, n);
	return r.length < 2 ? n : i + t(r);
}
var Zr = function(e) {
	var t = e.cache, n = e.serializedArr;
	return Pr(function() {
		for (var e = 0; e < n.length; e++) cr(t, n[e], !1);
	}), null;
}, Qr = /* #__PURE__ */ Rr(function(e, t) {
	var n = !1, r = [], i = function() {
		if (n && process.env.NODE_ENV !== "production") throw Error("css can only be used during render");
		var e = jr([...arguments], t.registered);
		return r.push(e), sr(t, e, !1), t.key + "-" + e.name;
	}, a = {
		css: i,
		cx: function() {
			if (n && process.env.NODE_ENV !== "production") throw Error("cx can only be used during render");
			var e = [...arguments];
			return Xr(t.registered, i, Yr(e));
		},
		theme: D.useContext(zr)
	}, o = e.children(a);
	return n = !0, /*#__PURE__*/ D.createElement(D.Fragment, null, /*#__PURE__*/ D.createElement(Zr, {
		cache: t,
		serializedArr: r
	}), o);
});
if (process.env.NODE_ENV !== "production" && (Qr.displayName = "EmotionClassNames"), process.env.NODE_ENV !== "production") {
	var $r = !0;
	if ($r && !(typeof jest < "u" || typeof vi < "u")) {
		var ei = typeof globalThis < "u" ? globalThis : $r ? window : global, ti = "__EMOTION_REACT_" + Wr.version.split(".")[0] + "__";
		ei[ti] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), ei[ti] = !0;
	}
}
//#endregion
//#region ../../node_modules/@chakra-ui/react-context/dist/index.mjs
function ni(e, t) {
	return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function ri(e = {}) {
	let { name: t, strict: n = !0, hookName: r = "useContext", providerName: i = "Provider", errorMessage: a, defaultValue: o } = e, s = le(o);
	s.displayName = t;
	function c() {
		var e;
		let t = k(s);
		if (!t && n) {
			let t = Error(a ?? ni(r, i));
			throw t.name = "ContextError", (e = Error.captureStackTrace) == null || e.call(Error, t, c), t;
		}
		return t;
	}
	return [
		s.Provider,
		c,
		s
	];
}
//#endregion
//#region ../../node_modules/@chakra-ui/react-use-safe-layout-effect/dist/index.mjs
var ii = globalThis != null && globalThis.document ? fe : A;
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-UIGT7YZF.mjs
function ai() {
	let e = k(zr);
	if (!e) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
	return e;
}
//#endregion
//#region ../../node_modules/@chakra-ui/color-mode/dist/chunk-UQDW7KKV.mjs
var oi = le({});
oi.displayName = "ColorModeContext";
function si() {
	let e = k(oi);
	if (e === void 0) throw Error("useColorMode must be used within a ColorModeProvider");
	return e;
}
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-7FWEOSAE.mjs
function ci() {
	let e = si(), t = ai();
	return {
		...e,
		theme: t
	};
}
//#endregion
//#region ../../node_modules/@chakra-ui/shared-utils/dist/index.mjs
var li = (...e) => e.filter(Boolean).join(" ");
function ui(e) {
	let t = typeof e;
	return e != null && (t === "object" || t === "function") && !Array.isArray(e);
}
function di(e, ...t) {
	return fi(e) ? e(...t) : e;
}
var fi = (e) => typeof e == "function", U = (e) => e ? "" : void 0;
function W(...e) {
	return function(t) {
		e.some((e) => (e?.(t), t?.defaultPrevented));
	};
}
function pi(...e) {
	return function(t) {
		e.forEach((e) => {
			e?.(t);
		});
	};
}
//#endregion
//#region ../../node_modules/@chakra-ui/styled-system/dist/index.mjs
var mi = /* @__PURE__ */ Pe((/* @__PURE__ */ Me(((e, t) => {
	var n = "__lodash_hash_undefined__", r = 9007199254740991, i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", c = "[object Error]", l = "[object Function]", u = "[object Map]", d = "[object Number]", f = "[object Object]", p = "[object RegExp]", m = "[object Set]", h = "[object String]", g = "[object WeakMap]", _ = "[object ArrayBuffer]", v = "[object DataView]", y = "[object Float32Array]", b = "[object Float64Array]", x = "[object Int8Array]", S = "[object Int16Array]", C = "[object Int32Array]", ee = "[object Uint8Array]", te = "[object Uint8ClampedArray]", ne = "[object Uint16Array]", re = "[object Uint32Array]", ie = /[\\^$.*+?()[\]{}|]/g, w = /^\[object .+?Constructor\]$/, ae = /^(?:0|[1-9]\d*)$/, T = {};
	T[y] = T[b] = T[x] = T[S] = T[C] = T[ee] = T[te] = T[ne] = T[re] = !0, T[i] = T[a] = T[_] = T[o] = T[v] = T[s] = T[c] = T[l] = T[u] = T[d] = T[f] = T[p] = T[m] = T[h] = T[g] = !1;
	var oe = typeof global == "object" && global && global.Object === Object && global, E = typeof self == "object" && self && self.Object === Object && self, D = oe || E || Function("return this")(), se = typeof e == "object" && e && !e.nodeType && e, ce = se && typeof t == "object" && t && !t.nodeType && t, le = ce && ce.exports === se, ue = le && oe.process, O = function() {
		try {
			return ce && ce.require && ce.require("util").types || ue && ue.binding && ue.binding("util");
		} catch {}
	}(), k = O && O.isTypedArray;
	function A(e, t, n) {
		switch (n.length) {
			case 0: return e.call(t);
			case 1: return e.call(t, n[0]);
			case 2: return e.call(t, n[0], n[1]);
			case 3: return e.call(t, n[0], n[1], n[2]);
		}
		return e.apply(t, n);
	}
	function de(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function fe(e) {
		return function(t) {
			return e(t);
		};
	}
	function pe(e, t) {
		return e?.[t];
	}
	function j(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	var M = Array.prototype, me = Function.prototype, N = Object.prototype, he = D["__core-js_shared__"], ge = me.toString, P = N.hasOwnProperty, _e = function() {
		var e = /[^.]+$/.exec(he && he.keys && he.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), F = N.toString, ve = ge.call(Object), ye = RegExp("^" + ge.call(P).replace(ie, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), be = le ? D.Buffer : void 0, xe = D.Symbol, Se = D.Uint8Array, Ce = be ? be.allocUnsafe : void 0, we = j(Object.getPrototypeOf, Object), Te = Object.create, Ee = N.propertyIsEnumerable, De = M.splice, Oe = xe ? xe.toStringTag : void 0, ke = function() {
		try {
			var e = kt(Object, "defineProperty");
			return e({}, "", {}), e;
		} catch {}
	}(), Ae = be ? be.isBuffer : void 0, je = Math.max, Me = Date.now, Ne = kt(D, "Map"), Pe = kt(Object, "create"), Fe = function() {
		function e() {}
		return function(t) {
			if (!Xt(t)) return {};
			if (Te) return Te(t);
			e.prototype = t;
			var n = new e();
			return e.prototype = void 0, n;
		};
	}();
	function Ie(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Le() {
		this.__data__ = Pe ? Pe(null) : {}, this.size = 0;
	}
	function Re(e) {
		var t = this.has(e) && delete this.__data__[e];
		return this.size -= +!!t, t;
	}
	function ze(e) {
		var t = this.__data__;
		if (Pe) {
			var r = t[e];
			return r === n ? void 0 : r;
		}
		return P.call(t, e) ? t[e] : void 0;
	}
	function Be(e) {
		var t = this.__data__;
		return Pe ? t[e] !== void 0 : P.call(t, e);
	}
	function Ve(e, t) {
		var r = this.__data__;
		return this.size += +!this.has(e), r[e] = Pe && t === void 0 ? n : t, this;
	}
	Ie.prototype.clear = Le, Ie.prototype.delete = Re, Ie.prototype.get = ze, Ie.prototype.has = Be, Ie.prototype.set = Ve;
	function He(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Ue() {
		this.__data__ = [], this.size = 0;
	}
	function We(e) {
		var t = this.__data__, n = lt(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : De.call(t, n, 1), --this.size, !0);
	}
	function Ge(e) {
		var t = this.__data__, n = lt(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function Ke(e) {
		return lt(this.__data__, e) > -1;
	}
	function qe(e, t) {
		var n = this.__data__, r = lt(n, e);
		return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
	}
	He.prototype.clear = Ue, He.prototype.delete = We, He.prototype.get = Ge, He.prototype.has = Ke, He.prototype.set = qe;
	function Je(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Ye() {
		this.size = 0, this.__data__ = {
			hash: new Ie(),
			map: new (Ne || He)(),
			string: new Ie()
		};
	}
	function Xe(e) {
		var t = Ot(this, e).delete(e);
		return this.size -= +!!t, t;
	}
	function Ze(e) {
		return Ot(this, e).get(e);
	}
	function Qe(e) {
		return Ot(this, e).has(e);
	}
	function $e(e, t) {
		var n = Ot(this, e), r = n.size;
		return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
	}
	Je.prototype.clear = Ye, Je.prototype.delete = Xe, Je.prototype.get = Ze, Je.prototype.has = Qe, Je.prototype.set = $e;
	function et(e) {
		var t = this.__data__ = new He(e);
		this.size = t.size;
	}
	function tt() {
		this.__data__ = new He(), this.size = 0;
	}
	function nt(e) {
		var t = this.__data__, n = t.delete(e);
		return this.size = t.size, n;
	}
	function rt(e) {
		return this.__data__.get(e);
	}
	function it(e) {
		return this.__data__.has(e);
	}
	function at(e, t) {
		var n = this.__data__;
		if (n instanceof He) {
			var r = n.__data__;
			if (!Ne || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
			n = this.__data__ = new Je(r);
		}
		return n.set(e, t), this.size = n.size, this;
	}
	et.prototype.clear = tt, et.prototype.delete = nt, et.prototype.get = rt, et.prototype.has = it, et.prototype.set = at;
	function ot(e, t) {
		var n = Wt(e), r = !n && L(e), i = !n && !r && qt(e), a = !n && !r && !i && $t(e), o = n || r || i || a, s = o ? de(e.length, String) : [], c = s.length;
		for (var l in e) (t || P.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Mt(l, c))) && s.push(l);
		return s;
	}
	function st(e, t, n) {
		(n !== void 0 && !Ut(e[t], n) || n === void 0 && !(t in e)) && ut(e, t, n);
	}
	function ct(e, t, n) {
		var r = e[t];
		(!(P.call(e, t) && Ut(r, n)) || n === void 0 && !(t in e)) && ut(e, t, n);
	}
	function lt(e, t) {
		for (var n = e.length; n--;) if (Ut(e[n][0], t)) return n;
		return -1;
	}
	function ut(e, t, n) {
		t == "__proto__" && ke ? ke(e, t, {
			configurable: !0,
			enumerable: !0,
			value: n,
			writable: !0
		}) : e[t] = n;
	}
	var dt = Dt();
	function ft(e) {
		return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Oe && Oe in Object(e) ? At(e) : Rt(e);
	}
	function pt(e) {
		return Zt(e) && ft(e) == i;
	}
	function mt(e) {
		return !Xt(e) || Ft(e) ? !1 : (Jt(e) ? ye : w).test(I(e));
	}
	function ht(e) {
		return Zt(e) && Yt(e.length) && !!T[ft(e)];
	}
	function gt(e) {
		if (!Xt(e)) return Lt(e);
		var t = It(e), n = [];
		for (var r in e) r == "constructor" && (t || !P.call(e, r)) || n.push(r);
		return n;
	}
	function _t(e, t, n, r, i) {
		e !== t && dt(t, function(a, o) {
			if (i ||= new et(), Xt(a)) vt(e, t, o, n, _t, r, i);
			else {
				var s = r ? r(Bt(e, o), a, o + "", e, t, i) : void 0;
				s === void 0 && (s = a), st(e, o, s);
			}
		}, tn);
	}
	function vt(e, t, n, r, i, a, o) {
		var s = Bt(e, n), c = Bt(t, n), l = o.get(c);
		if (l) {
			st(e, n, l);
			return;
		}
		var u = a ? a(s, c, n + "", e, t, o) : void 0, d = u === void 0;
		if (d) {
			var f = Wt(c), p = !f && qt(c), m = !f && !p && $t(c);
			u = c, f || p || m ? Wt(s) ? u = s : Kt(s) ? u = wt(s) : p ? (d = !1, u = xt(c, !0)) : m ? (d = !1, u = Ct(c, !0)) : u = [] : Qt(c) || L(c) ? (u = s, L(s) ? u = en(s) : (!Xt(s) || Jt(s)) && (u = jt(c))) : d = !1;
		}
		d && (o.set(c, u), i(u, c, r, a, o), o.delete(c)), st(e, n, u);
	}
	function yt(e, t) {
		return Vt(zt(e, t, z), e + "");
	}
	var bt = ke ? function(e, t) {
		return ke(e, "toString", {
			configurable: !0,
			enumerable: !1,
			value: nn(t),
			writable: !0
		});
	} : z;
	function xt(e, t) {
		if (t) return e.slice();
		var n = e.length, r = Ce ? Ce(n) : new e.constructor(n);
		return e.copy(r), r;
	}
	function St(e) {
		var t = new e.constructor(e.byteLength);
		return new Se(t).set(new Se(e)), t;
	}
	function Ct(e, t) {
		var n = t ? St(e.buffer) : e.buffer;
		return new e.constructor(n, e.byteOffset, e.length);
	}
	function wt(e, t) {
		var n = -1, r = e.length;
		for (t ||= Array(r); ++n < r;) t[n] = e[n];
		return t;
	}
	function Tt(e, t, n, r) {
		var i = !n;
		n ||= {};
		for (var a = -1, o = t.length; ++a < o;) {
			var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
			c === void 0 && (c = e[s]), i ? ut(n, s, c) : ct(n, s, c);
		}
		return n;
	}
	function Et(e) {
		return yt(function(t, n) {
			var r = -1, i = n.length, a = i > 1 ? n[i - 1] : void 0, o = i > 2 ? n[2] : void 0;
			for (a = e.length > 3 && typeof a == "function" ? (i--, a) : void 0, o && Nt(n[0], n[1], o) && (a = i < 3 ? void 0 : a, i = 1), t = Object(t); ++r < i;) {
				var s = n[r];
				s && e(t, s, r, a);
			}
			return t;
		});
	}
	function Dt(e) {
		return function(t, n, r) {
			for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
				var c = o[e ? s : ++i];
				if (n(a[c], c, a) === !1) break;
			}
			return t;
		};
	}
	function Ot(e, t) {
		var n = e.__data__;
		return Pt(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function kt(e, t) {
		var n = pe(e, t);
		return mt(n) ? n : void 0;
	}
	function At(e) {
		var t = P.call(e, Oe), n = e[Oe];
		try {
			e[Oe] = void 0;
			var r = !0;
		} catch {}
		var i = F.call(e);
		return r && (t ? e[Oe] = n : delete e[Oe]), i;
	}
	function jt(e) {
		return typeof e.constructor == "function" && !It(e) ? Fe(we(e)) : {};
	}
	function Mt(e, t) {
		var n = typeof e;
		return t ??= r, !!t && (n == "number" || n != "symbol" && ae.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function Nt(e, t, n) {
		if (!Xt(n)) return !1;
		var r = typeof t;
		return (r == "number" ? Gt(n) && Mt(t, n.length) : r == "string" && t in n) ? Ut(n[t], e) : !1;
	}
	function Pt(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function Ft(e) {
		return !!_e && _e in e;
	}
	function It(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || N);
	}
	function Lt(e) {
		var t = [];
		if (e != null) for (var n in Object(e)) t.push(n);
		return t;
	}
	function Rt(e) {
		return F.call(e);
	}
	function zt(e, t, n) {
		return t = je(t === void 0 ? e.length - 1 : t, 0), function() {
			for (var r = arguments, i = -1, a = je(r.length - t, 0), o = Array(a); ++i < a;) o[i] = r[t + i];
			i = -1;
			for (var s = Array(t + 1); ++i < t;) s[i] = r[i];
			return s[t] = n(o), A(e, this, s);
		};
	}
	function Bt(e, t) {
		if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__") return e[t];
	}
	var Vt = Ht(bt);
	function Ht(e) {
		var t = 0, n = 0;
		return function() {
			var r = Me(), i = 16 - (r - n);
			if (n = r, i > 0) {
				if (++t >= 800) return arguments[0];
			} else t = 0;
			return e.apply(void 0, arguments);
		};
	}
	function I(e) {
		if (e != null) {
			try {
				return ge.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function Ut(e, t) {
		return e === t || e !== e && t !== t;
	}
	var L = pt(function() {
		return arguments;
	}()) ? pt : function(e) {
		return Zt(e) && P.call(e, "callee") && !Ee.call(e, "callee");
	}, Wt = Array.isArray;
	function Gt(e) {
		return e != null && Yt(e.length) && !Jt(e);
	}
	function Kt(e) {
		return Zt(e) && Gt(e);
	}
	var qt = Ae || rn;
	function Jt(e) {
		if (!Xt(e)) return !1;
		var t = ft(e);
		return t == l || t == "[object GeneratorFunction]" || t == "[object AsyncFunction]" || t == "[object Proxy]";
	}
	function Yt(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= r;
	}
	function Xt(e) {
		var t = typeof e;
		return e != null && (t == "object" || t == "function");
	}
	function Zt(e) {
		return typeof e == "object" && !!e;
	}
	function Qt(e) {
		if (!Zt(e) || ft(e) != f) return !1;
		var t = we(e);
		if (t === null) return !0;
		var n = P.call(t, "constructor") && t.constructor;
		return typeof n == "function" && n instanceof n && ge.call(n) == ve;
	}
	var $t = k ? fe(k) : ht;
	function en(e) {
		return Tt(e, tn(e));
	}
	function tn(e) {
		return Gt(e) ? ot(e, !0) : gt(e);
	}
	var R = Et(function(e, t, n, r) {
		_t(e, t, n, r);
	});
	function nn(e) {
		return function() {
			return e;
		};
	}
	function z(e) {
		return e;
	}
	function rn() {
		return !1;
	}
	t.exports = R;
})))(), 1), hi = (e) => /!(important)?$/.test(e), gi = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, _i = (e, t) => (n) => {
	let r = String(t), i = hi(r), a = gi(r), o = e ? `${e}.${a}` : a, s = ui(n.__cssMap) && o in n.__cssMap ? n.__cssMap[o].varRef : t;
	return s = gi(s), i ? `${s} !important` : s;
};
function yi(e) {
	let { scale: t, transform: n, compose: r } = e;
	return (e, i) => {
		let a = _i(t, e)(i), o = n?.(a, i) ?? a;
		return r && (o = r(o, i)), o;
	};
}
var bi = (...e) => (t) => e.reduce((e, t) => t(e), t);
function xi(e, t) {
	return (n) => {
		let r = {
			property: n,
			scale: e
		};
		return r.transform = yi({
			scale: e,
			transform: t
		}), r;
	};
}
var Si = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function Ci(e) {
	let { property: t, scale: n, transform: r } = e;
	return {
		scale: n,
		property: Si(t),
		transform: n ? yi({
			scale: n,
			compose: r
		}) : r
	};
}
var wi = [
	"rotate(var(--chakra-rotate, 0))",
	"scaleX(var(--chakra-scale-x, 1))",
	"scaleY(var(--chakra-scale-y, 1))",
	"skewX(var(--chakra-skew-x, 0))",
	"skewY(var(--chakra-skew-y, 0))"
];
function Ti() {
	return [
		"translateX(var(--chakra-translate-x, 0))",
		"translateY(var(--chakra-translate-y, 0))",
		...wi
	].join(" ");
}
function Ei() {
	return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)", ...wi].join(" ");
}
var Di = {
	"--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
	filter: [
		"var(--chakra-blur)",
		"var(--chakra-brightness)",
		"var(--chakra-contrast)",
		"var(--chakra-grayscale)",
		"var(--chakra-hue-rotate)",
		"var(--chakra-invert)",
		"var(--chakra-saturate)",
		"var(--chakra-sepia)",
		"var(--chakra-drop-shadow)"
	].join(" ")
}, Oi = {
	backdropFilter: [
		"var(--chakra-backdrop-blur)",
		"var(--chakra-backdrop-brightness)",
		"var(--chakra-backdrop-contrast)",
		"var(--chakra-backdrop-grayscale)",
		"var(--chakra-backdrop-hue-rotate)",
		"var(--chakra-backdrop-invert)",
		"var(--chakra-backdrop-opacity)",
		"var(--chakra-backdrop-saturate)",
		"var(--chakra-backdrop-sepia)"
	].join(" "),
	"--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
	"--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function ki(e) {
	return {
		"--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
		"--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
		"--chakra-ring-width": e,
		boxShadow: [
			"var(--chakra-ring-offset-shadow)",
			"var(--chakra-ring-shadow)",
			"var(--chakra-shadow, 0 0 #0000)"
		].join(", ")
	};
}
var Ai = {
	"row-reverse": {
		space: "--chakra-space-x-reverse",
		divide: "--chakra-divide-x-reverse"
	},
	"column-reverse": {
		space: "--chakra-space-y-reverse",
		divide: "--chakra-divide-y-reverse"
	}
}, ji = {
	"to-t": "to top",
	"to-tr": "to top right",
	"to-r": "to right",
	"to-br": "to bottom right",
	"to-b": "to bottom",
	"to-bl": "to bottom left",
	"to-l": "to left",
	"to-tl": "to top left"
}, Mi = new Set(Object.values(ji)), Ni = /* @__PURE__ */ new Set([
	"none",
	"-moz-initial",
	"inherit",
	"initial",
	"revert",
	"unset"
]), Pi = (e) => e.trim();
function Fi(e, t) {
	if (e == null || Ni.has(e)) return e;
	if (!(Ii(e) || Ni.has(e))) return `url('${e}')`;
	let n = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), r = n?.[1], i = n?.[2];
	if (!r || !i) return e;
	let a = r.includes("-gradient") ? r : `${r}-gradient`, [o, ...s] = i.split(",").map(Pi).filter(Boolean);
	if (s?.length === 0) return e;
	let c = o in ji ? ji[o] : o;
	return s.unshift(c), `${a}(${s.map((e) => {
		if (Mi.has(e)) return e;
		let n = e.indexOf(" "), [r, i] = n === -1 ? [e] : [e.substr(0, n), e.substr(n + 1)], a = Ii(i) ? i : i && i.split(" "), o = `colors.${r}`, s = o in t.__cssMap ? t.__cssMap[o].varRef : r;
		return a ? [s, ...Array.isArray(a) ? a : [a]].join(" ") : s;
	}).join(", ")})`;
}
var Ii = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), Li = (e, t) => Fi(e, t ?? {});
function Ri(e) {
	return /^var\(--.+\)$/.test(e);
}
var zi = (e) => {
	let t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
	return {
		unitless: !n,
		value: t,
		unit: n
	};
}, Bi = (e) => (t) => `${e}(${t})`, G = {
	filter(e) {
		return e === "auto" ? Di : e;
	},
	backdropFilter(e) {
		return e === "auto" ? Oi : e;
	},
	ring(e) {
		return ki(G.px(e));
	},
	bgClip(e) {
		return e === "text" ? {
			color: "transparent",
			backgroundClip: "text"
		} : { backgroundClip: e };
	},
	transform(e) {
		return e === "auto" ? Ti() : e === "auto-gpu" ? Ei() : e;
	},
	vh(e) {
		return e === "$100vh" ? "var(--chakra-vh)" : e;
	},
	px(e) {
		if (e == null) return e;
		let { unitless: t } = zi(e);
		return t || typeof e == "number" ? `${e}px` : e;
	},
	fraction(e) {
		return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
	},
	float(e, t) {
		return t.direction === "rtl" ? {
			left: "right",
			right: "left"
		}[e] : e;
	},
	degree(e) {
		if (Ri(e) || e == null) return e;
		let t = typeof e == "string" && !e.endsWith("deg");
		return typeof e == "number" || t ? `${e}deg` : e;
	},
	gradient: Li,
	blur: Bi("blur"),
	opacity: Bi("opacity"),
	brightness: Bi("brightness"),
	contrast: Bi("contrast"),
	dropShadow: Bi("drop-shadow"),
	grayscale: Bi("grayscale"),
	hueRotate: Bi("hue-rotate"),
	invert: Bi("invert"),
	saturate: Bi("saturate"),
	sepia: Bi("sepia"),
	bgImage(e) {
		return e == null || Ii(e) || Ni.has(e) ? e : `url(${e})`;
	},
	outline(e) {
		return e !== null && (String(e) === "0" || String(e) === "none") ? {
			outline: "2px solid transparent",
			outlineOffset: "2px"
		} : { outline: e };
	},
	flexDirection(e) {
		let { space: t, divide: n } = Ai[e] ?? {}, r = { flexDirection: e };
		return t && (r[t] = 1), n && (r[n] = 1), r;
	}
}, K = {
	borderWidths: xi("borderWidths"),
	borderStyles: xi("borderStyles"),
	colors: xi("colors"),
	borders: xi("borders"),
	gradients: xi("gradients", G.gradient),
	radii: xi("radii", G.px),
	space: xi("space", bi(G.vh, G.px)),
	spaceT: xi("space", bi(G.vh, G.px)),
	degreeT(e) {
		return {
			property: e,
			transform: G.degree
		};
	},
	prop(e, t, n) {
		return {
			property: e,
			scale: t,
			...t && { transform: yi({
				scale: t,
				transform: n
			}) }
		};
	},
	propT(e, t) {
		return {
			property: e,
			transform: t
		};
	},
	sizes: xi("sizes", bi(G.vh, G.px)),
	sizesT: xi("sizes", bi(G.vh, G.fraction)),
	shadows: xi("shadows"),
	logical: Ci,
	blur: xi("blur", G.blur)
}, Vi = {
	background: K.colors("background"),
	backgroundColor: K.colors("backgroundColor"),
	backgroundImage: K.gradients("backgroundImage"),
	backgroundSize: !0,
	backgroundPosition: !0,
	backgroundRepeat: !0,
	backgroundAttachment: !0,
	backgroundClip: { transform: G.bgClip },
	bgSize: K.prop("backgroundSize"),
	bgPosition: K.prop("backgroundPosition"),
	bg: K.colors("background"),
	bgColor: K.colors("backgroundColor"),
	bgPos: K.prop("backgroundPosition"),
	bgRepeat: K.prop("backgroundRepeat"),
	bgAttachment: K.prop("backgroundAttachment"),
	bgGradient: K.gradients("backgroundImage"),
	bgClip: { transform: G.bgClip }
};
Object.assign(Vi, {
	bgImage: Vi.backgroundImage,
	bgImg: Vi.backgroundImage
});
var q = {
	border: K.borders("border"),
	borderWidth: K.borderWidths("borderWidth"),
	borderStyle: K.borderStyles("borderStyle"),
	borderColor: K.colors("borderColor"),
	borderRadius: K.radii("borderRadius"),
	borderTop: K.borders("borderTop"),
	borderBlockStart: K.borders("borderBlockStart"),
	borderTopLeftRadius: K.radii("borderTopLeftRadius"),
	borderStartStartRadius: K.logical({
		scale: "radii",
		property: {
			ltr: "borderTopLeftRadius",
			rtl: "borderTopRightRadius"
		}
	}),
	borderEndStartRadius: K.logical({
		scale: "radii",
		property: {
			ltr: "borderBottomLeftRadius",
			rtl: "borderBottomRightRadius"
		}
	}),
	borderTopRightRadius: K.radii("borderTopRightRadius"),
	borderStartEndRadius: K.logical({
		scale: "radii",
		property: {
			ltr: "borderTopRightRadius",
			rtl: "borderTopLeftRadius"
		}
	}),
	borderEndEndRadius: K.logical({
		scale: "radii",
		property: {
			ltr: "borderBottomRightRadius",
			rtl: "borderBottomLeftRadius"
		}
	}),
	borderRight: K.borders("borderRight"),
	borderInlineEnd: K.borders("borderInlineEnd"),
	borderBottom: K.borders("borderBottom"),
	borderBlockEnd: K.borders("borderBlockEnd"),
	borderBottomLeftRadius: K.radii("borderBottomLeftRadius"),
	borderBottomRightRadius: K.radii("borderBottomRightRadius"),
	borderLeft: K.borders("borderLeft"),
	borderInlineStart: {
		property: "borderInlineStart",
		scale: "borders"
	},
	borderInlineStartRadius: K.logical({
		scale: "radii",
		property: {
			ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
			rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
		}
	}),
	borderInlineEndRadius: K.logical({
		scale: "radii",
		property: {
			ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
			rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
		}
	}),
	borderX: K.borders(["borderLeft", "borderRight"]),
	borderInline: K.borders("borderInline"),
	borderY: K.borders(["borderTop", "borderBottom"]),
	borderBlock: K.borders("borderBlock"),
	borderTopWidth: K.borderWidths("borderTopWidth"),
	borderBlockStartWidth: K.borderWidths("borderBlockStartWidth"),
	borderTopColor: K.colors("borderTopColor"),
	borderBlockStartColor: K.colors("borderBlockStartColor"),
	borderTopStyle: K.borderStyles("borderTopStyle"),
	borderBlockStartStyle: K.borderStyles("borderBlockStartStyle"),
	borderBottomWidth: K.borderWidths("borderBottomWidth"),
	borderBlockEndWidth: K.borderWidths("borderBlockEndWidth"),
	borderBottomColor: K.colors("borderBottomColor"),
	borderBlockEndColor: K.colors("borderBlockEndColor"),
	borderBottomStyle: K.borderStyles("borderBottomStyle"),
	borderBlockEndStyle: K.borderStyles("borderBlockEndStyle"),
	borderLeftWidth: K.borderWidths("borderLeftWidth"),
	borderInlineStartWidth: K.borderWidths("borderInlineStartWidth"),
	borderLeftColor: K.colors("borderLeftColor"),
	borderInlineStartColor: K.colors("borderInlineStartColor"),
	borderLeftStyle: K.borderStyles("borderLeftStyle"),
	borderInlineStartStyle: K.borderStyles("borderInlineStartStyle"),
	borderRightWidth: K.borderWidths("borderRightWidth"),
	borderInlineEndWidth: K.borderWidths("borderInlineEndWidth"),
	borderRightColor: K.colors("borderRightColor"),
	borderInlineEndColor: K.colors("borderInlineEndColor"),
	borderRightStyle: K.borderStyles("borderRightStyle"),
	borderInlineEndStyle: K.borderStyles("borderInlineEndStyle"),
	borderTopRadius: K.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
	borderBottomRadius: K.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
	borderLeftRadius: K.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
	borderRightRadius: K.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(q, {
	rounded: q.borderRadius,
	roundedTop: q.borderTopRadius,
	roundedTopLeft: q.borderTopLeftRadius,
	roundedTopRight: q.borderTopRightRadius,
	roundedTopStart: q.borderStartStartRadius,
	roundedTopEnd: q.borderStartEndRadius,
	roundedBottom: q.borderBottomRadius,
	roundedBottomLeft: q.borderBottomLeftRadius,
	roundedBottomRight: q.borderBottomRightRadius,
	roundedBottomStart: q.borderEndStartRadius,
	roundedBottomEnd: q.borderEndEndRadius,
	roundedLeft: q.borderLeftRadius,
	roundedRight: q.borderRightRadius,
	roundedStart: q.borderInlineStartRadius,
	roundedEnd: q.borderInlineEndRadius,
	borderStart: q.borderInlineStart,
	borderEnd: q.borderInlineEnd,
	borderTopStartRadius: q.borderStartStartRadius,
	borderTopEndRadius: q.borderStartEndRadius,
	borderBottomStartRadius: q.borderEndStartRadius,
	borderBottomEndRadius: q.borderEndEndRadius,
	borderStartRadius: q.borderInlineStartRadius,
	borderEndRadius: q.borderInlineEndRadius,
	borderStartWidth: q.borderInlineStartWidth,
	borderEndWidth: q.borderInlineEndWidth,
	borderStartColor: q.borderInlineStartColor,
	borderEndColor: q.borderInlineEndColor,
	borderStartStyle: q.borderInlineStartStyle,
	borderEndStyle: q.borderInlineEndStyle
});
var Hi = {
	color: K.colors("color"),
	textColor: K.colors("color"),
	fill: K.colors("fill"),
	stroke: K.colors("stroke")
}, Ui = {
	boxShadow: K.shadows("boxShadow"),
	mixBlendMode: !0,
	blendMode: K.prop("mixBlendMode"),
	backgroundBlendMode: !0,
	bgBlendMode: K.prop("backgroundBlendMode"),
	opacity: !0
};
Object.assign(Ui, { shadow: Ui.boxShadow });
var Wi = {
	filter: { transform: G.filter },
	blur: K.blur("--chakra-blur"),
	brightness: K.propT("--chakra-brightness", G.brightness),
	contrast: K.propT("--chakra-contrast", G.contrast),
	hueRotate: K.degreeT("--chakra-hue-rotate"),
	invert: K.propT("--chakra-invert", G.invert),
	saturate: K.propT("--chakra-saturate", G.saturate),
	dropShadow: K.propT("--chakra-drop-shadow", G.dropShadow),
	backdropFilter: { transform: G.backdropFilter },
	backdropBlur: K.blur("--chakra-backdrop-blur"),
	backdropBrightness: K.propT("--chakra-backdrop-brightness", G.brightness),
	backdropContrast: K.propT("--chakra-backdrop-contrast", G.contrast),
	backdropHueRotate: K.degreeT("--chakra-backdrop-hue-rotate"),
	backdropInvert: K.propT("--chakra-backdrop-invert", G.invert),
	backdropSaturate: K.propT("--chakra-backdrop-saturate", G.saturate)
}, Gi = {
	alignItems: !0,
	alignContent: !0,
	justifyItems: !0,
	justifyContent: !0,
	flexWrap: !0,
	flexDirection: { transform: G.flexDirection },
	flex: !0,
	flexFlow: !0,
	flexGrow: !0,
	flexShrink: !0,
	flexBasis: K.sizes("flexBasis"),
	justifySelf: !0,
	alignSelf: !0,
	order: !0,
	placeItems: !0,
	placeContent: !0,
	placeSelf: !0,
	gap: K.space("gap"),
	rowGap: K.space("rowGap"),
	columnGap: K.space("columnGap")
};
Object.assign(Gi, { flexDir: Gi.flexDirection });
var Ki = {
	gridGap: K.space("gridGap"),
	gridColumnGap: K.space("gridColumnGap"),
	gridRowGap: K.space("gridRowGap"),
	gridColumn: !0,
	gridRow: !0,
	gridAutoFlow: !0,
	gridAutoColumns: !0,
	gridColumnStart: !0,
	gridColumnEnd: !0,
	gridRowStart: !0,
	gridRowEnd: !0,
	gridAutoRows: !0,
	gridTemplate: !0,
	gridTemplateColumns: !0,
	gridTemplateRows: !0,
	gridTemplateAreas: !0,
	gridArea: !0
}, qi = {
	appearance: !0,
	cursor: !0,
	resize: !0,
	userSelect: !0,
	pointerEvents: !0,
	outline: { transform: G.outline },
	outlineOffset: !0,
	outlineColor: K.colors("outlineColor")
}, Ji = {
	width: K.sizesT("width"),
	inlineSize: K.sizesT("inlineSize"),
	height: K.sizes("height"),
	blockSize: K.sizes("blockSize"),
	boxSize: K.sizes(["width", "height"]),
	minWidth: K.sizes("minWidth"),
	minInlineSize: K.sizes("minInlineSize"),
	minHeight: K.sizes("minHeight"),
	minBlockSize: K.sizes("minBlockSize"),
	maxWidth: K.sizes("maxWidth"),
	maxInlineSize: K.sizes("maxInlineSize"),
	maxHeight: K.sizes("maxHeight"),
	maxBlockSize: K.sizes("maxBlockSize"),
	overflow: !0,
	overflowX: !0,
	overflowY: !0,
	overscrollBehavior: !0,
	overscrollBehaviorX: !0,
	overscrollBehaviorY: !0,
	display: !0,
	aspectRatio: !0,
	hideFrom: {
		scale: "breakpoints",
		transform: (e, t) => ({ [`@media screen and (min-width: ${t.__breakpoints?.get(e)?.minW ?? e})`]: { display: "none" } })
	},
	hideBelow: {
		scale: "breakpoints",
		transform: (e, t) => ({ [`@media screen and (max-width: ${t.__breakpoints?.get(e)?._minW ?? e})`]: { display: "none" } })
	},
	verticalAlign: !0,
	boxSizing: !0,
	boxDecorationBreak: !0,
	float: K.propT("float", G.float),
	objectFit: !0,
	objectPosition: !0,
	visibility: !0,
	isolation: !0
};
Object.assign(Ji, {
	w: Ji.width,
	h: Ji.height,
	minW: Ji.minWidth,
	maxW: Ji.maxWidth,
	minH: Ji.minHeight,
	maxH: Ji.maxHeight,
	overscroll: Ji.overscrollBehavior,
	overscrollX: Ji.overscrollBehaviorX,
	overscrollY: Ji.overscrollBehaviorY
});
var Yi = {
	listStyleType: !0,
	listStylePosition: !0,
	listStylePos: K.prop("listStylePosition"),
	listStyleImage: !0,
	listStyleImg: K.prop("listStyleImage")
};
function Xi(e, t, n, r) {
	let i = typeof t == "string" ? t.split(".") : [t];
	for (r = 0; r < i.length && e; r += 1) e = e[i[r]];
	return e === void 0 ? n : e;
}
var Zi = ((e) => {
	let t = /* @__PURE__ */ new WeakMap();
	return (n, r, i, a) => {
		if (n === void 0) return e(n, r, i);
		t.has(n) || t.set(n, /* @__PURE__ */ new Map());
		let o = t.get(n);
		if (o.has(r)) return o.get(r);
		let s = e(n, r, i, a);
		return o.set(r, s), s;
	};
})(Xi), Qi = {
	border: "0px",
	clip: "rect(0, 0, 0, 0)",
	width: "1px",
	height: "1px",
	margin: "-1px",
	padding: "0px",
	overflow: "hidden",
	whiteSpace: "nowrap",
	position: "absolute"
}, $i = {
	position: "static",
	width: "auto",
	height: "auto",
	clip: "auto",
	padding: "0",
	margin: "0",
	overflow: "visible",
	whiteSpace: "normal"
}, ea = (e, t, n) => {
	let r = {}, i = Zi(e, t, {});
	for (let e in i) e in n && n[e] != null || (r[e] = i[e]);
	return r;
}, ta = {
	srOnly: { transform(e) {
		return e === !0 ? Qi : e === "focusable" ? $i : {};
	} },
	layerStyle: {
		processResult: !0,
		transform: (e, t, n) => ea(t, `layerStyles.${e}`, n)
	},
	textStyle: {
		processResult: !0,
		transform: (e, t, n) => ea(t, `textStyles.${e}`, n)
	},
	apply: {
		processResult: !0,
		transform: (e, t, n) => ea(t, e, n)
	}
}, na = {
	position: !0,
	pos: K.prop("position"),
	zIndex: K.prop("zIndex", "zIndices"),
	inset: K.spaceT("inset"),
	insetX: K.spaceT(["left", "right"]),
	insetInline: K.spaceT("insetInline"),
	insetY: K.spaceT(["top", "bottom"]),
	insetBlock: K.spaceT("insetBlock"),
	top: K.spaceT("top"),
	insetBlockStart: K.spaceT("insetBlockStart"),
	bottom: K.spaceT("bottom"),
	insetBlockEnd: K.spaceT("insetBlockEnd"),
	left: K.spaceT("left"),
	insetInlineStart: K.logical({
		scale: "space",
		property: {
			ltr: "left",
			rtl: "right"
		}
	}),
	right: K.spaceT("right"),
	insetInlineEnd: K.logical({
		scale: "space",
		property: {
			ltr: "right",
			rtl: "left"
		}
	})
};
Object.assign(na, {
	insetStart: na.insetInlineStart,
	insetEnd: na.insetInlineEnd
});
var ra = {
	ring: { transform: G.ring },
	ringColor: K.colors("--chakra-ring-color"),
	ringOffset: K.prop("--chakra-ring-offset-width"),
	ringOffsetColor: K.colors("--chakra-ring-offset-color"),
	ringInset: K.prop("--chakra-ring-inset")
}, J = {
	margin: K.spaceT("margin"),
	marginTop: K.spaceT("marginTop"),
	marginBlockStart: K.spaceT("marginBlockStart"),
	marginRight: K.spaceT("marginRight"),
	marginInlineEnd: K.spaceT("marginInlineEnd"),
	marginBottom: K.spaceT("marginBottom"),
	marginBlockEnd: K.spaceT("marginBlockEnd"),
	marginLeft: K.spaceT("marginLeft"),
	marginInlineStart: K.spaceT("marginInlineStart"),
	marginX: K.spaceT(["marginInlineStart", "marginInlineEnd"]),
	marginInline: K.spaceT("marginInline"),
	marginY: K.spaceT(["marginTop", "marginBottom"]),
	marginBlock: K.spaceT("marginBlock"),
	padding: K.space("padding"),
	paddingTop: K.space("paddingTop"),
	paddingBlockStart: K.space("paddingBlockStart"),
	paddingRight: K.space("paddingRight"),
	paddingBottom: K.space("paddingBottom"),
	paddingBlockEnd: K.space("paddingBlockEnd"),
	paddingLeft: K.space("paddingLeft"),
	paddingInlineStart: K.space("paddingInlineStart"),
	paddingInlineEnd: K.space("paddingInlineEnd"),
	paddingX: K.space(["paddingInlineStart", "paddingInlineEnd"]),
	paddingInline: K.space("paddingInline"),
	paddingY: K.space(["paddingTop", "paddingBottom"]),
	paddingBlock: K.space("paddingBlock")
};
Object.assign(J, {
	m: J.margin,
	mt: J.marginTop,
	mr: J.marginRight,
	me: J.marginInlineEnd,
	marginEnd: J.marginInlineEnd,
	mb: J.marginBottom,
	ml: J.marginLeft,
	ms: J.marginInlineStart,
	marginStart: J.marginInlineStart,
	mx: J.marginX,
	my: J.marginY,
	p: J.padding,
	pt: J.paddingTop,
	py: J.paddingY,
	px: J.paddingX,
	pb: J.paddingBottom,
	pl: J.paddingLeft,
	ps: J.paddingInlineStart,
	paddingStart: J.paddingInlineStart,
	pr: J.paddingRight,
	pe: J.paddingInlineEnd,
	paddingEnd: J.paddingInlineEnd
});
var ia = {
	textDecorationColor: K.colors("textDecorationColor"),
	textDecoration: !0,
	textDecor: { property: "textDecoration" },
	textDecorationLine: !0,
	textDecorationStyle: !0,
	textDecorationThickness: !0,
	textUnderlineOffset: !0,
	textShadow: K.shadows("textShadow")
}, aa = {
	clipPath: !0,
	transform: K.propT("transform", G.transform),
	transformOrigin: !0,
	translateX: K.spaceT("--chakra-translate-x"),
	translateY: K.spaceT("--chakra-translate-y"),
	skewX: K.degreeT("--chakra-skew-x"),
	skewY: K.degreeT("--chakra-skew-y"),
	scaleX: K.prop("--chakra-scale-x"),
	scaleY: K.prop("--chakra-scale-y"),
	scale: K.prop(["--chakra-scale-x", "--chakra-scale-y"]),
	rotate: K.degreeT("--chakra-rotate")
}, oa = {
	transition: !0,
	transitionDelay: !0,
	animation: !0,
	willChange: !0,
	transitionDuration: K.prop("transitionDuration", "transition.duration"),
	transitionProperty: K.prop("transitionProperty", "transition.property"),
	transitionTimingFunction: K.prop("transitionTimingFunction", "transition.easing")
}, sa = {
	fontFamily: K.prop("fontFamily", "fonts"),
	fontSize: K.prop("fontSize", "fontSizes", G.px),
	fontWeight: K.prop("fontWeight", "fontWeights"),
	lineHeight: K.prop("lineHeight", "lineHeights"),
	letterSpacing: K.prop("letterSpacing", "letterSpacings"),
	textAlign: !0,
	fontStyle: !0,
	textIndent: !0,
	wordBreak: !0,
	overflowWrap: !0,
	textOverflow: !0,
	textTransform: !0,
	whiteSpace: !0,
	isTruncated: { transform(e) {
		if (e === !0) return {
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap"
		};
	} },
	noOfLines: {
		static: {
			overflow: "hidden",
			textOverflow: "ellipsis",
			display: "-webkit-box",
			WebkitBoxOrient: "vertical",
			WebkitLineClamp: "var(--chakra-line-clamp)"
		},
		property: "--chakra-line-clamp"
	}
}, ca = {
	scrollBehavior: !0,
	scrollSnapAlign: !0,
	scrollSnapStop: !0,
	scrollSnapType: !0,
	scrollMargin: K.spaceT("scrollMargin"),
	scrollMarginTop: K.spaceT("scrollMarginTop"),
	scrollMarginBottom: K.spaceT("scrollMarginBottom"),
	scrollMarginLeft: K.spaceT("scrollMarginLeft"),
	scrollMarginRight: K.spaceT("scrollMarginRight"),
	scrollMarginX: K.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
	scrollMarginY: K.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
	scrollPadding: K.spaceT("scrollPadding"),
	scrollPaddingTop: K.spaceT("scrollPaddingTop"),
	scrollPaddingBottom: K.spaceT("scrollPaddingBottom"),
	scrollPaddingLeft: K.spaceT("scrollPaddingLeft"),
	scrollPaddingRight: K.spaceT("scrollPaddingRight"),
	scrollPaddingX: K.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
	scrollPaddingY: K.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function la(e) {
	return ui(e) && e.reference ? e.reference : String(e);
}
var ua = (e, ...t) => t.map(la).join(` ${e} `).replace(/calc/g, ""), da = (...e) => `calc(${ua("+", ...e)})`, fa = (...e) => `calc(${ua("-", ...e)})`, pa = (...e) => `calc(${ua("*", ...e)})`, ma = (...e) => `calc(${ua("/", ...e)})`, ha = (e) => {
	let t = la(e);
	return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : pa(t, -1);
}, ga = Object.assign((e) => ({
	add: (...t) => ga(da(e, ...t)),
	subtract: (...t) => ga(fa(e, ...t)),
	multiply: (...t) => ga(pa(e, ...t)),
	divide: (...t) => ga(ma(e, ...t)),
	negate: () => ga(ha(e)),
	toString: () => e.toString()
}), {
	add: da,
	subtract: fa,
	multiply: pa,
	divide: ma,
	negate: ha
});
function _a(e) {
	let t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
	return {
		unitless: !n,
		value: t,
		unit: n
	};
}
function va(e) {
	if (e == null) return e;
	let { unitless: t } = _a(e);
	return t || typeof e == "number" ? `${e}px` : e;
}
function ya(e, t) {
	let n = ["@media screen"];
	return e && n.push("and", `(min-width: ${va(e)})`), t && n.push("and", `(max-width: ${va(t)})`), n.join(" ");
}
var Y = {
	hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
	focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
	focusVisible: (e, t) => `${e}:focus-visible ${t}`,
	focusWithin: (e, t) => `${e}:focus-within ${t}`,
	active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
	disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
	invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
	checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
	indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
	readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
	expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
	placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, ba = (e) => Sa((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), xa = (e) => Sa((t) => e(t, "~ &"), "[data-peer]", ".peer"), Sa = (e, ...t) => t.map(e).join(", "), Ca = {
	_hover: "&:hover, &[data-hover]",
	_active: "&:active, &[data-active]",
	_focus: "&:focus, &[data-focus]",
	_highlighted: "&[data-highlighted]",
	_focusWithin: "&:focus-within",
	_focusVisible: "&:focus-visible, &[data-focus-visible]",
	_disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
	_readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
	_before: "&::before",
	_after: "&::after",
	_empty: "&:empty",
	_expanded: "&[aria-expanded=true], &[data-expanded]",
	_checked: "&[aria-checked=true], &[data-checked]",
	_grabbed: "&[aria-grabbed=true], &[data-grabbed]",
	_pressed: "&[aria-pressed=true], &[data-pressed]",
	_invalid: "&[aria-invalid=true], &[data-invalid]",
	_valid: "&[data-valid], &[data-state=valid]",
	_loading: "&[data-loading], &[aria-busy=true]",
	_selected: "&[aria-selected=true], &[data-selected]",
	_hidden: "&[hidden], &[data-hidden]",
	_autofill: "&:-webkit-autofill",
	_even: "&:nth-of-type(even)",
	_odd: "&:nth-of-type(odd)",
	_first: "&:first-of-type",
	_firstLetter: "&::first-letter",
	_last: "&:last-of-type",
	_notFirst: "&:not(:first-of-type)",
	_notLast: "&:not(:last-of-type)",
	_visited: "&:visited",
	_activeLink: "&[aria-current=page]",
	_activeStep: "&[aria-current=step]",
	_indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
	_groupHover: ba(Y.hover),
	_peerHover: xa(Y.hover),
	_groupFocus: ba(Y.focus),
	_peerFocus: xa(Y.focus),
	_groupFocusVisible: ba(Y.focusVisible),
	_peerFocusVisible: xa(Y.focusVisible),
	_groupActive: ba(Y.active),
	_peerActive: xa(Y.active),
	_groupDisabled: ba(Y.disabled),
	_peerDisabled: xa(Y.disabled),
	_groupInvalid: ba(Y.invalid),
	_peerInvalid: xa(Y.invalid),
	_groupChecked: ba(Y.checked),
	_peerChecked: xa(Y.checked),
	_groupFocusWithin: ba(Y.focusWithin),
	_peerFocusWithin: xa(Y.focusWithin),
	_peerPlaceholderShown: xa(Y.placeholderShown),
	_placeholder: "&::placeholder",
	_placeholderShown: "&:placeholder-shown",
	_fullScreen: "&:fullscreen",
	_selection: "&::selection",
	_rtl: "[dir=rtl] &, &[dir=rtl]",
	_ltr: "[dir=ltr] &, &[dir=ltr]",
	_mediaDark: "@media (prefers-color-scheme: dark)",
	_mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
	_dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
	_light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
	_horizontal: "&[data-orientation=horizontal]",
	_vertical: "&[data-orientation=vertical]"
}, wa = Object.keys(Ca);
function Ta(e, t = []) {
	let n = Object.assign({}, e);
	for (let e of t) e in n && delete n[e];
	return n;
}
var Ea = (0, mi.default)({}, Vi, q, Hi, Gi, Ji, Wi, ra, qi, Ki, ta, na, Ui, J, ca, sa, ia, aa, Yi, oa), Da = Object.assign({}, J, Ji, Gi, Ki, na);
Object.keys(Da);
var Oa = [...Object.keys(Ea), ...wa], ka = {
	...Ea,
	...Ca
}, Aa = (e) => e in ka, ja = (e) => (t) => {
	if (!t.__breakpoints) return e;
	let { isResponsive: n, toArrayValue: r, media: i } = t.__breakpoints, a = {};
	for (let o in e) {
		let s = di(e[o], t);
		if (s == null) continue;
		if (s = ui(s) && n(s) ? r(s) : s, !Array.isArray(s)) {
			a[o] = s;
			continue;
		}
		let c = s.slice(0, i.length).length;
		for (let e = 0; e < c; e += 1) {
			let t = i?.[e];
			if (!t) {
				a[o] = s[e];
				continue;
			}
			a[t] = a[t] || {}, s[e] != null && (a[t][o] = s[e]);
		}
	}
	return a;
};
function Ma(e) {
	let t = [], n = "", r = !1;
	for (let i = 0; i < e.length; i++) {
		let a = e[i];
		a === "(" ? (r = !0, n += a) : a === ")" ? (r = !1, n += a) : a === "," && !r ? (t.push(n), n = "") : n += a;
	}
	return n = n.trim(), n && t.push(n), t;
}
function Na(e) {
	return /^var\(--.+\)$/.test(e);
}
var Pa = (e, t) => e.startsWith("--") && typeof t == "string" && !Na(t), Fa = (e, t) => {
	if (t == null) return t;
	let n = (t) => e.__cssMap?.[t]?.varRef, r = (e) => n(e) ?? e, [i, a] = Ma(t);
	return t = n(i) ?? r(a) ?? r(t), t;
};
function Ia(e) {
	let { configs: t = {}, pseudos: n = {}, theme: r } = e, i = (e, a = !1) => {
		let o = di(e, r), s = ja(o)(r), c = {};
		for (let e in s) {
			let l = s[e], u = di(l, r);
			e in n && (e = n[e]), Pa(e, u) && (u = Fa(r, u));
			let d = t[e];
			if (d === !0 && (d = { property: e }), ui(u)) {
				c[e] = c[e] ?? {}, c[e] = (0, mi.default)({}, c[e], i(u, !0));
				continue;
			}
			let f = (d?.transform)?.call(d, u, r, o) ?? u;
			f = d?.processResult ? i(f, !0) : f;
			let p = di(d?.property, r);
			if (!a && d?.static) {
				let e = di(d.static, r);
				c = (0, mi.default)({}, c, e);
			}
			if (p && Array.isArray(p)) {
				for (let e of p) c[e] = f;
				continue;
			}
			if (p) {
				p === "&" && ui(f) ? c = (0, mi.default)({}, c, f) : c[p] = f;
				continue;
			}
			if (ui(f)) {
				c = (0, mi.default)({}, c, f);
				continue;
			}
			c[e] = f;
		}
		return c;
	};
	return i;
}
var La = (e) => (t) => Ia({
	theme: t,
	pseudos: Ca,
	configs: Ea
})(e);
function Ra(e, t) {
	if (Array.isArray(e)) return e;
	if (ui(e)) return t(e);
	if (e != null) return [e];
}
function za(e, t) {
	for (let n = t + 1; n < e.length; n++) if (e[n] != null) return n;
	return -1;
}
function Ba(e) {
	let t = e.__breakpoints;
	return function(e, n, r, i) {
		var a;
		if (!t) return;
		let o = {}, s = Ra(r, t.toArrayValue);
		if (!s) return o;
		let c = s.length, l = c === 1, u = !!e.parts;
		for (let r = 0; r < c; r++) {
			let c = t.details[r], d = t.details[za(s, r)], f = ya(c.minW, d?._minW), p = di(e[n]?.[s[r]], i);
			if (p) {
				if (u) {
					(a = e.parts) == null || a.forEach((e) => {
						(0, mi.default)(o, { [e]: l ? p[e] : { [f]: p[e] } });
					});
					continue;
				}
				if (!u) {
					l ? (0, mi.default)(o, p) : o[f] = p;
					continue;
				}
				o[f] = p;
			}
		}
		return o;
	};
}
function Va(e) {
	return (t) => {
		let { variant: n, size: r, theme: i } = t, a = Ba(i);
		return (0, mi.default)({}, di(e.baseStyle ?? {}, t), a(e, "sizes", r, t), a(e, "variants", n, t));
	};
}
function Ha(e) {
	return Ta(e, [
		"styleConfig",
		"size",
		"variant",
		"colorScheme"
	]);
}
//#endregion
//#region ../../node_modules/@chakra-ui/utils/dist/chunk-YTQ3XZ3T.mjs
function Ua(e, t) {
	let n = {};
	return Object.keys(e).forEach((r) => {
		t.includes(r) || (n[r] = e[r]);
	}), n;
}
function Wa(e, t, n, r) {
	let i = typeof t == "string" ? t.split(".") : [t];
	for (r = 0; r < i.length && e; r += 1) e = e[i[r]];
	return e === void 0 ? n : e;
}
var Ga = ((e) => {
	let t = /* @__PURE__ */ new WeakMap();
	return (n, r, i, a) => {
		if (n === void 0) return e(n, r, i);
		t.has(n) || t.set(n, /* @__PURE__ */ new Map());
		let o = t.get(n);
		if (o.has(r)) return o.get(r);
		let s = e(n, r, i, a);
		return o.set(r, s), s;
	};
})(Wa);
function Ka(e, t) {
	let n = {};
	return Object.keys(e).forEach((r) => {
		let i = e[r];
		t(i, r, e) && (n[r] = i);
	}), n;
}
var qa = (e) => Ka(e, (e) => e != null);
//#endregion
//#region ../../node_modules/@chakra-ui/utils/dist/chunk-Y5FGD7DM.mjs
function Ja(e) {
	return typeof e == "function";
}
process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/@chakra-ui/utils/dist/chunk-M3TFMUOL.mjs
function Ya(e, ...t) {
	return Ja(e) ? e(...t) : e;
}
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-DMO4EI7P.mjs
var Xa = /* @__PURE__ */ Pe((/* @__PURE__ */ Me(((e, t) => {
	var n = typeof Element < "u", r = typeof Map == "function", i = typeof Set == "function", a = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
	function o(e, t) {
		if (e === t) return !0;
		if (e && t && typeof e == "object" && typeof t == "object") {
			if (e.constructor !== t.constructor) return !1;
			var s, c, l;
			if (Array.isArray(e)) {
				if (s = e.length, s != t.length) return !1;
				for (c = s; c-- !== 0;) if (!o(e[c], t[c])) return !1;
				return !0;
			}
			var u;
			if (r && e instanceof Map && t instanceof Map) {
				if (e.size !== t.size) return !1;
				for (u = e.entries(); !(c = u.next()).done;) if (!t.has(c.value[0])) return !1;
				for (u = e.entries(); !(c = u.next()).done;) if (!o(c.value[1], t.get(c.value[0]))) return !1;
				return !0;
			}
			if (i && e instanceof Set && t instanceof Set) {
				if (e.size !== t.size) return !1;
				for (u = e.entries(); !(c = u.next()).done;) if (!t.has(c.value[0])) return !1;
				return !0;
			}
			if (a && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
				if (s = e.length, s != t.length) return !1;
				for (c = s; c-- !== 0;) if (e[c] !== t[c]) return !1;
				return !0;
			}
			if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
			if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function") return e.valueOf() === t.valueOf();
			if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function") return e.toString() === t.toString();
			if (l = Object.keys(e), s = l.length, s !== Object.keys(t).length) return !1;
			for (c = s; c-- !== 0;) if (!Object.prototype.hasOwnProperty.call(t, l[c])) return !1;
			if (n && e instanceof Element) return !1;
			for (c = s; c-- !== 0;) if (!((l[c] === "_owner" || l[c] === "__v" || l[c] === "__o") && e.$$typeof) && !o(e[l[c]], t[l[c]])) return !1;
			return !0;
		}
		return e !== e && t !== t;
	}
	t.exports = function(e, t) {
		try {
			return o(e, t);
		} catch (e) {
			if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
			throw e;
		}
	};
})))(), 1);
function Za(e, t = {}) {
	let { styleConfig: n, ...r } = t, { theme: i, colorMode: a } = ci(), o = e ? Ga(i, `components.${e}`) : void 0, s = n || o, c = (0, mi.default)({
		theme: i,
		colorMode: a
	}, s?.defaultProps ?? {}, qa(Ua(r, ["children"]))), l = j({});
	if (s) {
		let e = Va(s)(c);
		(0, Xa.default)(l.current, e) || (l.current = e);
	}
	return l.current;
}
function Qa(e, t = {}) {
	return Za(e, t);
}
function $a(e, t = {}) {
	return Za(e, t);
}
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-FDQH4LQI.mjs
var eo = /* @__PURE__ */ new Set([
	...Oa,
	"textStyle",
	"layerStyle",
	"apply",
	"noOfLines",
	"focusBorderColor",
	"errorBorderColor",
	"as",
	"__css",
	"css",
	"sx"
]), to = /* @__PURE__ */ new Set([
	"htmlWidth",
	"htmlHeight",
	"htmlSize",
	"htmlTranslate"
]);
function no(e) {
	return to.has(e) || !eo.has(e);
}
//#endregion
//#region ../../node_modules/@chakra-ui/object-utils/dist/chunk-OLTBUDV5.mjs
function ro(e, ...t) {
	if (e == null) throw TypeError("Cannot convert undefined or null to object");
	let n = { ...e };
	for (let e of t) if (e != null) for (let t in e) Object.prototype.hasOwnProperty.call(e, t) && (t in n && delete n[t], n[t] = e[t]);
	return n;
}
//#endregion
//#region ../../node_modules/@chakra-ui/object-utils/dist/chunk-R3DH46PF.mjs
function io(e) {
	let t = Object.assign({}, e);
	for (let e in t) t[e] === void 0 && delete t[e];
	return t;
}
//#endregion
//#region ../../node_modules/@emotion/is-prop-valid/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function ao(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
var oo = je((() => {})), so, co;
//#endregion
//#region ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
je((() => {
	oo(), so = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, co = /* #__PURE__ */ ao(function(e) {
		return so.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
	});
}))();
var lo = co, uo = function(e) {
	return e !== "theme";
}, fo = function(e) {
	return typeof e == "string" && e.charCodeAt(0) > 96 ? lo : uo;
}, po = function(e, t, n) {
	var r;
	if (t) {
		var i = t.shouldForwardProp;
		r = e.__emotion_forwardProp && i ? function(t) {
			return e.__emotion_forwardProp(t) && i(t);
		} : i;
	}
	return typeof r != "function" && n && (r = e.__emotion_forwardProp), r;
}, mo = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences", ho = function(e) {
	var t = e.cache, n = e.serialized, r = e.isStringTag;
	return sr(t, n, r), Pr(function() {
		return cr(t, n, r);
	}), null;
}, go = function e(t, n) {
	if (process.env.NODE_ENV !== "production" && t === void 0) throw Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
	var r = t.__emotion_real === t, i = r && t.__emotion_base || t, a, o;
	n !== void 0 && (a = n.label, o = n.target);
	var s = po(t, n, r), c = s || fo(i), l = !c("as");
	return function() {
		var u = arguments, d = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
		if (a !== void 0 && d.push("label:" + a + ";"), u[0] == null || u[0].raw === void 0) d.push.apply(d, u);
		else {
			process.env.NODE_ENV !== "production" && u[0][0] === void 0 && console.error(mo), d.push(u[0][0]);
			for (var f = u.length, p = 1; p < f; p++) process.env.NODE_ENV !== "production" && u[0][p] === void 0 && console.error(mo), d.push(u[p], u[0][p]);
		}
		var m = Rr(function(e, t, n) {
			var r = l && e.as || i, a = "", u = [], f = e;
			if (e.theme == null) {
				for (var p in f = {}, e) f[p] = e[p];
				f.theme = D.useContext(zr);
			}
			typeof e.className == "string" ? a = or(t.registered, u, e.className) : e.className != null && (a = e.className + " ");
			var m = jr(d.concat(u), t.registered, f);
			a += t.key + "-" + m.name, o !== void 0 && (a += " " + o);
			var h = l && s === void 0 ? fo(r) : c, g = {};
			for (var _ in e) l && _ === "as" || h(_) && (g[_] = e[_]);
			return g.className = a, g.ref = n, /*#__PURE__*/ D.createElement(D.Fragment, null, /*#__PURE__*/ D.createElement(ho, {
				cache: t,
				serialized: m,
				isStringTag: typeof r == "string"
			}), /*#__PURE__*/ D.createElement(r, g));
		});
		return m.displayName = a === void 0 ? "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")" : a, m.defaultProps = t.defaultProps, m.__emotion_real = m, m.__emotion_base = i, m.__emotion_styles = d, m.__emotion_forwardProp = s, Object.defineProperty(m, "toString", { value: function() {
			return o === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + o;
		} }), m.withComponent = function(t, r) {
			return e(t, tr({}, n, r, { shouldForwardProp: po(m, r, !0) })).apply(void 0, d);
		}, m;
	};
}, _o = /* @__PURE__ */ "a.abbr.address.area.article.aside.audio.b.base.bdi.bdo.big.blockquote.body.br.button.canvas.caption.cite.code.col.colgroup.data.datalist.dd.del.details.dfn.dialog.div.dl.dt.em.embed.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.iframe.img.input.ins.kbd.keygen.label.legend.li.link.main.map.mark.marquee.menu.menuitem.meta.meter.nav.noscript.object.ol.optgroup.option.output.p.param.picture.pre.progress.q.rp.rt.ruby.s.samp.script.section.select.small.source.span.strong.style.sub.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.title.tr.track.u.ul.var.video.wbr.circle.clipPath.defs.ellipse.foreignObject.g.image.line.linearGradient.mask.path.pattern.polygon.polyline.radialGradient.rect.stop.svg.text.tspan".split("."), vo = go.bind();
_o.forEach(function(e) {
	vo[e] = vo(e);
});
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-5PL47M24.mjs
var yo = vo.default ?? vo, bo = ({ baseStyle: e }) => (t) => {
	let { theme: n, css: r, __css: i, sx: a, ...o } = t, s = Ka(o, (e, t) => Aa(t)), c = La(ro({}, i, Ya(e, t), qa(s), a))(t.theme);
	return r ? [c, r] : c;
};
function xo(e, t) {
	let { baseStyle: n, ...r } = t ?? {};
	r.shouldForwardProp ||= no;
	let i = bo({ baseStyle: n }), a = yo(e, r)(i);
	return se.forwardRef(function(e, t) {
		let { colorMode: n, forced: r } = si();
		return se.createElement(a, {
			ref: t,
			"data-theme": r ? n : void 0,
			...e
		});
	});
}
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs
function So() {
	let e = /* @__PURE__ */ new Map();
	return new Proxy(xo, {
		apply(e, t, n) {
			return xo(...n);
		},
		get(t, n) {
			return e.has(n) || e.set(n, xo(n)), e.get(n);
		}
	});
}
var Co = So();
//#endregion
//#region ../../node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
function wo(e) {
	return ue(e);
}
//#endregion
//#region ../../node_modules/@chakra-ui/react-use-callback-ref/dist/index.mjs
function To(e, t = []) {
	let n = j(e);
	return A(() => {
		n.current = e;
	}), O((...e) => n.current?.call(n, ...e), t);
}
//#endregion
//#region ../../node_modules/@chakra-ui/react-use-update-effect/dist/index.mjs
function Eo(e, t) {
	let n = j(!1), r = j(!1);
	A(() => {
		if (n.current && r.current) return e();
		r.current = !0;
	}, t), A(() => (n.current = !0, () => {
		n.current = !1;
	}), []);
}
//#endregion
//#region ../../node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
function Do(e, t) {
	if (e != null) {
		if (typeof e == "function") {
			e(t);
			return;
		}
		try {
			e.current = t;
		} catch {
			throw Error(`Cannot assign value '${t}' to ref '${e}'`);
		}
	}
}
function Oo(...e) {
	return (t) => {
		e.forEach((e) => {
			Do(e, t);
		});
	};
}
//#endregion
//#region ../../node_modules/@chakra-ui/checkbox/dist/chunk-LYGBQ47X.mjs
var [ko, Ao] = ri({
	name: "CheckboxGroupContext",
	strict: !1
});
//#endregion
//#region ../../node_modules/@chakra-ui/checkbox/dist/chunk-2TOCDA5N.mjs
function jo(e) {
	let [t, n] = M(e), [r, i] = M(!1);
	return e !== t && (i(!0), n(e)), r;
}
//#endregion
//#region ../../node_modules/@chakra-ui/checkbox/dist/chunk-ULEC7HZU.mjs
function Mo(e) {
	return /* @__PURE__ */ N(Co.svg, {
		width: "1.2em",
		viewBox: "0 0 12 10",
		style: {
			fill: "none",
			strokeWidth: 2,
			stroke: "currentColor",
			strokeDasharray: 16
		},
		...e,
		children: /* @__PURE__ */ N("polyline", { points: "1.5 6 4.5 9 10.5 1" })
	});
}
function No(e) {
	return /* @__PURE__ */ N(Co.svg, {
		width: "1.2em",
		viewBox: "0 0 24 24",
		style: {
			stroke: "currentColor",
			strokeWidth: 4
		},
		...e,
		children: /* @__PURE__ */ N("line", {
			x1: "21",
			x2: "3",
			y1: "12",
			y2: "12"
		})
	});
}
function Po(e) {
	let { isIndeterminate: t, isChecked: n, ...r } = e, i = t ? No : Mo;
	return n || t ? /* @__PURE__ */ N(Co.div, {
		style: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: "100%"
		},
		children: /* @__PURE__ */ N(i, { ...r })
	}) : null;
}
//#endregion
//#region ../../node_modules/@chakra-ui/form-control/dist/chunk-OSN4JR34.mjs
var [Fo, Io] = ri({
	name: "FormControlStylesContext",
	errorMessage: "useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormControl />\" "
}), [Lo, Ro] = ri({
	strict: !1,
	name: "FormControlContext"
});
function zo(e) {
	let { id: t, isRequired: n, isInvalid: r, isDisabled: i, isReadOnly: a, ...o } = e, s = de(), c = t || `field-${s}`, l = `${c}-label`, u = `${c}-feedback`, d = `${c}-helptext`, [f, p] = M(!1), [m, h] = M(!1), [g, _] = M(!1), v = O((e = {}, t = null) => ({
		id: d,
		...e,
		ref: Oo(t, (e) => {
			e && h(!0);
		})
	}), [d]), y = O((e = {}, t = null) => ({
		...e,
		ref: t,
		"data-focus": U(g),
		"data-disabled": U(i),
		"data-invalid": U(r),
		"data-readonly": U(a),
		id: e.id === void 0 ? l : e.id,
		htmlFor: e.htmlFor === void 0 ? c : e.htmlFor
	}), [
		c,
		i,
		g,
		r,
		a,
		l
	]), b = O((e = {}, t = null) => ({
		id: u,
		...e,
		ref: Oo(t, (e) => {
			e && p(!0);
		}),
		"aria-live": "polite"
	}), [u]), x = O((e = {}, t = null) => ({
		...e,
		...o,
		ref: t,
		role: "group"
	}), [o]), S = O((e = {}, t = null) => ({
		...e,
		ref: t,
		role: "presentation",
		"aria-hidden": !0,
		children: e.children || "*"
	}), []);
	return {
		isRequired: !!n,
		isInvalid: !!r,
		isReadOnly: !!a,
		isDisabled: !!i,
		isFocused: !!g,
		onFocus: () => _(!0),
		onBlur: () => _(!1),
		hasFeedbackText: f,
		setHasFeedbackText: p,
		hasHelpText: m,
		setHasHelpText: h,
		id: c,
		labelId: l,
		feedbackId: u,
		helpTextId: d,
		htmlProps: o,
		getHelpTextProps: v,
		getErrorMessageProps: b,
		getRootProps: x,
		getLabelProps: y,
		getRequiredIndicatorProps: S
	};
}
var Bo = wo(function(e, t) {
	let n = $a("Form", e), { getRootProps: r, htmlProps: i, ...a } = zo(Ha(e)), o = li("chakra-form-control", e.className);
	return /* @__PURE__ */ N(Lo, {
		value: a,
		children: /* @__PURE__ */ N(Fo, {
			value: n,
			children: /* @__PURE__ */ N(Co.div, {
				...r({}, t),
				className: o,
				__css: n.container
			})
		})
	});
});
Bo.displayName = "FormControl";
var Vo = wo(function(e, t) {
	let n = Ro(), r = Io(), i = li("chakra-form__helper-text", e.className);
	return /* @__PURE__ */ N(Co.div, {
		...n?.getHelpTextProps(e, t),
		__css: r.helperText,
		className: i
	});
});
Vo.displayName = "FormHelperText";
//#endregion
//#region ../../node_modules/@chakra-ui/form-control/dist/chunk-VLMMX64R.mjs
function Ho(e) {
	let t = Ro(), { id: n, disabled: r, readOnly: i, required: a, isRequired: o, isInvalid: s, isReadOnly: c, isDisabled: l, onFocus: u, onBlur: d, ...f } = e, p = e["aria-describedby"] ? [e["aria-describedby"]] : [];
	return t?.hasFeedbackText && t?.isInvalid && p.push(t.feedbackId), t?.hasHelpText && p.push(t.helpTextId), {
		...f,
		"aria-describedby": p.join(" ") || void 0,
		id: n ?? t?.id,
		isDisabled: r ?? l ?? t?.isDisabled,
		isReadOnly: i ?? c ?? t?.isReadOnly,
		isRequired: a ?? o ?? t?.isRequired,
		isInvalid: s ?? t?.isInvalid,
		onFocus: W(t?.onFocus, u),
		onBlur: W(t?.onBlur, d)
	};
}
//#endregion
//#region ../../node_modules/@chakra-ui/visually-hidden/dist/chunk-3JHDQ75O.mjs
var Uo = {
	border: "0",
	clip: "rect(0, 0, 0, 0)",
	height: "1px",
	width: "1px",
	margin: "-1px",
	padding: "0",
	overflow: "hidden",
	whiteSpace: "nowrap",
	position: "absolute"
}, Wo = () => typeof document < "u", Go = !1, Ko = null, qo = !1, Jo = !1, Yo = /* @__PURE__ */ new Set();
function Xo(e, t) {
	Yo.forEach((n) => n(e, t));
}
var Zo = typeof window < "u" && window.navigator != null && /^Mac/.test(window.navigator.platform);
function Qo(e) {
	return !(e.metaKey || !Zo && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $o(e) {
	qo = !0, Qo(e) && (Ko = "keyboard", Xo("keyboard", e));
}
function es(e) {
	if (Ko = "pointer", e.type === "mousedown" || e.type === "pointerdown") {
		qo = !0;
		let t = e.composedPath ? e.composedPath()[0] : e.target, n = !1;
		try {
			n = t.matches(":focus-visible");
		} catch {}
		if (n) return;
		Xo("pointer", e);
	}
}
function ts(e) {
	return e.mozInputSource === 0 && e.isTrusted ? !0 : e.detail === 0 && !e.pointerType;
}
function ns(e) {
	ts(e) && (qo = !0, Ko = "virtual");
}
function rs(e) {
	e.target === window || e.target === document || (!qo && !Jo && (Ko = "virtual", Xo("virtual", e)), qo = !1, Jo = !1);
}
function is() {
	qo = !1, Jo = !0;
}
function as() {
	return Ko !== "pointer";
}
function os() {
	if (!Wo() || Go) return;
	let { focus: e } = HTMLElement.prototype;
	HTMLElement.prototype.focus = function(...t) {
		qo = !0, e.apply(this, t);
	}, document.addEventListener("keydown", $o, !0), document.addEventListener("keyup", $o, !0), document.addEventListener("click", ns, !0), window.addEventListener("focus", rs, !0), window.addEventListener("blur", is, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", es, !0), document.addEventListener("pointermove", es, !0), document.addEventListener("pointerup", es, !0)) : (document.addEventListener("mousedown", es, !0), document.addEventListener("mousemove", es, !0), document.addEventListener("mouseup", es, !0)), Go = !0;
}
function ss(e) {
	os(), e(as());
	let t = () => e(as());
	return Yo.add(t), () => {
		Yo.delete(t);
	};
}
//#endregion
//#region ../../node_modules/@chakra-ui/checkbox/dist/chunk-7D6N5TE5.mjs
function cs(e, t = []) {
	let n = Object.assign({}, e);
	for (let e of t) e in n && delete n[e];
	return n;
}
function ls(e = {}) {
	let { isDisabled: t, isReadOnly: n, isRequired: r, isInvalid: i, id: a, onBlur: o, onFocus: s, "aria-describedby": c } = Ho(e), { defaultChecked: l, isChecked: u, isFocusable: d, onChange: f, isIndeterminate: p, name: m, value: h, tabIndex: g = void 0, "aria-label": _, "aria-labelledby": v, "aria-invalid": y, ...b } = e, x = cs(b, [
		"isDisabled",
		"isReadOnly",
		"isRequired",
		"isInvalid",
		"id",
		"onBlur",
		"onFocus",
		"aria-describedby"
	]), S = To(f), C = To(o), ee = To(s), [te, ne] = M(!1), [re, ie] = M(!1), [w, ae] = M(!1), [T, oe] = M(!1);
	A(() => ss(ne), []);
	let E = j(null), [D, se] = M(!0), [ce, le] = M(!!l), ue = u !== void 0, k = ue ? u : ce, de = O((e) => {
		if (n || t) {
			e.preventDefault();
			return;
		}
		ue || le(k ? e.target.checked : p ? !0 : e.target.checked), S?.(e);
	}, [
		n,
		t,
		k,
		ue,
		p,
		S
	]);
	ii(() => {
		E.current && (E.current.indeterminate = !!p);
	}, [p]), Eo(() => {
		t && ie(!1);
	}, [t, ie]), ii(() => {
		let e = E.current;
		if (!e?.form) return;
		let t = () => {
			le(!!l);
		};
		return e.form.addEventListener("reset", t), () => e.form?.removeEventListener("reset", t);
	}, []);
	let fe = t && !d, pe = O((e) => {
		e.key === " " && oe(!0);
	}, [oe]), me = O((e) => {
		e.key === " " && oe(!1);
	}, [oe]);
	ii(() => {
		E.current && E.current.checked !== k && le(E.current.checked);
	}, [E.current]);
	let N = O((e = {}, r = null) => {
		let a = (e) => {
			re && e.preventDefault(), oe(!0);
		};
		return {
			...e,
			ref: r,
			"data-active": U(T),
			"data-hover": U(w),
			"data-checked": U(k),
			"data-focus": U(re),
			"data-focus-visible": U(re && te),
			"data-indeterminate": U(p),
			"data-disabled": U(t),
			"data-invalid": U(i),
			"data-readonly": U(n),
			"aria-hidden": !0,
			onMouseDown: W(e.onMouseDown, a),
			onMouseUp: W(e.onMouseUp, () => oe(!1)),
			onMouseEnter: W(e.onMouseEnter, () => ae(!0)),
			onMouseLeave: W(e.onMouseLeave, () => ae(!1))
		};
	}, [
		T,
		k,
		t,
		re,
		te,
		w,
		p,
		i,
		n
	]), he = O((e = {}, r = null) => ({
		...e,
		ref: r,
		"data-active": U(T),
		"data-hover": U(w),
		"data-checked": U(k),
		"data-focus": U(re),
		"data-focus-visible": U(re && te),
		"data-indeterminate": U(p),
		"data-disabled": U(t),
		"data-invalid": U(i),
		"data-readonly": U(n)
	}), [
		T,
		k,
		t,
		re,
		te,
		w,
		p,
		i,
		n
	]), ge = O((e = {}, n = null) => ({
		...x,
		...e,
		ref: Oo(n, (e) => {
			e && se(e.tagName === "LABEL");
		}),
		onClick: W(e.onClick, () => {
			var e;
			D || ((e = E.current) == null || e.click(), requestAnimationFrame(() => {
				var e;
				(e = E.current) == null || e.focus({ preventScroll: !0 });
			}));
		}),
		"data-disabled": U(t),
		"data-checked": U(k),
		"data-invalid": U(i)
	}), [
		x,
		t,
		k,
		i,
		D
	]), P = O((e = {}, o = null) => ({
		...e,
		ref: Oo(E, o),
		type: "checkbox",
		name: m,
		value: h,
		id: a,
		tabIndex: g,
		onChange: W(e.onChange, de),
		onBlur: W(e.onBlur, C, () => ie(!1)),
		onFocus: W(e.onFocus, ee, () => ie(!0)),
		onKeyDown: W(e.onKeyDown, pe),
		onKeyUp: W(e.onKeyUp, me),
		required: r,
		checked: k,
		disabled: fe,
		readOnly: n,
		"aria-label": _,
		"aria-labelledby": v,
		"aria-invalid": y ? !!y : i,
		"aria-describedby": c,
		"aria-disabled": t,
		style: Uo
	}), [
		m,
		h,
		a,
		de,
		C,
		ee,
		pe,
		me,
		r,
		k,
		fe,
		n,
		_,
		v,
		y,
		i,
		c,
		t,
		g
	]), _e = O((e = {}, n = null) => ({
		...e,
		ref: n,
		onMouseDown: W(e.onMouseDown, us),
		"data-disabled": U(t),
		"data-checked": U(k),
		"data-invalid": U(i)
	}), [
		k,
		t,
		i
	]);
	return {
		state: {
			isInvalid: i,
			isFocused: re,
			isChecked: k,
			isActive: T,
			isHovered: w,
			isIndeterminate: p,
			isDisabled: t,
			isReadOnly: n,
			isRequired: r
		},
		getRootProps: ge,
		getCheckboxProps: N,
		getIndicatorProps: he,
		getInputProps: P,
		getLabelProps: _e,
		htmlProps: x
	};
}
function us(e) {
	e.preventDefault(), e.stopPropagation();
}
//#endregion
//#region ../../node_modules/@chakra-ui/checkbox/dist/chunk-CWVAJCXJ.mjs
var ds = {
	display: "inline-flex",
	alignItems: "center",
	justifyContent: "center",
	verticalAlign: "top",
	userSelect: "none",
	flexShrink: 0
}, fs = {
	cursor: "pointer",
	display: "inline-flex",
	alignItems: "center",
	verticalAlign: "top",
	position: "relative"
}, ps = Jr({
	from: {
		opacity: 0,
		strokeDashoffset: 16,
		transform: "scale(0.95)"
	},
	to: {
		opacity: 1,
		strokeDashoffset: 0,
		transform: "scale(1)"
	}
}), ms = Jr({
	from: { opacity: 0 },
	to: { opacity: 1 }
}), hs = Jr({
	from: { transform: "scaleX(0.65)" },
	to: { transform: "scaleX(1)" }
}), gs = wo(function(e, t) {
	let n = Ao(), r = $a("Checkbox", {
		...n,
		...e
	}), i = Ha(e), { spacing: a = "0.5rem", className: o, children: s, iconColor: c, iconSize: l, icon: u = /* @__PURE__ */ N(Po, {}), isChecked: d, isDisabled: f = n?.isDisabled, onChange: p, inputProps: m, ...h } = i, g = d;
	n?.value && i.value && (g = n.value.includes(i.value));
	let _ = p;
	n?.onChange && i.value && (_ = pi(n.onChange, p));
	let { state: v, getInputProps: y, getCheckboxProps: b, getLabelProps: x, getRootProps: S } = ls({
		...h,
		isDisabled: f,
		isChecked: g,
		onChange: _
	}), C = jo(v.isChecked), ee = ce(u, {
		__css: pe(() => ({
			animation: C ? v.isIndeterminate ? `${ms} 20ms linear, ${hs} 200ms linear` : `${ps} 200ms linear` : void 0,
			fontSize: l,
			color: c,
			...r.icon
		}), [
			c,
			l,
			C,
			v.isIndeterminate,
			r.icon
		]),
		isIndeterminate: v.isIndeterminate,
		isChecked: v.isChecked
	});
	return /* @__PURE__ */ he(Co.label, {
		__css: {
			...fs,
			...r.container
		},
		className: li("chakra-checkbox", o),
		...S(),
		children: [
			/* @__PURE__ */ N("input", {
				className: "chakra-checkbox__input",
				...y(m, t)
			}),
			/* @__PURE__ */ N(Co.span, {
				__css: {
					...ds,
					...r.control
				},
				className: "chakra-checkbox__control",
				...b(),
				children: ee
			}),
			s && /* @__PURE__ */ N(Co.span, {
				className: "chakra-checkbox__label",
				...x(),
				__css: {
					marginStart: a,
					...r.label
				},
				children: s
			})
		]
	});
});
gs.displayName = "Checkbox";
//#endregion
//#region ../../node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
var _s = wo(function(e, t) {
	let n = Qa("Text", e), { className: r, align: i, decoration: a, casing: o, ...s } = Ha(e), c = io({
		textAlign: e.align,
		textDecoration: e.decoration,
		textTransform: e.casing
	});
	return /* @__PURE__ */ N(Co.p, {
		ref: t,
		className: li("chakra-text", e.className),
		...c,
		...s,
		__css: n
	});
});
_s.displayName = "Text";
//#endregion
//#region ../../node_modules/@chakra-ui/layout/dist/chunk-PULVB27S.mjs
var vs = Co("div");
vs.displayName = "Box";
var ys = wo(function(e, t) {
	let { size: n, centerContent: r = !0, ...i } = e;
	return /* @__PURE__ */ N(vs, {
		ref: t,
		boxSize: n,
		__css: {
			...r ? {
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			} : {},
			flexShrink: 0,
			flexGrow: 0
		},
		...i
	});
});
ys.displayName = "Square";
var bs = wo(function(e, t) {
	let { size: n, ...r } = e;
	return /* @__PURE__ */ N(ys, {
		size: n,
		ref: t,
		borderRadius: "9999px",
		...r
	});
});
bs.displayName = "Circle";
//#endregion
//#region src/prices/calculateDiscountedPrice.ts
var xs = ({ structure: e }) => w(e).with({ pricingType: "FIXED" }, { pricingType: "ONE_TIME" }, (e) => Number(e.price)).with({ pricingType: "LINEAR" }, (e) => Number(e.pricePerUnit)).with({ pricingType: "PACKAGE" }, (e) => Number(e.pricePerPackage)).with({ pricingType: "SEAT_BASED" }, (e) => Number(e.pricePerSeat)).with({ pricingType: "GRADUATED" }, (e) => {
	let t = e.tiers.at(0);
	return !t || !t.fee ? 0 : Number(t.fee);
}).with({ pricingType: "VOLUME" }, () => {
	throw Error(`${e.pricingType} pricing type is not supported`);
}).exhaustive(), Ss = ({ amount: e, discount: t }) => {
	let n = new P(t.amount);
	return w(t.discountCalculationType).with("NOMINAL", () => n.gt(e) ? e : n.toNumber()).with("PERCENTAGE", () => new P(e).times(n).div(100).toNumber()).exhaustive();
}, Cs = ({ amount: e, discount: t }) => new P(e).minus(Ss({
	amount: e,
	discount: t
})).toNumber(), ws = (e) => e.restrictToPrices.length === 0, Ts = (e) => {
	let t = e.price.structure.pricingType;
	return !(["VOLUME", "GRADUATED"].includes(t) || t === "LINEAR" && e.price.structure.isPricePercentage || e.price.structure.pricingType === "SEAT_BASED" && e.price.structure.tiers && e.price.structure.tiers.length > 0 || [
		"LINEAR",
		"PACKAGE",
		"SEAT_BASED"
	].includes(t) && e.discount.discountCalculationType === "NOMINAL" || ws(e.discount));
}, Es = ({ price: e, discount: t }) => !t || !Ts({
	price: e,
	discount: t
}) ? null : Cs({
	amount: xs({ structure: e.structure }),
	discount: t
}), X = (e) => (t) => {
	if (!t) return 0 .toFixed(e);
	let n = typeof t == "number" ? t.toString() : t;
	return isNaN(parseFloat(n)) ? 0 .toFixed(e) : (n.split(".")[1]?.length ?? 0) < e ? parseFloat(n).toFixed(e) : n;
}, Ds = ["USD"], Os = ["USD"], ks = (e) => {
	let t;
	return t = Ds.includes(e) ? "narrowSymbol" : "symbol", t;
}, As = (e, t = 2, n = 0) => {
	let r = ks(e);
	return new Intl.NumberFormat("en-GB", {
		style: "currency",
		currencyDisplay: r,
		currency: e,
		maximumFractionDigits: t,
		minimumFractionDigits: n
	});
}, Z = ({ value: e, currency: t, fallback: n = "", maximumFractionDigits: r = 2, minimumFractionDigits: i = 2, appendCurrencyCode: a = !1 }) => {
	if (!e || !t) return n;
	let o = As(t, r, i).format(parseFloat(e));
	return a && Os.includes(t) ? `${o} ${t}` : o;
}, js = (e) => w(e).with("USE_FIRST", "USE_MAXIMUM", () => "USE_MAXIMUM").with("PRORATE_INCREMENTS", () => "PRORATE_INCREMENTS").with("PRORATE_ALL_CHANGES", () => "PRORATE_ALL_CHANGES").exhaustive(), Ms = (e) => e.pricingType === "SEAT_BASED" && "contractedMinimumSeats" in e, Ns = (e) => e.pricingType === "SEAT_BASED" && "includedSeats" in e, Ps = (e) => ({
	pricingType: "SEAT_BASED",
	pricePerSeat: e.pricePerSeat,
	seatMetricId: e.seatTypeId,
	contractedMinimumSeats: e.includedSeats,
	prorationStrategy: js(e.prorationStrategy),
	overagesBillingFrequency: e.overagesBillingFrequency,
	prorateFlatFees: e.prorateFlatFees,
	tiers: e.tiers?.map(({ price: e, fee: t, upperBound: n }) => ({
		price: e,
		fee: t,
		upperBound: n
	}))
}), Fs = (e) => ({
	pricingType: "SEAT_BASED",
	pricePerSeat: e.pricePerSeat,
	seatTypeId: e.seatMetricId,
	includedSeats: e.contractedMinimumSeats,
	prorationStrategy: e.prorationStrategy,
	overagesBillingFrequency: e.overagesBillingFrequency,
	prorateFlatFees: e.prorateFlatFees,
	chargeMethod: "CHARGE_CONSUMED",
	tiers: (e.tiers ?? []).map(({ price: e, fee: t, upperBound: n }) => ({
		price: e,
		fee: t,
		upperBound: n,
		isPricePercentage: !1
	}))
}), Q = {
	in: (e) => ({
		externalIds: e.integrationIds?.map(({ service: e, id: t }) => ({
			key: e,
			value: t
		})) ?? [],
		parameters: e.customMetricParameters ?? []
	}),
	out: (e) => ({
		integrationIds: e.externalIds?.map(({ key: e, value: t }) => ({
			service: e,
			id: t
		})) ?? [],
		customMetricParameters: e.parameters ?? []
	})
}, Is = {
	toApiStructure: (e) => Ns(e) ? Ps(e) : e,
	toOldStructure: (e) => Ms(e) ? Fs(e) : e,
	in: (e) => w(e).with({ structure: { pricingType: "SEAT_BASED" } }, (e) => ({
		...e,
		...Q.in(e),
		structure: Fs(e.structure)
	})).with({ structure: { pricingType: "FIXED" } }, (e) => ({
		...e,
		...Q.in(e)
	})).with({ structure: { pricingType: "ONE_TIME" } }, (e) => ({
		...e,
		...Q.in(e)
	})).with({ structure: { pricingType: "GRADUATED" } }, (e) => ({
		...e,
		structure: _e("usageCalculationPeriod")(e.structure),
		...Q.in(e)
	})).with({ structure: { pricingType: "VOLUME" } }, (e) => ({
		...e,
		...Q.in(e)
	})).with({ structure: { pricingType: "PACKAGE" } }, (e) => ({
		...e,
		...Q.in(e)
	})).with({ structure: { pricingType: "LINEAR" } }, (e) => ({
		...e,
		...Q.in(e)
	})).exhaustive(),
	out: (e) => w(e).with({ structure: { pricingType: "SEAT_BASED" } }, (e) => ({
		...e,
		...Q.out(e),
		structure: Ps(e.structure)
	})).with({ structure: { pricingType: "FIXED" } }, (e) => ({
		...e,
		...Q.out(e)
	})).with({ structure: { pricingType: "ONE_TIME" } }, (e) => ({
		...e,
		...Q.out(e)
	})).with({ structure: { pricingType: "GRADUATED" } }, (e) => ({
		...e,
		...Q.out(e),
		structure: {
			...e.structure,
			usageCalculationMode: e.structure.usageCalculationMode
		}
	})).with({ structure: { pricingType: "VOLUME" } }, (e) => ({
		...e,
		...Q.out(e)
	})).with({ structure: { pricingType: "PACKAGE" } }, (e) => ({
		...e,
		...Q.out(e)
	})).with({ structure: { pricingType: "LINEAR" } }, (e) => ({
		...e,
		...Q.out(e)
	})).exhaustive()
}, Ls = (e, { minimumFractionDigits: t = 2, maximumFractionDigits: n = 10 } = {}) => {
	let r = Is.in({
		productId: "__IGNORE__",
		integrationIds: [],
		customMetricParameters: [],
		...e
	});
	switch (r.structure.pricingType) {
		case "FIXED": return Z({
			currency: r.currency,
			value: r.structure.price,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		});
		case "ONE_TIME": return Z({
			currency: r.currency,
			value: r.structure.price,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		});
		case "LINEAR": return r.structure.isPricePercentage ? `${r.structure.pricePerUnit}% (${r.currency})` : `${Z({
			currency: r.currency,
			value: r.structure.pricePerUnit,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		})} per unit`;
		case "PACKAGE": return `${Z({
			currency: r.currency,
			value: r.structure.pricePerPackage,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		})} per package`;
		case "VOLUME":
		case "GRADUATED": return r.structure.tiers[0].isPricePercentage ? `Starts from ${r.structure.tiers[0].price}% (${r.currency})` : `Starts from ${Z({
			currency: r.currency,
			value: r.structure.tiers[0].price,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		})}${r.structure.tiers[0].fee && Number.parseFloat(r.structure.tiers[0].fee) > 0 ? ` + ${Z({
			currency: r.currency,
			value: r.structure.tiers[0].fee,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		})}` : ""}`;
		case "SEAT_BASED": return r.structure.tiers?.length ? `Starts from ${Z({
			currency: r.currency,
			value: r.structure.tiers[0].price,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		})}` : `${Z({
			currency: r.currency,
			value: r.structure.pricePerSeat,
			maximumFractionDigits: n,
			minimumFractionDigits: t
		})} per unit`;
	}
}, Rs = (e) => e ? e.pricingType === "VOLUME" || e.pricingType === "GRADUATED" ? e.tiers[0].isPricePercentage : e.pricingType === "LINEAR" && e.isPricePercentage : !1, zs = (e) => {
	switch (e.pricingType) {
		case "FIXED": return "standard";
		case "ONE_TIME": return "standard";
		case "LINEAR": return "linear";
		case "PACKAGE": return "packaged";
		case "VOLUME": return `volume${Rs(e) ? "-percentage" : ""}`;
		case "GRADUATED": return `graduated${Rs(e) ? "-percentage" : ""}`;
		case "SEAT_BASED": return "seat";
	}
}, Bs = 2, Vs = (e) => e ? new Intl.NumberFormat("en-GB", {
	style: "currency",
	currency: e
}).resolvedOptions().maximumFractionDigits ?? Bs : Bs, Hs = 15, Us = ({ value: e, currency: t }) => {
	if (!e || Number.isNaN(Number(e))) return Z({
		value: e,
		currency: t
	});
	let n = new P(Number(e).toPrecision(Hs)).toFixed().split(".")[1]?.length ?? 0, r = Math.max(Vs(t), n);
	return Z({
		value: e,
		currency: t,
		minimumFractionDigits: r,
		maximumFractionDigits: r
	});
}, Ws = ({ discountCalculationType: e, discountAmount: t, currency: n }) => e === "PERCENTAGE" ? `${t}% off` : `${Us({
	currency: n,
	value: t.toString()
})} off`, Gs = (e) => e.reduce((t, n, r) => {
	let i = t[t.length - 1], a = i?.lastUnit ?? "", o = a.split(".")[1]?.length > 2 ? a.split(".")[1]?.length : 2, s = 1 / 10 ** o, c = r === e.length - 1, l = r === 0 ? 0 : parseFloat((parseFloat(X(o)(i?.lastUnit)) + s).toFixed(o)), u = r === e.length ? 0 : parseFloat(X(2)(n?.lastUnit));
	return [...t, {
		id: n.id,
		lastUnit: c ? "" : X(o)(u < l ? l : u),
		firstUnit: X(o)(l),
		unitPercentage: X(2)(n.unitPercentage),
		flatFee: X(2)(n.flatFee),
		minPrice: n.minPrice ? X(2)(n.minPrice) : "",
		maxPrice: n.maxPrice ? X(2)(n.maxPrice) : ""
	}];
}, []), Ks = (e) => e.reduce((t, n, r) => {
	let i = t[t.length - 1], a = r === e.length - 1, o = r === 0 ? 0 : parseInt(i?.lastUnit || "0") + 1, s = r === e.length ? 0 : parseInt(n.lastUnit || "0");
	return [...t, {
		id: n.id,
		lastUnit: a ? "" : (s < o ? o : s).toString(),
		firstUnit: o.toString(),
		unitPrice: X(2)(n.unitPrice),
		flatFee: X(2)(n.flatFee)
	}];
}, []), qs = 2, Js = (e) => !e || e.length === 0 ? {
	usageTierType: "FIXED",
	percentageTiers: Gs([{
		id: "percentage-tier-1",
		firstUnit: "0",
		lastUnit: "",
		unitPercentage: "0",
		flatFee: "0.00",
		maxPrice: "",
		minPrice: ""
	}]),
	tiers: Ks([{
		id: "fixed-tier-1",
		firstUnit: "0",
		lastUnit: "",
		unitPrice: "0.00",
		flatFee: "0.00"
	}])
} : "isPricePercentage" in e[0] && e[0]?.isPricePercentage ? {
	usageTierType: "PERCENTAGE",
	percentageTiers: Gs(e.map((t, n) => ({
		id: `tier-${n}`,
		firstUnit: n === 0 ? "0.00" : (parseFloat(e[n - 1]?.upperBound ?? "0.00") + .01).toFixed(2) ?? "0.00",
		lastUnit: t.upperBound ? X(qs)(t.upperBound) : "",
		unitPrice: "0.00",
		unitPercentage: X(qs)(t.price ?? "0.00"),
		flatFee: X(qs)(t.fee ?? "0") ?? "0.00",
		maxPrice: "maxPrice" in t && t.maxPrice ? X(qs)(t.maxPrice) : "",
		minPrice: "minPrice" in t && t.minPrice ? X(qs)(t.minPrice) : ""
	}))),
	tiers: Ks([{
		id: "fixed-tier-1",
		firstUnit: "0",
		lastUnit: "",
		unitPrice: "0.00",
		flatFee: "0.00"
	}])
} : {
	usageTierType: "FIXED",
	percentageTiers: Gs([{
		id: "percentage-tier-1",
		firstUnit: "0",
		lastUnit: "",
		unitPercentage: "0",
		flatFee: "0.00",
		maxPrice: "",
		minPrice: ""
	}]),
	tiers: Ks(e.map((t, n) => ({
		id: `tier-${n}`,
		firstUnit: n === 0 ? "0" : (parseFloat(e[n - 1]?.upperBound ?? "0") + 1).toString() ?? "0",
		lastUnit: t.upperBound ?? "",
		unitPrice: X(qs)(t.price ?? "0.00"),
		flatFee: X(qs)(t.fee ?? "0") ?? "0.00"
	})))
}, Ys = (e) => e.structure.pricingType === "SEAT_BASED", Xs = (e) => [
	"LINEAR",
	"VOLUME",
	"GRADUATED",
	"PACKAGE"
].includes(e.structure.pricingType), Zs = (e) => {
	let t = e.map((e) => typeof e == "number" ? e.toString() : e).map((e) => e.split(".")[1]?.length ?? 0);
	return Math.max(...t, 0);
}, Qs = (e, t) => {
	let n = Ft()(e);
	return t ? `${n} to ${Ft()(t)}` : `${n} or more`;
}, $s = (e, t, n) => {
	let r = Z({
		value: e,
		currency: n
	});
	return t ? `${r} to ${Z({
		value: t,
		currency: n
	})}` : `${r} or more`;
}, ec = (e) => parseFloat(e) > 0, tc = (e, t) => ` + ${Z({
	value: e,
	currency: t
})}`, nc = (e) => `${Ft()(e)} contracted ${E("seat", e)}`, $ = {
	STANDARD: "Fixed",
	LINEAR: "Linear",
	VOLUME: "Volume tiers",
	GRADUATED: "Graduated tiers",
	PACKAGE: "Packaged",
	SEAT_BASED_LINEAR: "Seat-based → Linear Pricing",
	SEAT_BASED_GRADUATED: "Seat-based → Graduated Pricing"
}, rc = [
	{
		value: "STANDARD",
		label: $.STANDARD,
		description: "Charge a recurring or one-off fixed fee"
	},
	{
		value: "LINEAR",
		label: $.LINEAR,
		description: "Charge a single, linear rate for usage."
	},
	{
		value: "VOLUME",
		label: $.VOLUME,
		description: "All usage is charged a single unit fee based on total volume."
	},
	{
		value: "GRADUATED",
		label: $.GRADUATED,
		description: "Usage in each tier is charged separately using respective tier fees."
	},
	{
		value: "PACKAGE",
		label: $.PACKAGE,
		description: "Charge a fixed fee for a packaged quantity of units."
	},
	{
		value: "SEAT_BASED_LINEAR",
		label: $.SEAT_BASED_LINEAR,
		description: "Charge a single, linear rate for seats."
	},
	{
		value: "SEAT_BASED_GRADUATED",
		label: $.SEAT_BASED_GRADUATED,
		description: "Seat usage in each tier is charged separately using respective tier fees."
	}
], ic = (e) => w(e).with({
	pricingType: "SEAT_BASED",
	tiers: ie.when((e) => (e?.length ?? 0) > 0)
}, () => $.SEAT_BASED_GRADUATED).with({ pricingType: "SEAT_BASED" }, () => $.SEAT_BASED_LINEAR).with({ pricingType: "FIXED" }, () => $.STANDARD).with({ pricingType: "ONE_TIME" }, () => $.STANDARD).with({ pricingType: "LINEAR" }, () => $.LINEAR).with({ pricingType: "PACKAGE" }, () => $.PACKAGE).with({ pricingType: "VOLUME" }, () => $.VOLUME).with({ pricingType: "GRADUATED" }, () => $.GRADUATED).exhaustive(), ac = (e) => "usageMetricId" in e.structure, oc = (e) => Xs(e) || Ys(e), sc = (e) => typeof e == "string" ? /* @__PURE__ */ N(me, { children: e }) : null, cc = () => /* @__PURE__ */ N(me, { children: " - " }), lc = (e = "") => /* @__PURE__ */ N(_s, {
	whiteSpace: "nowrap",
	children: e
}), uc = (e) => e != null && e !== "" && !isNaN(Number(e.toString())) ? e.slice(-1) === "1" && e !== "11" ? `${e}st` : e.slice(-1) === "2" && e !== "12" ? `${e}nd` : e.slice(-1) === "3" && e !== "13" ? `${e}rd` : `${e}th` : e, dc = ({ condition: e, left: t, right: n }) => (r) => e(r) ? t(r) : n(r), fc = (e) => e.match(/.{1,4}/g)?.join(" ") ?? "", pc = (e, { minimumFractionDigits: t = 0 } = {}) => `${X(t)(parseFloat(e))}%`, mc = (e) => e === void 0 ? /* @__PURE__ */ N(vs, {
	height: "20px",
	width: "120px",
	borderRadius: "24px",
	backgroundColor: "#94a3b8",
	opacity: "0.24"
}) : /* @__PURE__ */ N(_s, {
	textStyle: "previewText",
	children: e
}), hc = (e) => e ? e.replace(/\w\S*/g, function(e) {
	return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
}).replaceAll("_", " ") : "", gc = (e) => /* @__PURE__ */ N(gs, {
	colorScheme: "indigo.50",
	isChecked: e
}), _c = ({ onOpen: e, onClose: t } = {}) => {
	let [n, r] = M(!1), i = j(e), a = j(t);
	fe(() => {
		i.current = e, a.current = t;
	});
	let o = O(() => {
		r(!0), i.current?.();
	}, []), s = O(() => {
		r(!1), a.current?.();
	}, []);
	return {
		isOpen: n,
		onOpen: o,
		onClose: s,
		onToggle: O(() => {
			(n ? s : o)();
		}, [
			n,
			o,
			s
		])
	};
}, vc = {
	eq: (e, t) => F(e, t),
	neq: (e, t) => !F(e, t),
	and: (e, t) => !!e && !!t,
	or: (e, t) => !!e || !!t
}, yc = (e) => (t) => w(t).with({ type: "resolveState" }, (t) => ve(t.dataLocation)(e)).with({ type: "static" }, (e) => e.value).with({ type: "expression" }, (t) => bc(e)(t.value)).exhaustive(), bc = (e) => (t) => (Array.isArray(t) ? t : [t]).every(({ lhsValue: t, rhsValue: n, operator: r }) => {
	let i = yc(e)(t), a = yc(e)(n);
	return vc[r](i, a);
}), xc = (e) => (t) => e.flatMap((e) => e.validators.flatMap((n) => {
	if (e.ignoreIf && (typeof e.ignoreIf == "function" ? e.ignoreIf(t) : bc(t)(e.ignoreIf))) return [];
	let r = n(ve(e.dataLocation)(t), e.additionalData ? Object.entries(e.additionalData).reduce((e, [n, r]) => ({
		...e,
		[n]: ve(r)(t)
	}), {}) : t);
	if (r) return Array.isArray(r) ? r : [{ message: r }];
}).filter((e) => !!e).map((n) => ({
	fieldName: e.fieldName,
	message: n.message,
	metadata: n.metadata,
	value: ve(e.dataLocation)(t)
}))), Sc = (e) => {
	let t = j();
	return A(() => {
		F(e, t.current) || (t.current = e);
	}), t.current;
}, Cc = ({ value: e, reinitializeOnValueChange: t = !0, fieldConfiguration: n, showValidationErrors: r, onChange: i, onValidationStateChange: a, disabled: o = !1, apiErrors: s }) => {
	let [c, l] = M({
		formData: e,
		clearedApiErrors: /* @__PURE__ */ new Set()
	}), u = pe(() => n.filter((e) => e.validation && !o && !(e.disabled?.({
		formData: c.formData,
		property: e.property
	}) ?? !1)).flatMap((e) => ({
		fieldName: e.property,
		dataLocation: e.property,
		validators: e.validation
	})), [
		n,
		c,
		o
	]), d = Sc(c.formData), f = O(() => {
		l({
			formData: e,
			clearedApiErrors: /* @__PURE__ */ new Set()
		});
	}, [e]), p = O((e) => {
		l((t) => ({
			...t,
			formData: be(t.formData, typeof e == "function" ? e(t.formData) : e, { arrayMerge: (e, t) => t })
		}));
	}, []);
	A(() => {
		if (F(c.formData, d) || !d) return;
		i?.(c.formData);
		let e = xc(u)(c.formData);
		a?.(!e.length, e);
	}, [
		c.formData,
		d,
		i,
		a,
		u
	]);
	let m = Sc(e);
	A(() => {
		t && (typeof t == "function" && !t({
			newData: e,
			prevData: m
		}) || F(e, m) || l({
			formData: e,
			clearedApiErrors: /* @__PURE__ */ new Set()
		}));
	}, [
		e,
		m,
		t
	]);
	let h = Sc(s);
	A(() => {
		F(s, h) || l((e) => ({
			...e,
			clearedApiErrors: /* @__PURE__ */ new Set()
		}));
	}, [s, h]);
	let g = pe(() => xc(u)(c.formData), [u, c]), _ = pe(() => !g.length, [g.length]), v = Sc(_);
	A(() => {
		(_ !== v || v === void 0) && a?.(_, g);
	}, [
		_,
		a,
		v,
		g
	]);
	let y = O((e) => {
		l((t) => ({
			...t,
			clearedApiErrors: /* @__PURE__ */ new Set([...t.clearedApiErrors, e])
		}));
	}, []);
	return {
		fields: pe(() => n.reduce((e, t) => {
			let n = (t.property ?? "").split(".").filter(Boolean), i = r ? g.filter((e) => e.fieldName === t.property) : [], a = r && s && !c.clearedApiErrors.has(t.property) && s[t.property] ? s[t.property] : [], l = [...i, ...a];
			return {
				...e,
				[t.property]: {
					disabled: o || (t.disabled?.({
						formData: c.formData,
						property: t.property
					}) ?? !1),
					value: ve(n)(c.formData),
					onChange: (e) => {
						a.length > 0 && y(t.property), p(ye(n, e)({}));
					},
					validationErrors: l,
					options: t.options ?? []
				}
			};
		}, {}), [
			n,
			p,
			c,
			g,
			r,
			o,
			s,
			y
		]),
		queries: {
			formData: c.formData,
			isValid: _,
			isDirty: !F(c.formData, e),
			validationResults: g
		},
		mutators: {
			resetFormData: f,
			updateFormData: p
		}
	};
}, wc = (e) => e.map((e) => ({
	fieldName: e.key ?? "form",
	message: e.message,
	value: "server-error"
})), Tc = (e) => e.error.errors.reduce((e, t) => {
	let n = t.key ?? "form";
	return {
		...e,
		[n]: [...e[n] ?? [], t]
	};
}, {}), Ec = async (e) => {
	let t = "json" in e && typeof e.json == "function" ? await e.json() : e;
	return ae(t) ? Object.entries(Tc(t)).reduce((e, [t, n]) => ({
		...e,
		[t]: wc(n)
	}), {}) : {};
}, Dc = (e, t) => {
	let n = de();
	return pe(() => e || [t, n].filter(Boolean).join("-"), [
		e,
		t,
		n
	]);
}, Oc = (e) => {
	let { ref: t, handler: n, enabled: r = !0 } = e, i = jc(n), a = j({
		isPointerDown: !1,
		ignoreEmulatedMouseEvents: !1
	}).current;
	A(() => {
		if (!r) return;
		let e = (e) => {
			kc(e, t) && (a.isPointerDown = !0);
		}, o = (e) => {
			if (a.ignoreEmulatedMouseEvents) {
				a.ignoreEmulatedMouseEvents = !1;
				return;
			}
			a.isPointerDown && n && kc(e, t) && (a.isPointerDown = !1, i(e));
		}, s = (e) => {
			a.ignoreEmulatedMouseEvents = !0, n && a.isPointerDown && kc(e, t) && (a.isPointerDown = !1, i(e));
		}, c = Ac(t.current);
		return c.addEventListener("mousedown", e, !0), c.addEventListener("mouseup", o, !0), c.addEventListener("touchstart", e, !0), c.addEventListener("touchend", s, !0), () => {
			c.removeEventListener("mousedown", e, !0), c.removeEventListener("mouseup", o, !0), c.removeEventListener("touchstart", e, !0), c.removeEventListener("touchend", s, !0);
		};
	}, [
		n,
		t,
		i,
		a,
		r
	]);
}, kc = (e, t) => {
	let n = e.target;
	return n && !Ac(n).contains(n) ? !1 : !t.current?.contains(n);
}, Ac = (e) => e?.ownerDocument ?? document, jc = (e) => {
	let t = j(e);
	return A(() => {
		t.current = e;
	}), O((...e) => t.current?.(...e), []);
}, Mc = (e) => {
	let t = j();
	return A(() => {
		t.current = e;
	}, [e]), t.current;
}, Nc = () => {
	let [e, t] = M(!1);
	return A(() => {
		let e = window.matchMedia("(prefers-reduced-motion: reduce)");
		t(e.matches);
		let n = (e) => t(e.matches);
		return typeof e.addListener == "function" ? e.addListener(n) : e.addEventListener("change", n), () => {
			typeof e.removeListener == "function" ? e.removeListener(n) : e.removeEventListener("change", n);
		};
	}, []), e;
}, Pc = (e) => {
	let t = Array.isArray(e) ? e : [e], [n, r] = M(() => t.map((e) => typeof window < "u" && window.matchMedia(e).matches));
	return A(() => {
		if (typeof window > "u") return;
		let e = t.map((e) => window.matchMedia(e)), n = () => r(e.map((e) => e.matches));
		return n(), e.forEach((e) => e.addEventListener("change", n)), () => e.forEach((e) => e.removeEventListener("change", n));
	}, [t.join(",")]), n;
}, Fc = {
	UNPAID: {
		children: "Unpaid",
		sentiment: "neutral"
	},
	PARTIALLY_PAID: {
		children: "Partially paid",
		sentiment: "neutral"
	},
	PAID: {
		children: "Paid",
		sentiment: "success"
	},
	UNCOLLECTIBLE: {
		children: "Uncollectible",
		sentiment: "warning"
	}
}, Ic = ({ status: e, size: t = "md" }) => ({
	...Fc[e],
	size: t
}), Lc = Object.keys(Fc), Rc = {
	IN_PROGRESS: {
		children: "Upcoming",
		sentiment: "info"
	},
	DRAFT: {
		children: "Draft",
		sentiment: "draft"
	},
	FINAL: {
		children: "Final",
		sentiment: "info"
	},
	VOIDED: {
		children: "Void",
		sentiment: "neutral"
	},
	SENT: {
		children: "Sent",
		sentiment: "success"
	}
}, zc = Object.keys(Rc), Bc = ({ status: e, size: t = "md" }) => ({
	...Rc[e],
	size: t
}), Vc = {
	IN_PROGRESS: {
		children: "Upcoming",
		sentiment: "upcoming"
	},
	DRAFT: {
		children: "Draft",
		sentiment: "draft"
	},
	FINAL: {
		children: "Final",
		sentiment: "info"
	},
	VOIDED: {
		children: "Void",
		sentiment: "neutral"
	},
	SENT: {
		children: "Sent",
		sentiment: "success"
	}
}, Hc = Object.keys(Vc), Uc = ({ status: e, size: t = "md" }) => ({
	...Vc[e],
	size: t
}), Wc = {
	FULLY_APPLIED: {
		children: "Fully applied",
		sentiment: "success"
	},
	PARTIALLY_APPLIED: {
		children: "Partially applied",
		sentiment: "neutral"
	}
}, Gc = ({ status: e, size: t = "md" }) => ({
	...Wc[e],
	size: t
}), Kc = (e) => e !== void 0 && e in Wc, qc = ["PARTIALLY_APPLIED", "FULLY_APPLIED"], Jc = (e) => qc.includes(e), Yc = {
	AWAITING_FUNDING: {
		children: "Pending",
		sentiment: "upcoming"
	},
	ACTIVE: {
		children: "Active",
		sentiment: "info"
	},
	DEPLETED: {
		children: "Depleted",
		sentiment: "neutral"
	},
	EXPIRED: {
		children: "Expired",
		sentiment: "error"
	}
}, Xc = ({ status: e, size: t = "md" }) => ({
	...Yc[e],
	size: t
}), Zc = (e) => {
	let t = Vs(e.currency);
	return Z({
		...e,
		maximumFractionDigits: t,
		minimumFractionDigits: t
	});
}, Qc = 1, $c = ({ amount: e, currency: t }) => new P(e).round(Vs(t), Qc).toNumber(), el = (e) => e !== void 0, tl = {
	AED: "United Arab Emirates Dirham",
	ARS: "Argentinian Pesos",
	AUD: "Australian Dollars",
	BRL: "Brazilian Real",
	CAD: "Canadian Dollars",
	CHF: "Swiss Franc",
	CLP: "Chilean Peso",
	CNY: "Yuan Renminbi",
	COP: "Colombian Pesos",
	CZK: "Czech Koruna",
	DKK: "Danish Krone",
	EGP: "Egyptian Pound",
	EUR: "Euros",
	GBP: "Great British Pounds",
	HKD: "Hong Kong Dollar",
	ILS: "New Israeli Sheqel",
	INR: "Indian Rupee",
	ISK: "Icelandic Króna",
	JPY: "Yen",
	KRW: "South Korean Won",
	MXN: "Mexican Pesos",
	NOK: "Norwegian Krone",
	NZD: "New Zealand Dollar",
	PLN: "Zloty",
	SAR: "Saudi Riyal",
	SEK: "Swedish Krona",
	SGD: "Singapore Dollar",
	THB: "Baht",
	USD: "US Dollars",
	UYU: "Uruguayan Pesos",
	ZAR: "South African Rand"
}, nl = (e) => tl[e], rl = {
	AED: "AED",
	ARS: "ARS",
	AUD: "A$",
	BRL: "R$",
	CAD: "CA$",
	CHF: "CHF",
	CLP: "CLP",
	CNY: "CN¥",
	COP: "COP",
	CZK: "CZK",
	DKK: "DKK",
	EGP: "EGP",
	EUR: "€",
	GBP: "£",
	HKD: "HK$",
	ILS: "₪",
	INR: "₹",
	ISK: "ISK",
	JPY: "JP¥",
	KRW: "₩",
	MXN: "MX$",
	NOK: "NOK",
	NZD: "NZ$",
	PLN: "PLN",
	SAR: "SAR",
	SEK: "SEK",
	SGD: "SGD",
	THB: "THB",
	USD: "$",
	UYU: "UYU",
	ZAR: "ZAR"
}, il = Object.keys(rl), al = (e) => rl[e], ol = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, sl = globalThis, cl = "10.51.0";
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/carrier.js
function ll() {
	return ul(sl), sl;
}
function ul(e) {
	let t = e.__SENTRY__ = e.__SENTRY__ || {};
	return t.version = t.version || "10.51.0", t[cl] = t["10.51.0"] || {};
}
function dl(e, t, n = sl) {
	let r = n.__SENTRY__ = n.__SENTRY__ || {}, i = r[cl] = r["10.51.0"] || {};
	return i[e] || (i[e] = t());
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/debug-logger.js
var fl = "Sentry Logger ", pl = {};
function ml(e) {
	if (!("console" in sl)) return e();
	let t = sl.console, n = {}, r = Object.keys(pl);
	r.forEach((e) => {
		let r = pl[e];
		n[e] = t[e], t[e] = r;
	});
	try {
		return e();
	} finally {
		r.forEach((e) => {
			t[e] = n[e];
		});
	}
}
function hl() {
	Sl().enabled = !0;
}
function gl() {
	Sl().enabled = !1;
}
function _l() {
	return Sl().enabled;
}
function vl(...e) {
	xl("log", ...e);
}
function yl(...e) {
	xl("warn", ...e);
}
function bl(...e) {
	xl("error", ...e);
}
function xl(e, ...t) {
	ol && _l() && ml(() => {
		sl.console[e](`${fl}[${e}]:`, ...t);
	});
}
function Sl() {
	return ol ? dl("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
var Cl = {
	enable: hl,
	disable: gl,
	isEnabled: _l,
	log: vl,
	warn: yl,
	error: bl
}, wl = Object.prototype.toString;
function Tl(e, t) {
	return wl.call(e) === `[object ${t}]`;
}
function El(e) {
	return Tl(e, "Object");
}
function Dl(e) {
	return !!(e?.then && typeof e.then == "function");
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/object.js
function Ol(e, t, n) {
	try {
		Object.defineProperty(e, t, {
			value: n,
			writable: !0,
			configurable: !0
		});
	} catch {
		ol && Cl.log(`Failed to add non-enumerable property "${String(t)}" to object`, e);
	}
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/randomSafeContext.js
var kl;
function Al(e) {
	if (kl !== void 0) return kl ? kl(e) : e();
	let t = Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__"), n = sl;
	return t in n && typeof n[t] == "function" ? (kl = n[t], kl(e)) : (kl = null, e());
}
function jl() {
	return Al(() => Math.random());
}
function Ml() {
	return Al(() => Date.now());
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/string.js
function Nl(e, t = 0) {
	return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/misc.js
function Pl() {
	let e = sl;
	return e.crypto || e.msCrypto;
}
var Fl;
function Il() {
	return jl() * 16;
}
function Ll(e = Pl()) {
	try {
		if (e?.randomUUID) return Al(() => e.randomUUID()).replace(/-/g, "");
	} catch {}
	return Fl ||= "10000000100040008000100000000000", Fl.replace(/[018]/g, (e) => (e ^ (Il() & 15) >> e / 4).toString(16));
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/time.js
var Rl = 1e3;
function zl() {
	return Ml() / Rl;
}
function Bl() {
	let { performance: e } = sl;
	if (!e?.now || !e.timeOrigin) return zl;
	let t = e.timeOrigin;
	return () => (t + Al(() => e.now())) / Rl;
}
var Vl;
function Hl() {
	return (Vl ??= Bl())();
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/session.js
function Ul(e, t = {}) {
	if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Hl(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Ll()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration) e.duration = void 0;
	else if (typeof t.duration == "number") e.duration = t.duration;
	else {
		let t = e.timestamp - e.started;
		e.duration = t >= 0 ? t : 0;
	}
	t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/merge.js
function Wl(e, t, n = 2) {
	if (!t || typeof t != "object" || n <= 0) return t;
	if (e && Object.keys(t).length === 0) return e;
	let r = { ...e };
	for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && (r[e] = Wl(r[e], t[e], n - 1));
	return r;
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/propagationContext.js
function Gl() {
	return Ll();
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var Kl = "_sentrySpan";
function ql(e, t) {
	t ? Ol(e, Kl, t) : delete e[Kl];
}
function Jl(e) {
	return e[Kl];
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/scope.js
var Yl = 100, Xl = class e {
	constructor() {
		this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._attributes = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
			traceId: Gl(),
			sampleRand: jl()
		};
	}
	clone() {
		let t = new e();
		return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._attributes = { ...this._attributes }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = { values: [...this._contexts.flags.values] }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, t._conversationId = this._conversationId, ql(t, Jl(this)), t;
	}
	setClient(e) {
		this._client = e;
	}
	setLastEventId(e) {
		this._lastEventId = e;
	}
	getClient() {
		return this._client;
	}
	lastEventId() {
		return this._lastEventId;
	}
	addScopeListener(e) {
		this._scopeListeners.push(e);
	}
	addEventProcessor(e) {
		return this._eventProcessors.push(e), this;
	}
	setUser(e) {
		return this._user = e || {
			email: void 0,
			id: void 0,
			ip_address: void 0,
			username: void 0
		}, this._session && Ul(this._session, { user: e }), this._notifyScopeListeners(), this;
	}
	getUser() {
		return this._user;
	}
	setConversationId(e) {
		return this._conversationId = e || void 0, this._notifyScopeListeners(), this;
	}
	setTags(e) {
		return this._tags = {
			...this._tags,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setTag(e, t) {
		return this.setTags({ [e]: t });
	}
	setAttributes(e) {
		return this._attributes = {
			...this._attributes,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setAttribute(e, t) {
		return this.setAttributes({ [e]: t });
	}
	removeAttribute(e) {
		return e in this._attributes && (delete this._attributes[e], this._notifyScopeListeners()), this;
	}
	setExtras(e) {
		return this._extra = {
			...this._extra,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setExtra(e, t) {
		return this._extra = {
			...this._extra,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setFingerprint(e) {
		return this._fingerprint = e, this._notifyScopeListeners(), this;
	}
	setLevel(e) {
		return this._level = e, this._notifyScopeListeners(), this;
	}
	setTransactionName(e) {
		return this._transactionName = e, this._notifyScopeListeners(), this;
	}
	setContext(e, t) {
		return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
	}
	setSession(e) {
		return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
	}
	getSession() {
		return this._session;
	}
	update(t) {
		if (!t) return this;
		let n = typeof t == "function" ? t(this) : t, { tags: r, attributes: i, extra: a, user: o, contexts: s, level: c, fingerprint: l = [], propagationContext: u, conversationId: d } = (n instanceof e ? n.getScopeData() : El(n) ? t : void 0) || {};
		return this._tags = {
			...this._tags,
			...r
		}, this._attributes = {
			...this._attributes,
			...i
		}, this._extra = {
			...this._extra,
			...a
		}, this._contexts = {
			...this._contexts,
			...s
		}, o && Object.keys(o).length && (this._user = o), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), d && (this._conversationId = d), this;
	}
	clear() {
		return this._breadcrumbs = [], this._tags = {}, this._attributes = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, this._conversationId = void 0, ql(this, void 0), this._attachments = [], this.setPropagationContext({
			traceId: Gl(),
			sampleRand: jl()
		}), this._notifyScopeListeners(), this;
	}
	addBreadcrumb(e, t) {
		let n = typeof t == "number" ? t : Yl;
		if (n <= 0) return this;
		let r = {
			timestamp: zl(),
			...e,
			message: e.message ? Nl(e.message, 2048) : e.message
		};
		return this._breadcrumbs.push(r), this._breadcrumbs.length > n && (this._breadcrumbs = this._breadcrumbs.slice(-n), this._client?.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
	}
	getLastBreadcrumb() {
		return this._breadcrumbs[this._breadcrumbs.length - 1];
	}
	clearBreadcrumbs() {
		return this._breadcrumbs = [], this._notifyScopeListeners(), this;
	}
	addAttachment(e) {
		return this._attachments.push(e), this;
	}
	clearAttachments() {
		return this._attachments = [], this;
	}
	getScopeData() {
		return {
			breadcrumbs: this._breadcrumbs,
			attachments: this._attachments,
			contexts: this._contexts,
			tags: this._tags,
			attributes: this._attributes,
			extra: this._extra,
			user: this._user,
			level: this._level,
			fingerprint: this._fingerprint || [],
			eventProcessors: this._eventProcessors,
			propagationContext: this._propagationContext,
			sdkProcessingMetadata: this._sdkProcessingMetadata,
			transactionName: this._transactionName,
			span: Jl(this),
			conversationId: this._conversationId
		};
	}
	setSDKProcessingMetadata(e) {
		return this._sdkProcessingMetadata = Wl(this._sdkProcessingMetadata, e, 2), this;
	}
	setPropagationContext(e) {
		return this._propagationContext = e, this;
	}
	getPropagationContext() {
		return this._propagationContext;
	}
	captureException(e, t) {
		let n = t?.event_id || Ll();
		if (!this._client) return ol && Cl.warn("No client configured on scope - will not capture exception!"), n;
		let r = /* @__PURE__ */ Error("Sentry syntheticException");
		return this._client.captureException(e, {
			originalException: e,
			syntheticException: r,
			...t,
			event_id: n
		}, this), n;
	}
	captureMessage(e, t, n) {
		let r = n?.event_id || Ll();
		if (!this._client) return ol && Cl.warn("No client configured on scope - will not capture message!"), r;
		let i = n?.syntheticException ?? Error(e);
		return this._client.captureMessage(e, t, {
			originalException: e,
			syntheticException: i,
			...n,
			event_id: r
		}, this), r;
	}
	captureEvent(e, t) {
		let n = e.event_id || t?.event_id || Ll();
		return this._client ? (this._client.captureEvent(e, {
			...t,
			event_id: n
		}, this), n) : (ol && Cl.warn("No client configured on scope - will not capture event!"), n);
	}
	_notifyScopeListeners() {
		this._notifyingListeners ||= (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
			e(this);
		}), !1);
	}
};
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/defaultScopes.js
function Zl() {
	return dl("defaultCurrentScope", () => new Xl());
}
function Ql() {
	return dl("defaultIsolationScope", () => new Xl());
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/chain-and-copy-promiselike.js
var $l = (e) => e instanceof Promise && !e[eu], eu = Symbol("chained PromiseLike"), tu = (e, t, n) => {
	let r = e.then((e) => (t(e), e), (e) => {
		throw n(e), e;
	});
	return $l(r) && $l(e) ? r : nu(e, r);
}, nu = (e, t) => {
	let n = !1;
	for (let r in e) {
		if (r in t) continue;
		n = !0;
		let i = e[r];
		typeof i == "function" ? Object.defineProperty(t, r, {
			value: (...t) => i.apply(e, t),
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : t[r] = i;
	}
	return n && Object.assign(t, { [eu]: !0 }), t;
}, ru = class {
	constructor(e, t) {
		let n;
		n = e || new Xl();
		let r;
		r = t || new Xl(), this._stack = [{ scope: n }], this._isolationScope = r;
	}
	withScope(e) {
		let t = this._pushScope(), n;
		try {
			n = e(t);
		} catch (e) {
			throw this._popScope(), e;
		}
		return Dl(n) ? tu(n, () => this._popScope(), () => this._popScope()) : (this._popScope(), n);
	}
	getClient() {
		return this.getStackTop().client;
	}
	getScope() {
		return this.getStackTop().scope;
	}
	getIsolationScope() {
		return this._isolationScope;
	}
	getStackTop() {
		return this._stack[this._stack.length - 1];
	}
	_pushScope() {
		let e = this.getScope().clone();
		return this._stack.push({
			client: this.getClient(),
			scope: e
		}), e;
	}
	_popScope() {
		return this._stack.length <= 1 ? !1 : !!this._stack.pop();
	}
};
function iu() {
	let e = ul(ll());
	return e.stack = e.stack || new ru(Zl(), Ql());
}
function au(e) {
	return iu().withScope(e);
}
function ou(e, t) {
	let n = iu();
	return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function su(e) {
	return iu().withScope(() => e(iu().getIsolationScope()));
}
function cu() {
	return {
		withIsolationScope: su,
		withScope: au,
		withSetScope: ou,
		withSetIsolationScope: (e, t) => su(t),
		getCurrentScope: () => iu().getScope(),
		getIsolationScope: () => iu().getIsolationScope()
	};
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/asyncContext/index.js
function lu(e) {
	let t = ul(e);
	return t.acs ? t.acs : cu();
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/currentScopes.js
function uu() {
	return lu(ll()).getCurrentScope();
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/utils/prepareEvent.js
function du(e) {
	if (e) return fu(e) || mu(e) ? { captureContext: e } : e;
}
function fu(e) {
	return e instanceof Xl || typeof e == "function";
}
var pu = [
	"user",
	"level",
	"extra",
	"contexts",
	"tags",
	"fingerprint",
	"propagationContext"
];
function mu(e) {
	return Object.keys(e).some((e) => pu.includes(e));
}
//#endregion
//#region ../../node_modules/@sentry/core/build/esm/exports.js
function hu(e, t) {
	return uu().captureException(e, du(t));
}
//#endregion
//#region src/observability/logging.ts
var gu = (e, t) => {
	let n = e instanceof Error, r = n ? e : Error(_u(e));
	hu(r, { extra: n ? t : {
		...t,
		originalError: e
	} }), console.error(r.message, t);
}, _u = (e) => {
	if (typeof e == "string") return e;
	if (vu(e)) return `${e.status}: ${e.statusText}`;
	try {
		let t = JSON.stringify(e);
		if (t && t !== "{}") return t;
	} catch {}
	return String(e);
}, vu = (e) => typeof e == "object" && !!e && "status" in e && "statusText" in e, yu = (e) => /^[^\/]/.test(e);
//#endregion
//#region src/percentage/decimalFromPercentage.ts
function bu(e, t) {
	let n = P(P(e).times(100));
	return t ? n.toFixed(t).padEnd(n.toFixed(0).length + 1 + t, "0") : n.toFixed(10).replace(/\.?0+$/, "").toString();
}
function xu(e) {
	return P(P(e).div(100)).toFixed(10).toString();
}
//#endregion
//#region src/assets/assets.constants.ts
var Su = "seq-asset://", Cu = [
	"https://assets.dev.seqhq.io",
	"https://assets.sandbox.sequencehq.com",
	"https://assets.sequencehq.com",
	Su
], wu = {
	quotes: ["application/pdf"],
	billingSchedules: ["application/pdf"],
	invoices: [
		"image/jpeg",
		"image/png",
		"application/pdf",
		"text/csv",
		"text/plain",
		"application/rtf",
		"text/markdown",
		"application/vnd.ms-excel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"application/vnd.ms-excel.sheet.macroEnabled.12",
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		"application/zip",
		"application/vnd.oasis.opendocument.text",
		"application/vnd.oasis.opendocument.spreadsheet"
	]
}, Tu = ({ accountId: e, assetId: t }) => `${Su}${e}/${t}`, Eu = (e) => !Cu.some((t) => e.startsWith(t)), Du = (e) => {
	if (Eu(e)) return;
	let t = e.match(/\/([0-9a-f-]+)(?:\/.*)?\/([0-9a-f-]+)/);
	if (!t) return;
	let n = t.at(1), r = t.at(2);
	if (!(!n || !r)) return {
		accountId: n,
		assetId: r
	};
}, Ou = async ({ url: e, assetLoader: t }) => {
	if (e === "") return;
	if (Eu(e)) return e;
	let n = Du(e);
	if (!n) return;
	let r = await t(n);
	if (r) return r.urlSigned;
}, ku = ({ url: e, assetLoader: t }) => {
	let [n, r] = M();
	return A(() => {
		(async () => {
			let n = await Ou({
				url: e,
				assetLoader: t
			});
			r(n);
		})();
	}, [e]), n;
}, Au = () => {
	let e = "https://dashboard.sequencehq.com";
	xe.register({
		family: "Lato",
		fonts: [
			{
				src: `${e}/fonts/Lato-Regular.ttf`,
				fontStyle: "normal",
				fontWeight: "normal"
			},
			{
				src: `${e}/fonts/Lato-Bold.ttf`,
				fontStyle: "normal",
				fontWeight: "bold"
			},
			{
				src: `${e}/fonts/Lato-Italic.ttf`,
				fontStyle: "italic",
				fontWeight: "normal"
			},
			{
				src: `${e}/fonts/Lato-BoldItalic.ttf`,
				fontStyle: "italic",
				fontWeight: "bold"
			},
			{
				src: `${e}/fonts/Lato-SemiBold.ttf`,
				fontStyle: "normal",
				fontWeight: "semibold"
			}
		]
	});
}, ju = {
	DRAFT: {
		children: "Draft",
		sentiment: "draft"
	},
	PENDING: {
		children: "Upcoming",
		sentiment: "upcoming"
	},
	ACTIVE: {
		children: "Active",
		sentiment: "info"
	},
	SUSPENDED: {
		children: "Suspended",
		sentiment: "warning"
	},
	CANCELLED: {
		children: "Cancelled",
		sentiment: "error"
	},
	COMPLETED: {
		children: "Completed",
		sentiment: "success"
	}
}, Mu = Object.keys(ju), Nu = ({ status: e, size: t = "md" }) => ({
	...ju[e],
	size: t
}), Pu = "2100-01-01", Fu = (e) => !!e && b(/* @__PURE__ */ new Date(Pu), e), Iu = (e) => e ? Fu(e) ? "Milestone based" : n(e, "d MMM yyyy") : "Open ended", Lu = (e, t) => [...e].map((e) => e.startDate).filter(Boolean).sort().reverse().find((e) => !s(C(e), t)), Ru = (e) => (t) => {
	if (!l(t)) return;
	let n = ne(t);
	if (n < e) {
		let n = new Date(c(d(t, { months: -1 }))), r = ne(n);
		return _(y(n, { date: e < r ? e : r }));
	}
	return n === e ? t : _(y(t, { date: e }));
}, zu = (e) => ({ start: t, end: n }, r = 120) => {
	if (r <= 0) return gu(/* @__PURE__ */ Error("Max depth of billing dates reached")), [];
	let i = d(t, { months: e.intervalInMonths }), a = Ru(e.recurrenceDayOfMonth)(i);
	return a ? b(n, a) ? [a] : o(t, a) || b(a, t) ? [...zu(e)({
		start: i,
		end: n
	}, r - 1)] : [a, ...zu(e)({
		start: a,
		end: n
	}, r - 1)] : [];
}, Bu = {
	MONTHLY: [],
	QUARTERLY: [],
	HALF_YEARLY: [],
	YEARLY: [],
	ONE_TIME: [],
	ON_DEMAND: [],
	PER_EVENT: []
}, Vu = ({ recurrenceDayOfMonth: e, phaseDates: t }) => !l(t.start) || !l(t.end) ? Bu : {
	MONTHLY: zu({
		intervalInMonths: 1,
		recurrenceDayOfMonth: e
	})({
		start: t.start,
		end: t.end
	}),
	QUARTERLY: zu({
		intervalInMonths: 3,
		recurrenceDayOfMonth: e
	})({
		start: t.start,
		end: t.end
	}),
	HALF_YEARLY: zu({
		intervalInMonths: 6,
		recurrenceDayOfMonth: e
	})({
		start: t.start,
		end: t.end
	}),
	YEARLY: zu({
		intervalInMonths: 12,
		recurrenceDayOfMonth: e
	})({
		start: t.start,
		end: t.end
	}),
	ONE_TIME: [],
	ON_DEMAND: [],
	PER_EVENT: []
}, Hu = [
	"MONTHLY",
	"QUARTERLY",
	"HALF_YEARLY",
	"YEARLY"
], Uu = (e) => {
	let t = e.today ?? /* @__PURE__ */ new Date(), n = Vu({
		recurrenceDayOfMonth: e.recurrenceDayOfMonth,
		phaseDates: {
			start: e.startDate,
			end: new Date(e.endDate)
		}
	}), r = e.prices.reduce((e, t) => !e || ["ON_DEMAND", "ONE_TIME"].includes(t.billingFrequency) || Hu.findIndex((e) => e === t.billingFrequency) < Hu.findIndex((t) => t === e) ? t.billingFrequency : e, null);
	return r ? n[r].find((e) => s(e, t)) ?? null : n.MONTHLY.find((e) => s(e, t)) ?? null;
}, Wu = (e) => e.phases.reduce((t, n) => {
	if (n.recurrencePreference === "RESET") return [...t, { recurrenceDayOfMonth: ne(n.startDate) }];
	let r = t.at(-1)?.recurrenceDayOfMonth ?? e.recurrenceDayOfMonth;
	return [...t, { recurrenceDayOfMonth: r }];
}, []), Gu = ({ schedule: e, date: t }) => {
	let n = S.toApi(t), r = e.phases.filter((e) => e.startDate <= n).sort((e, t) => e.startDate.localeCompare(t.startDate)), i = r.at(-1);
	if (!(!i || i.endDate && i.endDate < n)) return r.reduce((e, t) => {
		let n = S.fromApi(t.startDate);
		return t.recurrencePreference === "RESET" && n ? ne(n) : e;
	}, e.recurrenceDayOfMonth);
}, Ku = (e) => {
	let t = /* @__PURE__ */ new Date(), n = !!(e.startDate && b(t, e.startDate)), r = e.endDate && m(e.endDate, { days: 1 });
	return {
		isFutureStartingSchedule: n,
		scheduleEndsBeforeNextBillingDate: !!(e.nextBillingDate && r && s(e.nextBillingDate, r)),
		minimumCustomDate: n && e.startDate ? d(e.startDate, { days: 1 }) : t,
		maximumCustomDate: r
	};
}, qu = (e) => {
	let t = Wu({
		recurrenceDayOfMonth: e.recurrenceDayOfMonth,
		phases: e.phases
	}), n = /* @__PURE__ */ new Date(), r = e.phases.findIndex((e) => s(n, e.startDate) && (!e.endDate || b(n, e.endDate)));
	return {
		nextBillingDate: r > -1 ? Uu({
			recurrenceDayOfMonth: t[r]?.recurrenceDayOfMonth,
			startDate: e.phases[r].startDate,
			endDate: e.endDate ? e.endDate : d(/* @__PURE__ */ new Date(), { years: 1 }),
			prices: e.prices
		}) : e.endDate && Uu({
			recurrenceDayOfMonth: e.recurrenceDayOfMonth,
			startDate: e.startDate,
			endDate: e.endDate,
			prices: e.prices
		}),
		phaseRecurrenceDates: t,
		currentPhaseStartDate: r > -1 ? e.phases[r].startDate : void 0,
		hasFuturePhases: e.phases.some((e) => s(e.startDate, n))
	};
}, Ju = ({ startDate: e, endDate: t }) => {
	if (!t) return "OPEN_ENDED";
	let n = ee.toDuration(e)(t);
	return ge(n, "Duration should be defined"), (n?.years ?? 0) >= 90 ? "MILESTONE" : n;
}, Yu = "yyyy-MM-dd", Xu = (e) => {
	if (e.phases.length === 0) throw Error("cannot split an empty set of phases");
	let t = e.phases.find((e) => Fu(e.endDate ?? ""));
	if (t) throw Error(`cannot split milestone based phase "${t.id}"`);
	let n = [...e.phases].sort((e, t) => e.startDate.localeCompare(t.startDate)), r = n.find((t) => t.startDate <= e.splitDate && (!t.endDate || e.splitDate <= t.endDate));
	if (!r) throw Error(`no phase covers the amendment date "${e.splitDate}"`);
	if (r.startDate === e.splitDate) return {
		phases: n,
		amendmentPhaseId: r.id
	};
	let i = e.createPhaseId();
	return {
		phases: n.flatMap((t) => t === r ? [{
			...t,
			endDate: Zu(e.splitDate)
		}, {
			...t,
			id: i,
			startDate: e.splitDate
		}] : [t]),
		amendmentPhaseId: i
	};
}, Zu = (e) => n(m(h(e, Yu, /* @__PURE__ */ new Date()), { days: 1 }), Yu), Qu = (e) => [e.find(({ isDefault: e }) => e), ...e.filter((e) => !e.isDefault)].filter(Boolean).map((e) => ({
	value: e.id,
	label: e.name,
	secondaryLabel: e.isDefault ? "(default)" : void 0
})), $u = {
	TAXED: "Taxable",
	TAX_EXEMPT: "Exempt",
	REVERSE_CHARGED: "Reverse charge"
}, ed = (e) => $u[e], td = Object.keys($u), nd = (e, t) => {
	let n = 10 ** (Math.max(e.toString().split(".")[1]?.length ?? 0, t.toString().split(".")[1]?.length ?? 0) + 2);
	return (e * n + t * n) / n;
}, rd = (e, t, n) => {
	let r = Math.max((e.toString().split(".")[1]?.length ?? 0) + (t.toString().split(".")[1]?.length ?? 0)), i = 10 ** r, a = e * i * (t * i) / (i * i), o = 10 ** (n ?? r);
	return Math.round(a * o) / o;
}, id = [
	"ONE_TIME",
	"FIXED",
	"SEAT_BASED",
	"GRADUATED"
], ad = [
	"LINEAR",
	"VOLUME",
	"GRADUATED",
	"PACKAGE"
], od = (e) => e ? {
	...e,
	days: e.days ?? -1
} : void 0, sd = (e) => e.map((e) => ({
	...e,
	discounts: e.discounts.map((e) => ({
		...e,
		discountCalculationType: e.type
	})),
	minimums: e.minimums.map((e) => ({
		id: "",
		...e
	})),
	duration: od(e.duration)
})), cd = (e, t) => ({
	productId: e.productId,
	fullRate: 0,
	discountedRate: 0,
	commitmentRate: 0,
	intervalMultiplier: t,
	isCommitted: !1
}), ld = (e) => w(e.billingFrequency).with("MONTHLY", () => 1).with("QUARTERLY", () => 3).with("YEARLY", () => 12).with("HALF_YEARLY", () => 6).with("ONE_TIME", () => Infinity).with("ON_DEMAND", () => Infinity).with("PER_EVENT", () => Infinity).exhaustive(), ud = ({ discount: e, priceFullRate: t, price: n, intervalMultiplier: r, currency: i }) => {
	if (!e) return t * r;
	let a = w(e.discountCalculationType).with("PERCENTAGE", () => Md({
		discount: e,
		priceFullRate: t,
		price: n,
		currency: i
	}) * r).with("NOMINAL", () => {
		let a = Math.ceil(r), o = t - Md({
			discount: e,
			priceFullRate: t,
			price: n,
			currency: i
		});
		return t * r - o * a;
	}).exhaustive();
	return Math.max(0, a);
}, dd = ({ phase: e, calculateUpfrontTotalOnly: t, currency: n }) => pd({
	phase: e,
	calculateUpfrontTotalOnly: t,
	currency: n
}), fd = ({ intervalMultiplier: e, amountForPeriod: t, currency: n }) => {
	let r = Math.floor(e), i = new P(e).minus(r).toNumber(), a = r > 0 ? new P($c({
		amount: t(1),
		currency: n
	})).times(r) : new P(0), o = i > 0 ? $c({
		amount: t(i),
		currency: n
	}) : 0;
	return a.plus(o).toNumber();
}, pd = ({ phase: e, calculateUpfrontTotalOnly: t, currency: n, billingPeriodMultiplier: r }) => {
	let i = e.discounts?.length ? yd(e.discounts) : {}, a = e.duration;
	return e.prices.map((o) => {
		let s = ld(o), c = a ? g(a, {
			months: s,
			days: -1
		}) : !1, l = r ?? (a ? Od({
			billingFrequency: o.billingFrequency,
			duration: !t || c ? a : {
				months: s,
				days: -1
			},
			startDate: e.startDate
		}) : 1), u = cd(o, l);
		if (!id.includes(o.structure.pricingType)) return u;
		let d = xd(o, n), f = xd(o), p = Sd(e, o);
		if (d === void 0 || !f || p) return u;
		let m = o.temporaryId ?? o.id, h = i[m] ?? void 0, _ = (e) => new P(d).times(e).toNumber(), v = (e) => ud({
			discount: h,
			priceFullRate: d,
			price: o,
			intervalMultiplier: e,
			currency: n
		});
		return {
			productId: o.productId,
			fullRate: n ? fd({
				intervalMultiplier: l,
				amountForPeriod: _,
				currency: n
			}) : _(l),
			discountedRate: n ? fd({
				intervalMultiplier: l,
				amountForPeriod: v,
				currency: n
			}) : v(l),
			commitmentRate: ud({
				discount: h,
				priceFullRate: f,
				price: o,
				intervalMultiplier: 1
			}),
			intervalMultiplier: l,
			isCommitted: !0
		};
	});
}, md = ({ phase: e, calculateUpfrontTotalOnly: t, currency: n }) => {
	if (!e.duration) return;
	let r = e.discounts && e.discounts.length > 0 ? yd(e.discounts) : {}, i = dd({
		phase: e,
		calculateUpfrontTotalOnly: t,
		currency: n
	}).reduce((e, t) => ({
		priceFullRate: gd(e.priceFullRate, t.fullRate),
		priceDiscountedRate: gd(e.priceDiscountedRate, t.discountedRate)
	}), {
		priceFullRate: 0,
		priceDiscountedRate: 0
	}), a = kd(e, n), o = gd(i.priceFullRate, a), s = gd(i.priceDiscountedRate, a), c = r[vd], l = t ? 1 : Od({
		billingFrequency: _d(e),
		duration: e.duration,
		startDate: e.startDate
	}), u = c ? hd({
		phase: e,
		calculateUpfrontTotalOnly: t,
		globalDiscount: c,
		preGlobalDiscountRate: s,
		intervalMultiplier: l,
		currency: n
	}) : s;
	return {
		totalFullRate: o,
		totalPreGlobalDiscountRate: s,
		totalDiscountedRate: u,
		intervalMultiplier: l,
		globalDiscountAmount: new P(s).minus(u).toNumber()
	};
}, hd = ({ phase: e, calculateUpfrontTotalOnly: t, globalDiscount: n, preGlobalDiscountRate: r, intervalMultiplier: i, currency: a }) => {
	let o = e.prices.filter((e) => Number.isFinite(ld(e))), s = new Set(o.map((e) => e.billingFrequency));
	if (t || s.size !== 1) return jd({
		globalDiscount: n,
		preGlobalDiscountRate: r,
		intervalMultiplier: i,
		currency: a
	});
	let c = {
		...e,
		prices: o
	}, l = (e) => gd(pd({
		phase: c,
		currency: a,
		billingPeriodMultiplier: e
	}).reduce((e, t) => gd(e, t.discountedRate), 0), kd(c, a, e)), u = pd({
		phase: {
			...e,
			minimums: [],
			prices: e.prices.filter((e) => e.billingFrequency === "ONE_TIME")
		},
		currency: a
	}).reduce((e, t) => gd(e, t.discountedRate), 0), d = (e, t) => jd({
		globalDiscount: n,
		preGlobalDiscountRate: gd(l(e), t ? u : 0),
		intervalMultiplier: e,
		currency: a
	}), f = Math.floor(i), p = new P(i).minus(f).toNumber(), m = f > 0 ? new P(d(1, !0)).plus(new P(d(1, !1)).times(f - 1)) : new P(0), h = p > 0 ? d(p, f === 0) : 0;
	return m.plus(h).toNumber();
}, gd = (e, t) => new P(e).plus(t).toNumber(), _d = (e) => e.prices.find((e) => Number.isFinite(ld(e)))?.billingFrequency ?? "ONE_TIME", vd = "applyToAllPrices", yd = (e) => {
	let t = e.find((e) => e.restrictToPrices.length === 0);
	return e.reduce((e, t) => ({
		...e,
		...t.restrictToPrices.reduce((e, n) => ({
			...e,
			[n]: t
		}), {})
	}), t ? { [vd]: t } : {});
}, bd = (e, { currency: t, discount: n } = {}) => {
	if (e.structure.pricingType !== "SEAT_BASED") throw Error("using getSeatBasedPrice with invalid price");
	let r = (e) => {
		if (!t) return n ? Cs({
			amount: e,
			discount: n
		}) : e;
		let r = $c({
			amount: e,
			currency: t
		});
		return n ? new P(r).minus($c({
			amount: Ss({
				amount: e,
				discount: n
			}),
			currency: t
		})).toNumber() : r;
	};
	if (!e.structure.tiers?.length) return r(xs(e) * e.structure.contractedMinimumSeats);
	let { contractedMinimumSeats: i, tiers: a } = e.structure;
	return a.reduce((e, t, n) => {
		if (i === 0) return n === 0 && t.fee ? gd(e, r(Number(t.fee))) : e;
		let o = n === 0 ? 1 : Number(a[n - 1].upperBound) + 1, s = t.upperBound ? Number(t.upperBound) : Infinity, c = Array.from({ length: i }).reduce((e, t, n) => {
			let r = n + 1;
			return r >= o && r <= s ? e + 1 : e;
		}, 0), l = Number(t.price), u = r(c * l), d = c > 0 && t.fee ? r(Number(t.fee)) : 0;
		return gd(gd(e, u), d);
	}, 0);
}, xd = (e, t) => {
	if (e.structure.pricingType === "SEAT_BASED") return bd(e, { currency: t });
	if (e.structure.pricingType === "FIXED" || e.structure.pricingType === "ONE_TIME" || e.structure.pricingType === "GRADUATED") return xs(e);
}, Sd = (e, t) => {
	let n = e.minimums.at(0);
	return t.structure.pricingType !== "GRADUATED" || !n ? !1 : n.restrictToPrices.length === 0 || n.restrictToPrices.some((t) => e.prices.find((e) => (e.temporaryId ?? e.id) === t)?.structure.pricingType === "GRADUATED");
}, Cd = ({ startDate: e, duration: n }) => {
	if (!n || n.days === void 0 || n.days < 0) return 0;
	let i = n.days + 1, a = e ? c(e) : null, o = e ? t(e) : 30, s = e ? t(d(e, n)) : 30, l = e && a ? (r({
		start: e,
		end: a
	}).days ?? 0) + 1 : 30, u = Math.min(l, i), f = Math.max(i - l, 0);
	return Math.min(Math.min(1, u / o) + Math.min(1, f / s), 1);
}, wd = (e, t) => {
	let n = (f(t) - f(e)) * 12 + i(t) - i(e), r = s(d(e, { months: n }), t);
	return Math.max(r ? n - 1 : n, 0);
}, Td = (e, t) => {
	let n = wd(e, t), r = d(e, { months: n });
	return n + Cd({
		startDate: r,
		duration: { days: te(t, r) - 1 }
	});
}, Ed = (e, t) => {
	let n = Math.floor(wd(e, t) / 12), r = d(e, { years: n });
	return n + te(t, r) / p(r);
}, Dd = (e) => (e?.years ?? 0) * 12 + (e?.months ?? 0) + Cd({ duration: { days: e?.days } }), Od = (e) => {
	let t = e.startDate ?? _(/* @__PURE__ */ new Date()), n = od(e.duration), r = n ? d(d(t, n), { days: 1 }) : t, i = e.startDate ? Td(t, r) : Dd(n), a = Ed(t, r);
	return w(e.billingFrequency).with("MONTHLY", () => i).with("QUARTERLY", () => i / 3).with("YEARLY", () => a).with("HALF_YEARLY", () => i / 6).with("ONE_TIME", () => 1).with("ON_DEMAND", () => 0).with("PER_EVENT", () => 0).exhaustive();
}, kd = (e, t, n) => {
	let r = e.minimums.at(0);
	if (!r) return 0;
	let i = Ad({
		minimum: r,
		minimumsSupportedPrices: e.prices.filter((e) => ad.includes(e.structure.pricingType))
	});
	return i ? fd({
		intervalMultiplier: n ?? Od({
			billingFrequency: i,
			duration: e.duration,
			startDate: e.startDate
		}),
		amountForPeriod: (e) => new P(r.amount).times(e).toNumber(),
		currency: t
	}) : 0;
}, Ad = ({ minimum: e, minimumsSupportedPrices: t }) => e.restrictToPrices.length === 0 ? t.at(0)?.billingFrequency : t.find((t) => e.restrictToPrices.includes(t.temporaryId ?? t.id ?? ""))?.billingFrequency, jd = ({ globalDiscount: e, preGlobalDiscountRate: t, intervalMultiplier: n, currency: r }) => {
	let i = Ss({
		amount: t,
		discount: {
			...e,
			amount: w(e.discountCalculationType).with("PERCENTAGE", () => e.amount).with("NOMINAL", () => new P(e.amount).times(Math.ceil(n)).toString()).exhaustive()
		}
	}), a = new P(t).minus($c({
		amount: i,
		currency: r
	})).toNumber();
	return Math.max(0, a);
}, Md = ({ discount: e, priceFullRate: t, price: n, currency: r }) => e ? n.structure.pricingType === "SEAT_BASED" ? bd(n, {
	currency: r,
	discount: e
}) : Cs({
	amount: t,
	discount: e
}) : t, Nd = (e) => {
	let t = e[vd];
	if (t) return w(t.discountCalculationType).with("PERCENTAGE", () => t).with("NOMINAL", () => void 0).exhaustive();
}, Pd = (e) => {
	let t = Nd(e.discounts?.length ? yd(e.discounts) : {});
	return pd({ phase: e }).map((n, r) => {
		if (!n.isCommitted) return {
			amount: 0,
			fullAmount: 0,
			isCommitted: !1
		};
		let i = e.prices.at(r);
		return {
			amount: t ? Math.max(0, Cs({
				amount: n.commitmentRate,
				discount: t
			})) : n.commitmentRate,
			fullAmount: i ? xd(i) ?? 0 : 0,
			...t ? { preGlobalDiscountAmount: n.commitmentRate } : {},
			isCommitted: !0
		};
	});
}, Fd = ({ startDate: e, phases: t }) => e ? t.reduce((t, n, r) => {
	let i = r === 0, a = t.at(-1);
	if (!i && !a?.endDate || !n.duration) return [...t, n];
	let o = i ? e : d(a?.endDate, { days: 1 }), s = d(o, n.duration);
	return [...t, {
		...n,
		startDate: o,
		endDate: s
	}];
}, []) : t, Id = ({ startDate: e, phases: t, currency: n }) => Fd({
	startDate: e,
	phases: t
}).reduce((e, t) => {
	let r = md({
		phase: t,
		currency: n
	});
	return r ? {
		totalFullRate: gd(e.totalFullRate, r.totalFullRate),
		totalDiscountedRate: gd(e.totalDiscountedRate, r.totalDiscountedRate)
	} : e;
}, {
	totalFullRate: 0,
	totalDiscountedRate: 0
}), Ld = ({ startDate: e, phases: t, currency: n }) => Fd({
	startDate: e,
	phases: t
}).map((e) => md({
	phase: e,
	currency: n
})), Rd = ({ startDate: e, phases: t, currency: n }) => Fd({
	startDate: e,
	phases: t
}).map((e) => kd(e, n)), zd = ({ startDate: e, phases: t }) => Fd({
	startDate: e,
	phases: t
}).map((e) => {
	let t = Pd(e);
	return e.prices.reduce((e, n, r) => {
		let i = t.at(r);
		return !n.productId || !i ? e : {
			...e,
			[n.productId]: i
		};
	}, {});
}), Bd = ({ startDate: e, phases: t, currency: n }) => Fd({
	startDate: e,
	phases: t
}).map((e) => {
	let t = dd({
		phase: e,
		currency: n
	});
	return e.prices.reduce((e, n, r) => {
		let i = t.at(r), a = n.temporaryId ?? n.id;
		return !a || !i ? e : {
			...e,
			[a]: i
		};
	}, {});
}), Vd = ({ startDate: e, phases: t, currency: n }) => {
	let r = (e ? Fd({
		phases: t,
		startDate: e
	}) : t).at(0);
	return r ? md({
		phase: {
			...r,
			prices: r.prices.filter(Hd)
		},
		calculateUpfrontTotalOnly: !0,
		currency: n
	})?.totalDiscountedRate ?? 0 : 0;
}, Hd = (e) => w(e).with({
	billingType: "IN_ADVANCE",
	structure: { pricingType: re.union("FIXED", "ONE_TIME", "SEAT_BASED") }
}, () => !0).otherwise(() => !1), Ud = ({ startDate: e, phases: t }) => {
	let n = e ?? /* @__PURE__ */ new Date(), r = t.reduce((e, t, r) => {
		let i = r > 0 ? e[r - 1] : void 0, a = r === 0 ? n : i && d(i, { days: 1 });
		return [...e, a && t.duration ? d(a, t.duration) : void 0];
	}, []).at(-1);
	if (r) return ee.toDuration(n)(r);
}, Wd = ({ startDate: e, phases: t, currency: n }) => {
	let { totalDiscountedRate: r, totalFullRate: i } = Id({
		startDate: e,
		phases: sd(t),
		currency: n
	}), a = Ud({
		startDate: e,
		phases: t.map((e) => ({ duration: od(e.duration) }))
	});
	return {
		totalContractValue: r,
		totalDiscountValue: new P(i).minus(r).toNumber(),
		totalDuration: a ? {
			years: a.years ?? 0,
			months: a.months ?? 0,
			days: (a.days ?? 0) + 1
		} : void 0
	};
}, Gd = (e) => e ? x(e.days === -1 ? {
	years: e.years,
	months: e.months
} : e, {
	format: [
		"years",
		"months",
		"days"
	],
	fallback: "—"
}) : "Open ended", Kd = (e) => e === "OPEN_ENDED" || !e, qd = {
	DRAFT: {
		children: "Draft",
		sentiment: "draft"
	},
	PUBLISHED: {
		children: "Published",
		sentiment: "info"
	},
	PREPARING_SIGNATURE_REQUEST: {
		children: "Published",
		sentiment: "info"
	},
	READY_TO_SIGN: {
		children: "Published",
		sentiment: "info"
	},
	ACCEPTED: {
		children: "Ready for billing",
		sentiment: "highlight"
	},
	EXECUTED: {
		children: "Executed",
		sentiment: "success"
	},
	EXPIRED: {
		children: "Expired",
		sentiment: "error"
	},
	WAITING_FOR_REVIEW: {
		children: "Needs review",
		sentiment: "highlight"
	}
}, Jd = ({ status: e, isPublished: t, isExpired: n, hasApprovalWorkflow: r, size: i = "md" }) => ({
	...qd[w({
		hasApprovalWorkflow: r,
		isExpired: n,
		isPublished: t,
		status: e
	}).when(({ hasApprovalWorkflow: e }) => e, () => "WAITING_FOR_REVIEW").when(({ isExpired: e }) => e, () => "EXPIRED").when(({ isPublished: e, status: t }) => e && t === "DRAFT", () => "PUBLISHED").otherwise(({ status: e }) => e)],
	size: i
}), Yd = Ce([
	"productId",
	"name",
	"currency",
	"structure",
	"billingFrequency",
	"billingType",
	"integrationIds",
	"customMetricParameters"
]), Xd = (e) => {
	let t = e.phase.prices.map((e) => e.id), n = e.phase.prices.find((t) => t.id === e.existingPriceId);
	if (!n) return { phaseUpdate: { priceIds: [...t, e.newPriceId] } };
	let r = e.phase.discounts.find((e) => e.priceIds.includes(n.id)), i = e.phase.minimums.find((e) => e.scope.priceIds.includes(n.id));
	return {
		phaseUpdate: { priceIds: [...t.filter((e) => e !== n.id), e.newPriceId] },
		minimumUpdate: i ? {
			...i,
			scope: {
				...i.scope,
				priceIds: [...i.scope.priceIds.filter((e) => e !== n.id), e.newPriceId]
			}
		} : void 0,
		discountUpdate: r ? {
			...r,
			priceIds: [...r.priceIds.filter((e) => e !== n.id), e.newPriceId]
		} : void 0
	};
}, Zd = (e) => {
	let t = e.phases.findIndex((t) => t.id === e.phaseId), n = e.phases[t], r = e.originalPriceId ? n.prices.find((t) => t.id === e.originalPriceId) : n.prices.find((t) => t.productId === e.newPrice.productId);
	ge(n, "Phase not found");
	let i = e.phases.slice(t + 1), a = i.findIndex((t, n) => {
		let a = e.originalPriceId ? t.prices.filter((e) => e.productId === r?.productId) : t.prices.filter((t) => t.productId === e.newPrice.productId), o = n ? i[n - 1].prices.some((t) => t.productId === e.newPrice.productId) : !!r, s = a?.find((e) => F(Yd(e), Yd(r)));
		return !!(o && !a?.length || a?.length && !s);
	});
	return [n, ...a === -1 ? i : i.slice(0, a)].map((t) => {
		let n = (e.originalPriceId ? t.prices.filter((e) => e.productId === r?.productId) : t.prices.filter((t) => t.productId === e.newPrice.productId))?.find((e) => F(Yd(e), Yd(r)));
		return {
			phaseId: t.id,
			...Xd({
				existingPriceId: n?.id,
				newPriceId: e.newPrice.id,
				productId: e.newPrice.productId,
				phase: t
			})
		};
	}).reduce((e, t) => ({
		updatedPhases: {
			...e.updatedPhases,
			[t.phaseId]: t.phaseUpdate
		},
		updatedDiscounts: {
			...e.updatedDiscounts,
			...t.discountUpdate ? { [t.discountUpdate.id]: t.discountUpdate } : {}
		},
		updatedMinimums: {
			...e.updatedMinimums,
			...t.minimumUpdate ? { [t.minimumUpdate.id]: t.minimumUpdate } : {}
		}
	}), {
		updatedPhases: {},
		updatedDiscounts: {},
		updatedMinimums: {}
	});
}, Qd = (e) => ({
	value: e.minimum.value,
	name: e.minimum.name,
	scope: {
		target: e.minimum.scope.target,
		productIds: we("productId")(e.minimum.scope.priceIds.map((t) => {
			let n = e.phase.prices.find((e) => e.id === t);
			return {
				productId: n?.productId,
				billingFrequency: n?.billingFrequency,
				billingType: n?.billingType,
				pricingType: n?.structure.pricingType
			};
		}))
	}
}), $d = (e) => e.newMinimum.scope.priceIds.map((t) => e.targetPhase.prices.find((e) => e.id === t)).filter((e) => !!e).map((t) => e.phase.prices.find((e) => e.productId === t.productId)).filter((e) => !!e).map((e) => e.id), ef = (e) => {
	let t = e.phases.findIndex((t) => t.id === e.phaseId), n = e.phases[t], r = n.minimums[0];
	ge(n, "Phase not found");
	let i = e.phases.slice(t + 1), a = i.findIndex((t, i) => {
		let a = t.minimums[0], o = !!(a && r && F(Qd({
			minimum: a,
			phase: t
		}), Qd({
			minimum: r,
			phase: n
		})));
		return !!((e.phases[i - 1]?.minimums.length > 0 || i === 0 && n.minimums.length > 0) && !a || a && !o);
	});
	return [n, ...a === -1 ? i : i.slice(0, a)].reduce((t, r, i) => {
		let a = i === 0 ? e.newMinimum : {
			...e.newMinimum,
			id: r.minimums[0] ? r.minimums[0]?.id : crypto.randomUUID(),
			scope: {
				...e.newMinimum.scope,
				priceIds: $d({
					targetPhase: n,
					phase: r,
					newMinimum: e.newMinimum
				})
			}
		};
		return {
			updatedMinimums: {
				...t.updatedMinimums,
				[a.id]: a
			},
			updatedPhases: {
				...t.updatedPhases,
				...r.minimums[0]?.id === a.id ? {} : { [r.id]: { minimumIds: [a.id] } }
			}
		};
	}, {});
}, tf = (e) => ({
	discountCalculationType: e.discount.discountCalculationType,
	amount: e.discount.amount,
	seatDiscountType: e.discount.seatDiscountType,
	message: e.discount.message,
	productIds: we("productId")(e.discount.priceIds.map((t) => ({ productId: e.phase.prices.find((e) => e.id === t)?.productId })))
}), nf = (e) => e.newDiscount.priceIds.map((t) => e.targetPhase.prices.find((e) => e.id === t)).filter((e) => !!e).map((t) => e.phase.prices.find((e) => e.productId === t.productId)).filter((e) => !!e).map((e) => e.id), rf = (e) => (t) => {
	let n = e.originalDiscountInTargetPhase ? t.discounts.find((n) => F(Se(["value", "amount"])(tf({
		discount: n,
		phase: t
	})), Se(["value", "amount"])(e.comparableOriginalDiscount))) : null, r = n && e.originalDiscountInTargetPhase && F(tf({
		discount: n,
		phase: t
	}), e.comparableOriginalDiscount), i = t.discounts.filter((e) => e.id !== n?.id), a = t.prices.filter((t) => !i.length || i.every((n) => {
		let r = n.priceIds.length === 0, i = e.allowStackedDiscounts && r, a = !r && !n.priceIds.includes(t.id);
		return i || a;
	})), o = i.some((e) => !e.priceIds.length), s = e.isNewDiscountAnUpdate || a.length === t.prices.length, c = e.allowStackedDiscounts ? !o : s;
	return !!(!(e.isNewDiscountAGlobalDiscount ? c : e.newDiscountProducts.every((e) => a.find((t) => t.productId === e))) || e.isNewDiscountAnUpdate && !n || n && !r);
}, af = (e) => {
	let t = e.allowStackedDiscounts ?? !1, n = e.phases.findIndex((t) => t.id === e.phaseId), r = e.phases[n], i = r.discounts.find((t) => t.id === e.newDiscount.id) ?? null;
	ge(r, "Phase not found");
	let a = e.phases.slice(n + 1), o = e.newDiscount.priceIds.map((e) => r.prices.find((t) => t.id === e)).map((e) => e?.productId).filter((e) => !!e), s = i ? tf({
		discount: i,
		phase: r
	}) : null, c = !o.length, l = !!i, u = a.findIndex(rf({
		originalDiscountInTargetPhase: i,
		isNewDiscountAGlobalDiscount: c,
		isNewDiscountAnUpdate: l,
		newDiscountProducts: o,
		comparableOriginalDiscount: s,
		phases: e.phases,
		allowStackedDiscounts: t
	}));
	return [r, ...u === -1 ? a : a.slice(0, u)].reduce((n, i, a) => {
		let o = s ? i.discounts.find((e) => F(Se(["value", "amount"])(tf({
			discount: e,
			phase: i
		})), Se(["value", "amount"])(s))) : null, l = a === 0 ? e.newDiscount : {
			...e.newDiscount,
			id: o ? o.id : crypto.randomUUID(),
			priceIds: c ? [] : nf({
				targetPhase: r,
				phase: i,
				newDiscount: e.newDiscount
			})
		}, u = i.discounts.map((e) => e.id), d = !t && l.priceIds.length === 0 ? [l.id] : [...i.discounts.filter((e) => !o || e.id !== o?.id).map((e) => e.id), l.id];
		return {
			updatedDiscounts: {
				...n.updatedDiscounts,
				[l.id]: l
			},
			updatedPhases: {
				...n.updatedPhases,
				...F(u, d) ? {} : { [i.id]: { discountIds: d } }
			}
		};
	}, {});
}, of = (e, t) => !e.dates.absolute.start || !t.dates.absolute.start ? 0 : s(e.dates.absolute.start, t.dates.absolute.start) ? -1 : 1, sf = (e) => {
	let t = [...e.phases].sort(of), n = t.findIndex((t) => t.id === e.phaseId);
	if (!t[n]) return;
	let r = t.slice(n).find((e) => e.recurrencePreference === "RESET");
	if (r) return r.dates.absolute.start && i(r.dates.absolute.start);
	let a = t[t.length - 1].dates.absolute.start;
	return a && i(a);
}, cf = (e) => {
	if (!(e.phaseDuration === "OPEN_ENDED" || e.phaseDuration === "MILESTONE")) return d(e.startDate, e.phaseDuration);
}, lf = (e) => e.phases.reduce((t, n, r) => {
	let i = t.at(-1), a = (i?.endDate ? d(i.endDate, { days: 1 }) : void 0) ?? e.startDate;
	return ge(a, `invalid start date for phase ${r}`), [...t, {
		...n,
		startDate: a,
		endDate: cf({
			startDate: a,
			phaseDuration: n.duration
		})
	}];
}, []), uf = (e) => new Promise((t) => setTimeout(t, e)), df = (...e) => {
	if (localStorage.getItem("enable-sequence-logs") === "true") return console.info(...e);
}, ff = {
	DRAFT: {
		children: "Draft",
		sentiment: "draft"
	},
	ACTIVE: {
		children: "Active",
		sentiment: "info"
	},
	ARCHIVED: {
		children: "Archived",
		sentiment: "error"
	}
}, pf = [
	"ACTIVE",
	"ARCHIVED",
	"DRAFT"
], mf = ({ status: e, size: t = "md" }) => ({
	...ff[e],
	size: t
}), hf = (e) => !e || !Array.isArray(e) && typeof e != "object" ? e : Array.isArray(e) ? e.filter((e) => ![void 0, null].includes(e)).map(hf) : Object.entries(e).reduce((e, [t, n]) => [void 0, null].includes(n) ? e : {
	...e,
	[t]: hf(n)
}, {}), gf = (e, t) => F(hf(e), hf(t)), _f = (e) => {
	if (!yf(e)) return typeof e == "string" ? vf(e) ?? e : Array.isArray(e) ? e.map(_f) : typeof e == "object" ? Object.entries(e).reduce((e, [t, n]) => yf(n) ? e : {
		...e,
		[t]: _f(n)
	}, {}) : e;
}, vf = (e) => {
	try {
		return new P(e.trim()).toString();
	} catch {
		return;
	}
}, yf = (e) => e == null || e === "", bf = (e, t) => {
	let n = new Set(e);
	return n.has(t) ? n.delete(t) : n.add(t), n;
}, xf = {
	organization_id: "org-local-dev",
	member_id: "member-local-dev"
}, Sf = "local-dev-sso-token", Cf = "local-dev-oauth-discovery-token";
function wf({ ssoTestConnectionId: e } = {}) {
	let t = {
		member_id: xf.member_id,
		organization_id: xf.organization_id,
		email_address: "local-dev@sequence.local",
		name: "Local Dev User",
		status: "active",
		trusted_metadata: { sequenceUserId: "f1b3ce84-53ea-41fb-a1dc-b5215dec787e" },
		roles: [{ role_id: "admin" }]
	}, n = {
		organization_id: xf.organization_id,
		member_id: xf.member_id,
		session_id: "session-local-dev",
		started_at: (/* @__PURE__ */ new Date()).toISOString(),
		last_accessed_at: (/* @__PURE__ */ new Date()).toISOString(),
		expires_at: new Date(Date.now() + 864e5).toISOString()
	}, r = {
		organization_id: xf.organization_id,
		organization_name: "Local"
	}, i = (e) => ({
		fromCache: !1,
		...e
	}), a = () => () => {};
	return {
		onStateChange: a,
		self: {
			getSync: () => t,
			getInfo: () => i({ member: t }),
			onChange: a
		},
		session: {
			getSync: () => n,
			getInfo: () => i({ session: n }),
			onChange: a,
			authenticate: () => Promise.resolve({
				member: t,
				member_session: n,
				organization: r,
				session_jwt: "local-dev-jwt",
				session_token: "local-dev-token",
				status_code: 200
			}),
			revoke: () => Promise.resolve()
		},
		organization: {
			members: {
				search: () => Promise.resolve({ members: [t] }),
				get: () => Promise.resolve({ member: t }),
				update: () => Promise.resolve(),
				delete: () => Promise.resolve()
			},
			getSync: () => r,
			getInfo: () => i({ organization: r }),
			onChange: a
		},
		magicLinks: { email: { discovery: { send: () => Promise.resolve() } } },
		sso: {
			start: ({ login_redirect_url: e }) => (window.location.assign(`${e}?stytch_token_type=sso&token=${Sf}`), Promise.resolve()),
			authenticate: () => Promise.resolve({
				member: t,
				member_session: n,
				organization: r,
				session_jwt: "local-dev-jwt",
				session_token: "local-dev-token",
				status_code: 200
			}),
			discoverConnections: () => Promise.resolve({ connections: e ? [{
				connection_id: e,
				display_name: "Local IdP",
				identity_provider: "okta"
			}] : [] })
		},
		oauth: {
			google: { discovery: { start: ({ discovery_redirect_url: e }) => (window.location.assign(`${e}?stytch_token_type=discovery_oauth&token=${Cf}`), Promise.resolve()) } },
			discovery: { authenticate: () => Promise.resolve({
				intermediate_session_token: "local-dev-intermediate-session-token",
				email_address: t.email_address,
				discovered_organizations: [{
					organization: r,
					membership: { type: "active_member" },
					primary_required: null
				}]
			}) }
		},
		discovery: {
			organizations: { list: () => Promise.resolve({ discovered_organizations: [{ organization: {
				organization_id: xf.organization_id,
				organization_name: "Local"
			} }] }) },
			intermediateSessions: { exchange: () => Promise.resolve() }
		},
		rbac: {
			isAuthorizedSync: () => !0,
			isAuthorized: () => Promise.resolve(!0),
			allPermissions: () => Promise.resolve({})
		},
		idp: {
			oauthAuthorizeStart: ({ scopes: e = [] } = {}) => Promise.resolve({
				client: {
					client_id: "client-local-dev",
					client_type: "first_party",
					client_name: "Local Dev App",
					client_description: "A connected app running against local dev.",
					client_logo_url: ""
				},
				consent_required: !0,
				scope_results: e.map((t, n) => ({
					scope: t,
					description: `Access your ${t} data`,
					is_grantable: e.length <= 1 || n < e.length - 1
				})),
				request_id: "request-local-dev",
				status_code: 200
			}),
			oauthAuthorizeSubmit: ({ redirect_uri: e, consent_granted: t }) => Promise.resolve({
				redirect_uri: `${e}?${t ? "code=local-dev-code" : "error=access_denied"}`,
				authorization_code: t ? "local-dev-code" : ""
			})
		},
		member: { getSync: () => t },
		user: { getSync: () => t }
	};
}
//#endregion
//#region src/countries/countries.ts
var Tf = ["US", "CA"], Ef = (e) => Tf.includes(e), Df = (e) => Ef(e) ? "Zip code" : "Postcode";
//#endregion
export { Ve as ALL_BILLING_FREQUENCIES, We as ALL_BILLING_TYPES, wu as ASSET_ACCEPTED_MIME_TYPES, $ as PRICING_MODEL_LABELS, rc as PRICING_MODEL_OPTIONS, Mu as allBillingScheduleStatuses, Hc as allCreditNoteStatuses, il as allCurrencies, Lc as allInvoicePaymentStatuses, zc as allInvoiceStatuses, pf as allProductStatuses, td as allTaxStatuses, sd as apiPhaseToCalculatePhaseTotalAmountPhase, af as applyNewDiscountToPhases, ef as applyNewMinimumToPhases, Zd as applyNewPriceToPhases, Fe as arrayToIdKeyedObject, lf as calculateAbsoluteDatesForPhases, Es as calculateDiscountedPrice, Vd as calculateDueOnStartDate, Od as calculateIntervalMultiplier, Bd as calculatePriceTotalsForPhases, Wd as calculateQuoteMetadata, Rd as calculateQuotePhaseMinimumTotals, Ld as calculateQuotePhaseSubTotals, zd as calculateQuotePriceCommitments, Id as calculateQuoteTotals, dc as conditional, Tu as constructAssetPath, Xe as convertBlobToBase64, Ef as countryUsesZipCode, wf as createLocalStytchStub, tl as currencyToName, Ot as dateTimeWithFormat, xu as decimalFromPercentage, uf as delay, df as developerLog, Ge as downloadBlob, X as enforceMinimumPrecision, xc as evaluateValidators, Ke as filenameFromResponse, _t as fixMenuPosition, tc as flatFeeLabel, nd as floatSafeAdd, rd as floatSafeMultiply, xt as formatAddress, Gd as formatContractLength, zt as formatCurrencyInput, It as formatDecimal, Rt as formatDecimalPlaces, Lt as formatFileSizeToHumanReadable, At as formatISODate, Ft as formatInteger, wt as formatOrdinal, Nt as formatRangeDate, Iu as formatScheduleEndDate, Dt as formatSortCode, Mt as futureRelativeToDate, Fd as getAbsolutePhaseDates, Lu as getActivePhaseStart, rt as getAuthConfig, lt as getAuthWebConfig, Vu as getBillingDates, Ss as getDiscountAmount, Zs as getHighestPrecision, sf as getMonthBillingStartedForAnnualFreq, Uu as getNextBillingDateForSchedule, tt as getNodeSentryConfig, dt as getNotificationEmailAddress, Qu as getOptionsFromTaxCategories, ut as getPortalDomain, bt as getPositionRelativeToPositionedParent, Df as getPostcodeLabel, ic as getPricingModelLabel, et as getReactSentryConfig, Wu as getRecurrenceDateForPhases, Gu as getScheduleBillingDayOn, Ku as getScheduleChangeDateBounds, qu as getScheduleDates, st as getSdkConfig, Ou as getSignedAssetUrl, Ud as getTotalPricingDuration, at as getUserInfoConfig, Jc as hasCreditNoteBeenApplied, ec as hasNonZeroFlatFee, fc as iban, oc as isAUsageBasedPrice, Kc as isDisplayableCreditNoteApplicationStatus, Eu as isExternalAssetUrl, yu as isExternalLink, Fu as isMilestoneScheduleEndDate, Kd as isOpenEndedPhaseDuration, ac as isPriceUsageBased, gc as isSelected, el as isValidCurrencyString, ft as joinCsv, xf as localAuthMockSession, kt as localDateWithFormat, gu as logError, Ec as mapApiResponseToFieldValidationErrors, $s as moneyRangeLabel, lc as noWrap, _f as normaliseAmounts, cc as notInUse, uc as nth, gf as objectsAreEqualIgnoreUndefined, Ju as parseBillingSchedulePhaseDuration, Du as parseInternalAssetUrl, jt as pastRelativeToDate, bu as percentageFromDecimal, sc as plain, mc as previewValues, Is as priceModelAdapter, zs as priceStructureToUrlChunk, Au as registerReactPdfFonts, Pt as relativeTimeToNow, Ys as requiresSeatMetric, Xs as requiresUsageMetric, $c as roundToCurrencyScale, Gs as sanitizePercentageTiers, Ks as sanitizeTiers, Js as sanitizeTiersAndAddLowerBounds, nc as seatMinimumLabel, pt as splitCsv, Xu as splitSchedulePhasesAtDate, _u as stringifyErrorValue, Qs as tierRangeLabel, Et as toBankAccountTypeDescription, Le as toBillingFrequencyLabel, Re as toBillingFrequencyName, ze as toBillingFrequencyPluralName, Nu as toBillingScheduleStatusBadgeProps, Ue as toBillingType, Xc as toCreditGrantStatusBadgeProps, Gc as toCreditNoteApplicationStatusBadgeProps, Uc as toCreditNoteStatusBadgeProps, nl as toCurrencyName, Vs as toCurrencyScale, al as toCurrencySymbol, Ws as toDiscountAmount, Ic as toInvoicePaymentStatusBadgeProps, Bc as toInvoiceStatusBadgeProps, Z as toMoney, pc as toPercentage, Ls as toPriceSummary, mf as toProductStatusBadgeProps, Jd as toQuoteStatusBadgeProps, Zc as toScaledMoney, Us as toScaledRate, ed as toTaxStatusLabel, hc as toTitleCase, bf as toggleInSet, yt as unfixMenuPosition, _c as useDisclosure, Cc as useForm, ku as useGetSignedAssetUrl, Dc as useId, Pc as useMediaQuery, Oc as useOutsideClick, Nc as usePrefersReducedMotion, Mc as usePrevious };

//# sourceMappingURL=index.js.map